// import React from "react";

// import {
//   useState,
//   useEffect,
//   useRef,
//   useCallback,
//   memo,
//   forwardRef,
//   useImperativeHandle,
// } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Button,
//   Alert,
//   ListGroup,
//   Badge,
//   Spinner,
//   Offcanvas,
//   ProgressBar,
//   Modal,
// } from "react-bootstrap";
// import {
//   BsPlusCircle,
//   BsChevronUp,
//   BsChevronDown,
//   BsCheck2Circle,
//   BsArrowLeft,
//   BsArrowRight,
//   BsCheckCircleFill,
//   BsBookmark,
//   BsBookmarkFill,
//   BsPlayFill,
//   BsPauseFill,
//   BsFullscreen,
//   BsVolumeUp,
//   BsVolumeMute,
//   BsSkipForward,
//   BsSkipBackward,
//   BsArrowRepeat,
//   BsLockFill,
//   BsDownload,
//   BsEye,
//   BsImage,
// } from "react-icons/bs";
// import { motion, AnimatePresence } from "framer-motion";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import Lottie from "react-lottie";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// // Safe Render Component to prevent object rendering errors
// const SafeRender = ({ children, fallback = null }) => {
//   try {
//     if (children == null) {
//       return fallback;
//     }

//     if (typeof children === 'object' && !React.isValidElement(children)) {
//       console.warn('Attempted to render object:', children);
//       return fallback || <span>[Content]</span>;
//     }

//     return children;
//   } catch (error) {
//     console.error('Rendering error:', error);
//     return fallback || <span>Error rendering content</span>;
//   }
// };

// // IMPORTANT: Replace these with actual imported Lottie JSON data or set to null
// const defaultLoadingAnimationData = null;
// const defaultSuccessAnimationData = null;
// const defaultConfettiAnimationData = null;

// // Lottie animation options - only create if animation data exists
// const defaultOptions = defaultLoadingAnimationData ? {
//   loop: true,
//   autoplay: true,
//   animationData: defaultLoadingAnimationData,
//   rendererSettings: {
//     preserveAspectRatio: "xMidYMid slice",
//   },
// } : null;

// const successOptions = defaultSuccessAnimationData ? {
//   loop: false,
//   autoplay: true,
//   animationData: defaultSuccessAnimationData,
//   rendererSettings: {
//     preserveAspectRatio: "xMidYMid slice",
//   },
// } : null;

// const confettiOptions = defaultConfettiAnimationData ? {
//   loop: false,
//   autoplay: true,
//   animationData: defaultConfettiAnimationData,
//   rendererSettings: {
//     preserveAspectRatio: "xMidYMid slice",
//   },
// } : null;

// // Certificate Modal Component
// const CertificateModal = memo(({
//   show,
//   onHide,
//   certificateData,
//   course,
//   userName = "Student",
//   certificateImageUrl
// }) => {
//   const certificateRef = useRef(null);
//   const [downloading, setDownloading] = useState(false);
//   const [imageLoading, setImageLoading] = useState(true);
//   const [imageError, setImageError] = useState(false);

//   const downloadCertificate = async (format = 'png') => {
//     if (!certificateImageUrl) {
//       Swal.fire({
//         title: 'Download Failed',
//         text: 'Certificate image not available for download.',
//         icon: 'error',
//         confirmButtonColor: '#6366f1',
//       });
//       return;
//     }

//     setDownloading(true);

//     try {
//       if (format === 'png') {
//         // Direct download for PNG
//         const link = document.createElement('a');
//         link.download = `certificate-${course?.title || 'course'}.png`;
//         link.href = certificateImageUrl;
//         link.click();
//       } else {
//         // For PDF, we need to create from the image
//         const response = await fetch(certificateImageUrl);
//         const blob = await response.blob();
//         const imgData = URL.createObjectURL(blob);

//         const pdf = new jsPDF('landscape', 'mm', 'a4');
//         const pdfWidth = pdf.internal.pageSize.getWidth();
//         const pdfHeight = pdf.internal.pageSize.getHeight();

//         // Add image to PDF
//         pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
//         pdf.save(`certificate-${course?.title || 'course'}.pdf`);
//       }

//       Swal.fire({
//         title: 'Success!',
//         text: `Certificate downloaded as ${format.toUpperCase()}`,
//         icon: 'success',
//         confirmButtonColor: '#6366f1',
//       });
//     } catch (error) {
//       console.error('Download error:', error);
//       Swal.fire({
//         title: 'Download Failed',
//         text: 'Failed to download certificate. Please try again.',
//         icon: 'error',
//         confirmButtonColor: '#6366f1',
//       });
//     } finally {
//       setDownloading(false);
//     }
//   };

//   const handleImageLoad = () => {
//     setImageLoading(false);
//     setImageError(false);
//   };

//   const handleImageError = () => {
//     setImageLoading(false);
//     setImageError(true);
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={onHide}
//       centered
//       size="xl"
//       backdrop="static"
//       className="certificate-modal"
//     >
//       <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', color: 'white' }}>
//         <Modal.Title>
//           <div className="d-flex align-items-center">
//             <BsCheckCircleFill className="me-2" size={24} />
//             Course Certificate
//           </div>
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="p-4">
//         <div className="text-center mb-4">
//           <h4 className="fw-bold text-primary">Congratulations!</h4>
//           <p className="text-muted">
//             You have successfully completed the course and earned this certificate.
//           </p>
//         </div>

//         {/* Certificate Preview */}
//         <div className="certificate-container mb-4">
//           <div
//             ref={certificateRef}
//             className="certificate-preview text-center"
//             style={{
//               background: '#ffffff',
//               border: '1px solid #e0e0e0',
//               borderRadius: '10px',
//               padding: '20px',
//               position: 'relative',
//               boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
//               minHeight: '500px',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center'
//             }}
//           >
//             {certificateImageUrl ? (
//               <>
//                 {imageLoading && (
//                   <div className="text-center py-5">
//                     <Spinner animation="border" variant="primary" />
//                     <p className="mt-2 text-muted">Loading certificate...</p>
//                   </div>
//                 )}

//                 {imageError ? (
//                   <div className="text-center py-5">
//                     <BsImage size={48} className="text-muted mb-3" />
//                     <h5 className="text-muted">Failed to load certificate image</h5>
//                     <p className="text-muted">Please try again later.</p>
//                   </div>
//                 ) : (
//                   <img
//                     src={certificateImageUrl}
//                     alt="Course Certificate"
//                     style={{
//                       maxWidth: '100%',
//                       maxHeight: '600px',
//                       borderRadius: '8px',
//                       display: imageLoading ? 'none' : 'block'
//                     }}
//                     onLoad={handleImageLoad}
//                     onError={handleImageError}
//                   />
//                 )}
//               </>
//             ) : (
//               // Fallback certificate design if no image is available
//               <div className="fallback-certificate text-center">
//                 <div
//                   style={{
//                     background: 'linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%)',
//                     border: '15px solid #6366f1',
//                     borderRadius: '10px',
//                     padding: '30px',
//                     minHeight: '400px',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'center',
//                     alignItems: 'center'
//                   }}
//                 >
//                   <h1
//                     style={{
//                       color: '#6366f1',
//                       fontSize: '2rem',
//                       fontWeight: 'bold',
//                       marginBottom: '20px',
//                       textTransform: 'uppercase'
//                     }}
//                   >
//                     Certificate of Completion
//                   </h1>

//                   <div
//                     style={{
//                       height: '3px',
//                       background: 'linear-gradient(90deg, transparent, #6366f1, transparent)',
//                       margin: '20px auto',
//                       width: '200px'
//                     }}
//                   />

//                   <div className="mb-4">
//                     <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '10px' }}>
//                       This is to certify that
//                     </p>
//                     <h2
//                       style={{
//                         color: '#1f2937',
//                         fontSize: '1.8rem',
//                         fontWeight: 'bold',
//                         margin: '20px 0',
//                         textTransform: 'uppercase'
//                       }}
//                     >
//                       {userName}
//                     </h2>
//                     <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '20px' }}>
//                       has successfully completed the course
//                     </p>
//                     <h3
//                       style={{
//                         color: '#6366f1',
//                         fontSize: '1.3rem',
//                         fontWeight: 'bold',
//                         margin: '20px 0',
//                         fontStyle: 'italic'
//                       }}
//                     >
//                       "{course?.title || 'Course'}"
//                     </h3>
//                   </div>

//                   <div className="mt-4">
//                     <div
//                       style={{
//                         height: '2px',
//                         background: 'linear-gradient(90deg, transparent, #8b5cf6, transparent)',
//                         margin: '30px auto',
//                         width: '300px'
//                       }}
//                     />
//                     <div className="row text-center">
//                       <div className="col-6">
//                         <div style={{ borderTop: '2px solid #6366f1', paddingTop: '10px' }}>
//                           <p style={{ margin: 0, fontWeight: 'bold', color: '#1f2937' }}>
//                             Date Completed
//                           </p>
//                           <p style={{ margin: 0, color: '#666' }}>
//                             {new Date().toLocaleDateString()}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="col-6">
//                         <div style={{ borderTop: '2px solid #6366f1', paddingTop: '10px' }}>
//                           <p style={{ margin: 0, fontWeight: 'bold', color: '#1f2937' }}>
//                             Certificate ID
//                           </p>
//                           <p style={{ margin: 0, color: '#666', fontFamily: 'monospace' }}>
//                             CERT-{Date.now()}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Download Options */}
//         <div className="text-center">
//           <p className="text-muted mb-3">
//             Download your certificate in your preferred format
//           </p>
//           <div className="d-flex justify-content-center gap-3 flex-wrap">
//             <Button
//               variant="outline-primary"
//               onClick={() => downloadCertificate('png')}
//               disabled={downloading || !certificateImageUrl || imageError}
//               className="d-flex align-items-center"
//             >
//               <BsDownload className="me-2" />
//               {downloading ? 'Downloading...' : 'Download PNG'}
//             </Button>
//             <Button
//               variant="primary"
//               onClick={() => downloadCertificate('pdf')}
//               disabled={downloading || !certificateImageUrl || imageError}
//               className="d-flex align-items-center"
//               style={{ background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', border: 'none' }}
//             >
//               <BsDownload className="me-2" />
//               {downloading ? 'Downloading...' : 'Download PDF'}
//             </Button>
//           </div>

//           {(!certificateImageUrl || imageError) && (
//             <div className="mt-3">
//               <Alert variant="warning" className="mb-0">
//                 <small>
//                   Certificate image is not currently available. Please try again later or contact support.
//                 </small>
//               </Alert>
//             </div>
//           )}
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// });

// // Circular Progress Component
// const CircularProgress = ({ percentage, size = 120, strokeWidth = 15 }) => {
//   const radius = (size - strokeWidth) / 2;
//   const circumference = radius * 2 * Math.PI;
//   const offset = circumference - (percentage / 100) * circumference;
//   const [animatedPercentage, setAnimatedPercentage] = useState(0);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setAnimatedPercentage(percentage);
//     }, 200);

//     return () => clearTimeout(timer);
//   }, [percentage]);

//   return (
//     <div
//       className="position-relative d-flex justify-content-center align-items-center"
//       style={{ width: size, height: size }}
//     >
//       <svg width={size} height={size} className="position-absolute">
//         <defs>
//           <linearGradient
//             id="progressGradient"
//             x1="0%"
//             y1="0%"
//             x2="100%"
//             y2="0%"
//           >
//             <stop offset="0%" stopColor="#6366f1" />
//             <stop offset="100%" stopColor="#8b5cf6" />
//           </linearGradient>
//         </defs>
//         <circle
//           className="text-muted"
//           stroke="currentColor"
//           fill="transparent"
//           strokeWidth={strokeWidth}
//           r={radius}
//           cx={size / 2}
//           cy={size / 2}
//           opacity={0.2}
//         />
//         <motion.circle
//           className="text-primary"
//           stroke="url(#progressGradient)"
//           fill="transparent"
//           strokeWidth={strokeWidth}
//           strokeDasharray={circumference}
//           initial={{ strokeDashoffset: circumference }}
//           animate={{ strokeDashoffset: offset }}
//           transition={{ duration: 1, ease: "easeOut" }}
//           strokeLinecap="round"
//           r={radius}
//           cx={size / 2}
//           cy={size / 2}
//         />
//       </svg>
//       <div className="position-relative text-center">
//         <motion.h3
//           className="mb-0 fw-bold"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.5 }}
//         >
//           {Math.round(animatedPercentage)}%
//         </motion.h3>
//         <small className="text-muted">Complete</small>
//       </div>
//     </div>
//   );
// };

// // Custom Video Player Component with restrictions
// const CustomVideoPlayer = forwardRef(({ videoUrl, onEnd, onProgress, subpartId, token, API_BASE_URL }, ref) => {
//   const videoRef = useRef(null);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);
//   const [volume, setVolume] = useState(1);
//   const [isMuted, setIsMuted] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [hasReachedEnd, setHasReachedEnd] = useState(false);
//   const [lastSentTime, setLastSentTime] = useState(0);
//   const [userInteracted, setUserInteracted] = useState(false);

//   useImperativeHandle(ref, () => ({
//     pause: () => {
//       if (videoRef.current) {
//         videoRef.current.pause();
//         setIsPlaying(false);
//       }
//     },
//     getCurrentTime: () => videoRef.current?.currentTime || 0,
//     getDuration: () => videoRef.current?.duration || 0,
//   }));

//   const sendProgress = useCallback(() => {
//     const video = videoRef.current;
//     if (!video || !subpartId || !token) return;

//     if (video.currentTime === 0) {
//       return;
//     }

//     // Only send progress if significant time has passed (to avoid too many requests)
//     if (Math.abs(video.currentTime - lastSentTime) < 5) {
//       return;
//     }

//     const progressData = {
//       current_time: video.currentTime,
//       duration: video.duration,
//     };

//     const url = `${API_BASE_URL}/lms/subpart/${subpartId}/progress/`;

//     console.log("Sending video progress:", progressData);

//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${token}`,
//       },
//       body: JSON.stringify(progressData),
//       keepalive: true,
//     })
//       .then(() => setLastSentTime(video.currentTime))
//       .catch(error => {
//         console.error("Failed to send video progress:", error);
//       });
//   }, [subpartId, token, API_BASE_URL, lastSentTime]);

//   useEffect(() => {
//     const video = videoRef.current;
//     if (!video) return;

//     let debounceTimeout;

//     const debouncedSendProgress = () => {
//       clearTimeout(debounceTimeout);
//       debounceTimeout = setTimeout(sendProgress, 1000);
//     };

//     const handlePause = () => {
//       if (video.ended) {
//         return;
//       }
//       console.log("Video paused, queueing progress send.");
//       debouncedSendProgress();
//     };

//     const handleVisibilityChange = () => {
//       if (document.visibilityState === 'hidden') {
//         console.log("Page hidden, sending progress immediately.");
//         clearTimeout(debounceTimeout);
//         sendProgress();
//       }
//     };

//     // Prevent right-click context menu
//     const preventContextMenu = (e) => e.preventDefault();

//     // Prevent keyboard shortcuts
//     const preventShortcuts = (e) => {
//       if (
//         e.key === ' ' || // Space bar
//         e.key === 'k' || // K key (play/pause)
//         e.key === 'K' ||
//         e.key === 'f' || // F key (fullscreen)
//         e.key === 'F' ||
//         e.key === 'm' || // M key (mute)
//         e.key === 'M' ||
//         e.key === 'c' || // C key (captions)
//         e.key === 'C' ||
//         e.ctrlKey ||     // Ctrl combinations
//         e.metaKey        // Cmd combinations (Mac)
//       ) {
//         e.preventDefault();
//       }
//     };

//     video.addEventListener("pause", handlePause);
//     document.addEventListener("visibilitychange", handleVisibilityChange);
//     video.addEventListener("contextmenu", preventContextMenu);
//     document.addEventListener("keydown", preventShortcuts);

//     return () => {
//       clearTimeout(debounceTimeout);
//       console.log("Component unmounting, sending final progress.");
//       sendProgress();
//       video.removeEventListener("pause", handlePause);
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//       video.removeEventListener("contextmenu", preventContextMenu);
//       document.removeEventListener("keydown", preventShortcuts);
//     };
//   }, [sendProgress]);

//   useEffect(() => {
//     const video = videoRef.current;
//     if (!video) return;

//     const handleTimeUpdate = () => {
//       setCurrentTime(video.currentTime);
//       const progressValue = (video.currentTime / video.duration) * 100;
//       setProgress(progressValue);
//       onProgress(progressValue);

//       // Send progress every 30 seconds or when significant time passes
//       if (Math.abs(video.currentTime - lastSentTime) >= 30) {
//         sendProgress();
//       }
//     };

//     const handleLoadedMetadata = () => {
//       setDuration(video.duration);
//       setHasReachedEnd(false);

//       // Disable seeking and controls for restricted viewing
//       if (video.textTracks) {
//         for (let i = 0; i < video.textTracks.length; i++) {
//           video.textTracks[i].mode = 'hidden';
//         }
//       }
//     };

//     const handleEnded = () => {
//       setIsPlaying(false);

//       console.log("Video ended, sending final progress.");
//       sendProgress();

//       if (!hasReachedEnd) {
//         setHasReachedEnd(true);
//         setTimeout(() => {
//           onEnd();
//         }, 100);
//       }
//     };

//     const handlePlay = () => {
//       setIsPlaying(true);
//       setUserInteracted(true);
//     };

//     const handlePause = () => setIsPlaying(false);

//     // Prevent seeking by disabling seek functionality
//     const handleSeeked = () => {
//       // If user tries to seek forward more than 10 seconds from last sent time, revert
//       if (userInteracted && video.currentTime - lastSentTime > 10) {
//         video.currentTime = lastSentTime;
//         Swal.fire({
//           title: 'Seeking Restricted',
//           text: 'Please watch the video sequentially to track your progress properly.',
//           icon: 'warning',
//           confirmButtonColor: '#6366f1',
//           timer: 3000
//         });
//       }
//     };

//     video.addEventListener("timeupdate", handleTimeUpdate);
//     video.addEventListener("loadedmetadata", handleLoadedMetadata);
//     video.addEventListener("ended", handleEnded);
//     video.addEventListener("play", handlePlay);
//     video.addEventListener("pause", handlePause);
//     video.addEventListener("seeked", handleSeeked);

//     return () => {
//       video.removeEventListener("timeupdate", handleTimeUpdate);
//       video.removeEventListener("loadedmetadata", handleLoadedMetadata);
//       video.removeEventListener("ended", handleEnded);
//       video.removeEventListener("play", handlePlay);
//       video.removeEventListener("pause", handlePause);
//       video.removeEventListener("seeked", handleSeeked);
//     };
//   }, [onEnd, onProgress, hasReachedEnd, sendProgress, lastSentTime, userInteracted]);

//   useEffect(() => {
//     setHasReachedEnd(false);
//     setProgress(0);
//     setCurrentTime(0);
//     setLastSentTime(0);
//     setUserInteracted(false);
//   }, [videoUrl]);

//   const togglePlay = () => {
//     const video = videoRef.current;
//     if (video) {
//       if (isPlaying) {
//         video.pause();
//       } else {
//         video.play().catch((error) => {
//           console.error("Video play failed:", error);
//         });
//       }
//     }
//   };

//   const toggleMute = () => {
//     const video = videoRef.current;
//     if (video) {
//       video.muted = !video.muted;
//       setIsMuted(!isMuted);
//     }
//   };

//   const handleVolumeChange = (e) => {
//     const value = Number.parseFloat(e.target.value);
//     const video = videoRef.current;
//     if (video) {
//       video.volume = value;
//       setVolume(value);
//       setIsMuted(value === 0);
//     }
//   };

//   const handleProgressChange = (e) => {
//     const value = Number.parseFloat(e.target.value);
//     const video = videoRef.current;
//     if (video) {
//       // Only allow minimal seeking (5 seconds buffer)
//       const targetTime = (value / 100) * video.duration;
//       const maxAllowedTime = lastSentTime + 5;

//       if (targetTime <= maxAllowedTime) {
//         video.currentTime = targetTime;
//         setProgress(value);
//       } else {
//         // Reset to allowed position
//         video.currentTime = maxAllowedTime;
//         setProgress((maxAllowedTime / video.duration) * 100);

//         Swal.fire({
//           title: 'Seeking Restricted',
//           text: 'You can only seek within 5 seconds of your current progress.',
//           icon: 'warning',
//           confirmButtonColor: '#6366f1',
//           timer: 3000
//         });
//       }
//     }
//   };

//   const skipForward = () => {
//     const video = videoRef.current;
//     if (video) {
//       Swal.fire({
//         title: "Forward Skipping Disabled",
//         text: "You cannot skip ahead. Please continue watching the video to proceed.",
//         icon: "info",
//         confirmButtonText: "OK",
//         confirmButtonColor: "#6366f1",
//       });
//     }
//   };


//   const skipBackward = () => {
//     const video = videoRef.current;
//     if (video) {
//       video.currentTime = Math.max(video.currentTime - 5, 0);
//     }
//   };

//   const toggleFullscreen = () => {
//     const videoElement = videoRef.current;
//     if (!videoElement) return;

//     const container = videoElement.closest(".video-container");
//     if (!container) return;

//     if (!document.fullscreenElement) {
//       container
//         .requestFullscreen()
//         .then(() => setIsFullscreen(true))
//         .catch((err) => {
//           console.error(
//             `Error attempting to enable fullscreen: ${err.message}`
//           );
//         });
//     } else {
//       document.exitFullscreen();
//       setIsFullscreen(false);
//     }
//   };

//   const formatTime = (seconds) => {
//     if (isNaN(seconds) || seconds < 0) return "0:00";
//     const minutes = Math.floor(seconds / 60);
//     const remainingSeconds = Math.floor(seconds % 60);
//     return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
//   };

//   const btnStyle = {
//     background: "none",
//     border: "none",
//     color: "white",
//     padding: "0",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     fontSize: "14px",
//   };

//   return (
//     <div
//       className="video-container"
//       style={{
//         backgroundColor: "#000",
//         width: "100%",
//         position: "relative",
//         overflow: "hidden",
//         aspectRatio: "16 / 9",
//       }}
//     >
//       <video
//         key={videoUrl}
//         ref={videoRef}
//         src={videoUrl}
//         controlsList="nodownload noplaybackrate nofullscreen"
//         disablePictureInPicture
//         playsInline
//         onContextMenu={(e) => e.preventDefault()}
//         style={{
//           width: "100%",
//           height: "100%",
//           objectFit: "contain",
//           display: "block",
//         }}
//       />
//       <div
//         className="video-controls"
//         style={{
//           position: "absolute",
//           bottom: 0,
//           left: 0,
//           right: 0,
//           backgroundColor: "rgba(0, 0, 0, 0.6)",
//           padding: "8px 10px",
//           display: "flex",
//           flexDirection: "column",
//           zIndex: 10,
//         }}
//       >
//         <input
//           type="range"
//           min="0"
//           max="100"
//           step="0.1"
//           value={progress}
//           onChange={handleProgressChange}
//           style={{
//             width: "100%",
//             accentColor: "#0d6efd",
//             cursor: "pointer",
//             height: "5px",
//             marginBottom: "6px",
//           }}
//         />
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: "8px",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "10px",
//               flexWrap: "wrap",
//             }}
//           >
//             <button onClick={togglePlay} style={btnStyle}>
//               {isPlaying ? <BsPauseFill size={24} /> : <BsPlayFill size={24} />}
//             </button>
//             <button onClick={skipBackward} style={btnStyle}>
//               <BsSkipBackward size={20} />
//             </button>
//             <button onClick={skipForward} style={btnStyle}>
//               <BsSkipForward size={20} />
//             </button>
//             <button onClick={toggleMute} style={btnStyle}>
//               {isMuted ? <BsVolumeMute size={20} /> : <BsVolumeUp size={20} />}
//             </button>
//             <input
//               type="range"
//               min="0"
//               max="1"
//               step="0.1"
//               value={volume}
//               onChange={handleVolumeChange}
//               style={{
//                 width: "60px",
//                 accentColor: "#fff",
//                 cursor: "pointer",
//               }}
//             />
//             <span style={{ color: "#fff", fontSize: "0.8rem" }}>
//               {formatTime(currentTime)} / {formatTime(duration)}
//             </span>
//           </div>
//           <button
//             onClick={toggleFullscreen}
//             style={{
//               position: "absolute",
//               top: "12px",
//               right: "12px",
//               background: "none",
//               border: "none",
//               color: "white",
//               padding: "4px",
//               cursor: "pointer",
//               zIndex: 15,
//             }}
//           >
//             <BsFullscreen size={14} />
//           </button>
//         </div>
//       </div>
//       {!isPlaying && (
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(0,0,0,0.3)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             cursor: "default",
//             zIndex: 5,
//           }}
//         >
//           <div
//             onClick={togglePlay}
//             style={{
//               backgroundColor: "rgba(255,255,255,0.3)",
//               borderRadius: "50%",
//               padding: "12px",
//               cursor: "pointer",
//             }}
//           >
//             <BsPlayFill size={40} color="white" />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// });

// // YouTube-style Video Recommendation Component
// const VideoRecommendation = ({
//   lesson,
//   partIndex,
//   isLocked,
//   handleLessonSelect,
//   isActive,
//   isComplete,
//   API_BASE_URL,
//   duration,
// }) => {
//   const [showDescription, setShowDescription] = useState(false);

//   return (
//     <div className="youtube-recommendation">
//       <div
//         className={`youtube-video-card ${isLocked ? "locked" : ""} ${isActive ? "active" : ""
//           }`}
//         onClick={() =>
//           !isLocked && handleLessonSelect(partIndex, lesson.subpart_id)
//         }
//       >
//         <div className="video-thumbnail">
//           {lesson.video ? (
//             <img
//               src={`${API_BASE_URL}/lms/media/videos/thumbnail.png`}
//               alt="Video Thumbnail"
//             />
//           ) : (
//             <div className="placeholder-thumbnail">
//               <BsPlayFill className="play-icon" />
//             </div>
//           )}
//           {duration && (
//             <span className="video-duration">
//               <SafeRender>{lesson.duration}</SafeRender>
//             </span>
//           )}
//         </div>

//         <div className="video-info">
//           <h6 className="video-title">
//             <SafeRender>{lesson.subpart_title}</SafeRender>
//           </h6>

//           <div className="video-meta">
//             <span className="video-section">Section {partIndex + 1}</span>
//             {isComplete && <span className="video-watched">Watched</span>}
//           </div>

//           <button
//             className="description-toggle"
//             onClick={(e) => {
//               e.stopPropagation();
//               setShowDescription(!showDescription);
//             }}
//           >
//             {showDescription ? "Hide description" : "Show description"}
//           </button>

//           {showDescription && (
//             <div className="video-description">
//               <SafeRender>
//                 {lesson.part_description ||
//                   "No description available for this lesson."}
//               </SafeRender>
//             </div>
//           )}
//         </div>

//         <div className="video-status">
//           {isComplete ? (
//             <BsCheck2Circle size={20} className="text-success" />
//           ) : isLocked ? (
//             <BsLockFill size={18} className="text-muted" />
//           ) : (
//             <BsPlayFill size={20} className="text-primary" />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// // Quiz Modal Component
// const QuizModal = memo(
//   ({
//     show,
//     onHide,
//     quiz,
//     quizSubmitted,
//     quizResults,
//     currentQuestionIndex,
//     answers,
//     colors,
//     handleOptionChange,
//     handlePrevQuestion,
//     handleNextQuestion,
//     handleSubmitQuiz,
//     isQuizComplete,
//     retakeQuiz,
//   }) => (
//     <Modal
//       show={show}
//       onHide={onHide}
//       centered
//       size="lg"
//       backdrop="static"
//       className="quiz-modal"
//     >
//       <Modal.Header
//         closeButton
//         style={{ background: colors.gradient, color: colors.white }}
//       >
//         <Modal.Title>
//           <div className="d-flex align-items-center">
//             <BsBookmark className="me-2" size={24} />
//             <SafeRender>{quiz?.title || "Section Quiz"}</SafeRender>
//           </div>
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="p-4">
//         {quiz && quiz.questions && !quizSubmitted ? (
//           <>
//             <div className="mb-4">
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h5 className="fw-bold mb-0">
//                   Question {currentQuestionIndex + 1} of {quiz.questions.length}
//                 </h5>
//                 <div className="progress w-50" style={{ height: "8px" }}>
//                   <div
//                     className="progress-bar"
//                     role="progressbar"
//                     style={{
//                       width: `${((currentQuestionIndex + 1) / quiz.questions.length) *
//                         100
//                         }%`,
//                       background: colors.gradient,
//                     }}
//                     aria-valuenow={
//                       ((currentQuestionIndex + 1) / quiz.questions.length) * 100
//                     }
//                     aria-valuemin="0"
//                     aria-valuemax="100"
//                   ></div>
//                 </div>
//               </div>

//               <div className="question-container">
//                 <Card className="border-0 shadow-sm mb-4">
//                   <Card.Body>
//                     <h5 className="fw-bold">
//                       <SafeRender>
//                         {quiz.questions[currentQuestionIndex].text}
//                       </SafeRender>
//                     </h5>
//                   </Card.Body>
//                 </Card>

//                 <div className="options-container">
//                   {quiz.questions[currentQuestionIndex].options.map(
//                     (option) => (
//                       <Card
//                         key={option.id}
//                         data-option-id={option.id}
//                         className={`mb-3 border-0 shadow-sm option-card ${answers[quiz.questions[currentQuestionIndex].id] ===
//                           option.id
//                           ? "selected"
//                           : ""
//                           }`}
//                         onClick={() =>
//                           handleOptionChange(
//                             quiz.questions[currentQuestionIndex].id,
//                             option.id
//                           )
//                         }
//                         style={{
//                           cursor: "pointer",
//                           borderLeft:
//                             answers[quiz.questions[currentQuestionIndex].id] ===
//                               option.id
//                               ? `5px solid ${colors.primary}`
//                               : "5px solid transparent",
//                           transform:
//                             answers[quiz.questions[currentQuestionIndex].id] ===
//                               option.id
//                               ? "translateX(5px)"
//                               : "none",
//                           transition: "all 0.2s ease",
//                         }}
//                       >
//                         <Card.Body className="d-flex align-items-center">
//                           <div
//                             className="option-indicator me-3"
//                             style={{
//                               width: "24px",
//                               height: "24px",
//                               borderRadius: "50%",
//                               border: `2px solid ${answers[
//                                 quiz.questions[currentQuestionIndex].id
//                               ] === option.id
//                                 ? colors.primary
//                                 : "#ddd"
//                                 }`,
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                               background:
//                                 answers[
//                                   quiz.questions[currentQuestionIndex].id
//                                 ] === option.id
//                                   ? colors.primary
//                                   : "transparent",
//                             }}
//                           >
//                             {answers[
//                               quiz.questions[currentQuestionIndex].id
//                             ] === option.id && (
//                                 <div
//                                   style={{
//                                     width: "10px",
//                                     height: "10px",
//                                     borderRadius: "50%",
//                                     background: "white",
//                                   }}
//                                 ></div>
//                               )}
//                           </div>
//                           <div>
//                             <SafeRender>{option.text}</SafeRender>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>

//             <div className="d-flex justify-content-between mt-4">
//               <Button
//                 variant="outline-secondary"
//                 onClick={handlePrevQuestion}
//                 disabled={currentQuestionIndex === 0}
//                 className="d-flex align-items-center"
//               >
//                 <BsArrowLeft className="me-2" /> Previous
//               </Button>

//               {currentQuestionIndex < quiz.questions.length - 1 ? (
//                 <Button
//                   variant="primary"
//                   onClick={handleNextQuestion}
//                   className="d-flex align-items-center"
//                   style={{ background: colors.gradient, border: "none" }}
//                 >
//                   Next <BsArrowRight className="ms-2" />
//                 </Button>
//               ) : (
//                 <Button
//                   variant="success"
//                   onClick={handleSubmitQuiz}
//                   disabled={!isQuizComplete()}
//                   className="d-flex align-items-center"
//                 >
//                   Submit Quiz <BsCheckCircleFill className="ms-2" />
//                 </Button>
//               )}
//             </div>
//           </>
//         ) : quizSubmitted && quizResults ? (
//           <div className="text-center py-4">
//             <div className="mb-4">
//               <div className="result-icon mb-3">
//                 {quizResults.result === "Passed" ? (
//                   <div
//                     className="success-icon"
//                     style={{ color: colors.success, fontSize: "4rem" }}
//                   >
//                     <BsCheckCircleFill />
//                   </div>
//                 ) : (
//                   <div
//                     className="warning-icon"
//                     style={{ color: colors.warning, fontSize: "4rem" }}
//                   >
//                     <BsArrowRepeat />
//                   </div>
//                 )}
//               </div>

//               <h4 className="fw-bold">
//                 {quizResults.result === "Passed"
//                   ? "Quiz Passed!"
//                   : "Quiz Needs Improvement"}
//               </h4>
//               <p className="text-muted">
//                 <SafeRender>{quizResults.message}</SafeRender>
//               </p>

//               <div className="score-display my-4">
//                 <CircularProgress percentage={quizResults.score} />
//                 <h5 className="mt-3">
//                   Your Score: {Math.round(quizResults.score)}%
//                 </h5>
//               </div>

//               {quizResults.result !== "Passed" && (
//                 <p className="text-warning">
//                   You can retake the quiz to improve your score.
//                 </p>
//               )}
//             </div>

//             <div className="d-flex justify-content-center gap-3">
//               {quizResults.result !== "Passed" && (
//                 <Button
//                   variant="warning"
//                   onClick={retakeQuiz}
//                   className="d-flex align-items-center"
//                 >
//                   <BsArrowRepeat className="me-2" /> Retake Quiz
//                 </Button>
//               )}

//               <Button
//                 variant="primary"
//                 onClick={onHide}
//                 style={{ background: colors.gradient, border: "none" }}
//               >
//                 Continue Learning
//               </Button>
//             </div>
//           </div>
//         ) : (
//           <p className="text-center text-muted">
//             No quiz available for this section yet.
//           </p>
//         )}
//       </Modal.Body>
//     </Modal>
//   )
// );

// // Quiz Offcanvas Component
// const QuizOffcanvas = memo(
//   ({
//     show,
//     onHide,
//     quiz,
//     quizSubmitted,
//     quizResults,
//     currentQuestionIndex,
//     answers,
//     colors,
//     handleOptionChange,
//     handlePrevQuestion,
//     handleNextQuestion,
//     handleSubmitQuiz,
//     isQuizComplete,
//     retakeQuiz,
//   }) => (
//     <Offcanvas
//       show={show}
//       onHide={onHide}
//       placement="bottom"
//       style={{ height: "90vh" }}
//     >
//       <Offcanvas.Header
//         closeButton
//         style={{ background: colors.gradient, color: colors.white }}
//       >
//         <Offcanvas.Title>
//           <div className="d-flex align-items-center">
//             <BsBookmark className="me-2" size={24} />
//             <SafeRender>{quiz?.title || "Section Quiz"}</SafeRender>
//           </div>
//         </Offcanvas.Title>
//       </Offcanvas.Header>
//       <Offcanvas.Body>
//         {quiz && quiz.questions && !quizSubmitted ? (
//           <>
//             <div className="mb-4">
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h5 className="fw-bold mb-0">
//                   Question {currentQuestionIndex + 1} of {quiz.questions.length}
//                 </h5>
//                 <div className="progress w-50" style={{ height: "8px" }}>
//                   <div
//                     className="progress-bar"
//                     role="progressbar"
//                     style={{
//                       width: `${((currentQuestionIndex + 1) / quiz.questions.length) *
//                         100
//                         }%`,
//                       background: colors.gradient,
//                     }}
//                     aria-valuenow={
//                       ((currentQuestionIndex + 1) / quiz.questions.length) * 100
//                     }
//                     aria-valuemin="0"
//                     aria-valuemax="100"
//                   ></div>
//                 </div>
//               </div>

//               <div className="question-container">
//                 <Card className="border-0 shadow-sm mb-4">
//                   <Card.Body>
//                     <h5 className="fw-bold">
//                       <SafeRender>
//                         {quiz.questions[currentQuestionIndex].text}
//                       </SafeRender>
//                     </h5>
//                   </Card.Body>
//                 </Card>

//                 <div className="options-container">
//                   {quiz.questions[currentQuestionIndex].options.map(
//                     (option) => (
//                       <Card
//                         key={option.id}
//                         data-option-id={option.id}
//                         className={`mb-3 border-0 shadow-sm option-card ${answers[quiz.questions[currentQuestionIndex].id] ===
//                           option.id
//                           ? "selected"
//                           : ""
//                           }`}
//                         onClick={() =>
//                           handleOptionChange(
//                             quiz.questions[currentQuestionIndex].id,
//                             option.id
//                           )
//                         }
//                         style={{
//                           cursor: "pointer",
//                           borderLeft:
//                             answers[quiz.questions[currentQuestionIndex].id] ===
//                               option.id
//                               ? `5px solid ${colors.primary}`
//                               : "5px solid transparent",
//                           transform:
//                             answers[quiz.questions[currentQuestionIndex].id] ===
//                               option.id
//                               ? "translateX(5px)"
//                               : "none",
//                           transition: "all 0.2s ease",
//                         }}
//                       >
//                         <Card.Body className="d-flex align-items-center">
//                           <div
//                             className="option-indicator me-3"
//                             style={{
//                               width: "24px",
//                               height: "24px",
//                               borderRadius: "50%",
//                               border: `2px solid ${answers[
//                                 quiz.questions[currentQuestionIndex].id
//                               ] === option.id
//                                 ? colors.primary
//                                 : "#ddd"
//                                 }`,
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                               background:
//                                 answers[
//                                   quiz.questions[currentQuestionIndex].id
//                                 ] === option.id
//                                   ? colors.primary
//                                   : "transparent",
//                             }}
//                           >
//                             {answers[
//                               quiz.questions[currentQuestionIndex].id
//                             ] === option.id && (
//                                 <div
//                                   style={{
//                                     width: "10px",
//                                     height: "10px",
//                                     borderRadius: "50%",
//                                     background: "white",
//                                   }}
//                                 ></div>
//                               )}
//                           </div>
//                           <div>
//                             <SafeRender>{option.text}</SafeRender>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>

//             <div className="d-flex justify-content-between mt-4">
//               <Button
//                 variant="outline-secondary"
//                 onClick={handlePrevQuestion}
//                 disabled={currentQuestionIndex === 0}
//                 className="d-flex align-items-center"
//               >
//                 <BsArrowLeft className="me-2" /> Previous
//               </Button>

//               {currentQuestionIndex < quiz.questions.length - 1 ? (
//                 <Button
//                   variant="primary"
//                   onClick={handleNextQuestion}
//                   className="d-flex align-items-center"
//                   style={{ background: colors.gradient, border: "none" }}
//                 >
//                   Next <BsArrowRight className="ms-2" />
//                 </Button>
//               ) : (
//                 <Button
//                   variant="success"
//                   onClick={handleSubmitQuiz}
//                   disabled={!isQuizComplete()}
//                   className="d-flex align-items-center"
//                 >
//                   Submit Quiz <BsCheckCircleFill className="ms-2" />
//                 </Button>
//               )}
//             </div>
//           </>
//         ) : quizSubmitted && quizResults ? (
//           <div className="text-center py-4">
//             <div className="mb-4">
//               <div className="result-icon mb-3">
//                 {quizResults.result === "Passed" ? (
//                   <div
//                     className="success-icon"
//                     style={{ color: colors.success, fontSize: "4rem" }}
//                   >
//                     <BsCheckCircleFill />
//                   </div>
//                 ) : (
//                   <div
//                     className="warning-icon"
//                     style={{ color: colors.warning, fontSize: "4rem" }}
//                   >
//                     <BsArrowRepeat />
//                   </div>
//                 )}
//               </div>

//               <h4 className="fw-bold">
//                 {quizResults.result === "Passed"
//                   ? "Quiz Passed!"
//                   : "Quiz Needs Improvement"}
//               </h4>
//               <p className="text-muted">
//                 <SafeRender>{quizResults.message.text || quizResults.message}</SafeRender>
//               </p>

//               <div className="score-display my-4">
//                 <CircularProgress percentage={quizResults.score} />
//                 <h5 className="mt-3">
//                   Your Score: {Math.round(quizResults.score)}%
//                 </h5>
//               </div>

//               {quizResults.result !== "Passed" && (
//                 <p className="text-warning">
//                   You can retake the quiz to improve your score.
//                 </p>
//               )}
//             </div>

//             <div className="d-flex justify-content-center gap-3">
//               {quizResults.result !== "Passed" && (
//                 <Button
//                   variant="warning"
//                   onClick={retakeQuiz}
//                   className="d-flex align-items-center"
//                 >
//                   <BsArrowRepeat className="me-2" /> Retake Quiz
//                 </Button>
//               )}

//               <Button
//                 variant="primary"
//                 onClick={onHide}
//                 style={{ background: colors.gradient, border: "none" }}
//               >
//                 Continue Learning
//               </Button>
//             </div>
//           </div>
//         ) : (
//           <p className="text-center text-muted">
//             No quiz available for this section yet.
//           </p>
//         )}
//       </Offcanvas.Body>
//     </Offcanvas>
//   )
// );

// // Mobile Menu Offcanvas
// const MobileMenuOffcanvas = memo(
//   ({
//     show,
//     onHide,
//     course,
//     colors,
//     activePartIndex,
//     togglePart,
//     activeLesson,
//     isLessonLocked,
//     handleLessonSelect,
//     bookmarkedLessons,
//   }) => (
//     <Offcanvas
//       show={show}
//       onHide={onHide}
//       placement="start"
//       style={{ maxWidth: "80%" }}
//     >
//       <Offcanvas.Header
//         closeButton
//         style={{ background: colors.gradient, color: colors.white }}
//       >
//         <Offcanvas.Title>Course Structure</Offcanvas.Title>
//       </Offcanvas.Header>
//       <Offcanvas.Body className="p-0">
//         <ListGroup variant="flush" className="course-structure">
//           {course?.parts?.map((part, partIndex) => (
//             <div key={part.part_id}>
//               <ListGroup.Item
//                 action
//                 className={`fw-bold d-flex justify-content-between align-items-center border-0 ${activePartIndex === partIndex ? "text-primary" : "text-dark"
//                   }`}
//                 onClick={() => togglePart(partIndex)}
//                 style={{
//                   cursor: "pointer",
//                   backgroundColor:
//                     activePartIndex === partIndex ? "#f0f4ff" : "#ffffff",
//                   padding: "1rem",
//                 }}
//               >
//                 <div className="d-flex align-items-center">
//                   <div
//                     className="me-2 rounded-circle d-flex align-items-center justify-content-center"
//                     style={{
//                       width: "28px",
//                       height: "28px",
//                       background:
//                         activePartIndex === partIndex
//                           ? colors.primary
//                           : "#e9ecef",
//                       color: activePartIndex === partIndex ? "white" : "black",
//                     }}
//                   >
//                     {partIndex + 1}
//                   </div>
//                   <SafeRender>{part.part_title}</SafeRender>
//                 </div>
//                 {activePartIndex === partIndex ? (
//                   <BsChevronUp />
//                 ) : (
//                   <BsChevronDown />
//                 )}
//               </ListGroup.Item>
//               <AnimatePresence>
//                 {activePartIndex === partIndex && (
//                   <motion.div
//                     initial={{ height: 0, opacity: 0 }}
//                     animate={{ height: "auto", opacity: 1 }}
//                     exit={{ height: 0, opacity: 0 }}
//                     transition={{ duration: 0.3 }}
//                   >
//                     {part.subparts?.map((lesson, lessonIndex) => {
//                       const locked = isLessonLocked(partIndex, lessonIndex);
//                       return (
//                         <ListGroup.Item
//                           key={lesson.subpart_id}
//                           action
//                           active={
//                             activeLesson?.subpart_id === lesson.subpart_id
//                           }
//                           className={`border-0 py-3 px-4 ${locked ? "text-muted" : ""
//                             }`}
//                           onClick={() =>
//                             !locked &&
//                             handleLessonSelect(partIndex, lesson.subpart_id)
//                           }
//                           style={{
//                             cursor: locked ? "not-allowed" : "pointer",
//                             backgroundColor:
//                               activeLesson?.subpart_id === lesson.subpart_id
//                                 ? colors.primary + "20"
//                                 : lesson.is_complete
//                                   ? colors.success + "20"
//                                   : "white",
//                             borderLeft:
//                               activeLesson?.subpart_id === lesson.subpart_id
//                                 ? `4px solid ${colors.primary}`
//                                 : lesson.is_complete
//                                   ? `4px solid ${colors.success}`
//                                   : "4px solid transparent",
//                           }}
//                         >
//                           <div className="d-flex justify-content-between align-items-center">
//                             <div className="d-flex align-items-center">
//                               <div
//                                 className="me-3 rounded-circle d-flex align-items-center justify-content-center"
//                                 style={{
//                                   width: "24px",
//                                   height: "24px",
//                                   background: lesson.is_complete
//                                     ? colors.success
//                                     : "#e9ecef",
//                                   color: lesson.is_complete ? "white" : "black",
//                                 }}
//                               >
//                                 {lesson.is_complete ? (
//                                   <BsCheck2Circle size={14} />
//                                 ) : locked ? (
//                                   <BsLockFill size={12} />
//                                 ) : (
//                                   lessonIndex + 1
//                                 )}
//                               </div>
//                               <p className="mb-0 fw-medium small">
//                                 <SafeRender>{lesson.subpart_title}</SafeRender>
//                               </p>
//                             </div>
//                             {bookmarkedLessons.includes(lesson.subpart_id) && (
//                               <BsBookmarkFill className="text-warning" />
//                             )}
//                           </div>
//                         </ListGroup.Item>
//                       );
//                     })}
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </div>
//           ))}
//         </ListGroup>
//       </Offcanvas.Body>
//     </Offcanvas>
//   )
// );

// export default function CourseViewer() {
//   const { id } = useParams();
//   const [course, setCourse] = useState(null);
//   const [activePartIndex, setActivePartIndex] = useState(null);
//   const [activeLesson, setActiveLesson] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isInstructor, setInstructor] = useState(false);
//   const [isEnrolled, setEnrolled] = useState(false);
//   const [quiz, setQuiz] = useState(null);
//   const [answers, setAnswers] = useState({});
//   const [showQuiz, setShowQuiz] = useState(false);
//   const [showCurriculum, setShowCurriculum] = useState(false);
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//   const [quizSubmitted, setQuizSubmitted] = useState(false);
//   const [quizResults, setQuizResults] = useState(null);
//   const [showQuizModal, setShowQuizModal] = useState(false);
//   const [showOffcanvas, setShowOffcanvas] = useState(false);
//   const [bookmarkedLessons, setBookmarkedLessons] = useState([]);
//   const [videoProgress, setVideoProgress] = useState(0);
//   const [quizButtonEnabled, setQuizButtonEnabled] = useState(false);
//   const [showMobileMenu, setShowMobileMenu] = useState(false);
//   const [canRetakeQuiz, setCanRetakeQuiz] = useState(false);
//   const [submittedQuizzes, setSubmittedQuizzes] = useState([]);
//   const [expandedVideoSection, setExpandedVideoSection] = useState({
//     upNext: true,
//     otherSections: true,
//   });
//   const [showCertificateModal, setShowCertificateModal] = useState(false);
//   const [certificateData, setCertificateData] = useState(null);
//   const [certificateImageUrl, setCertificateImageUrl] = useState(null);
//   const [userName, setUserName] = useState("Student");
//   const [fetchingCertificate, setFetchingCertificate] = useState(false);
//   const [viewLoading, setViewLoading] = useState(false);
//   const [downloadLoading, setDownloadLoading] = useState(false);
//   const [showFullContent, setShowFullContent] = useState(false);
//   const token = localStorage.getItem("jwttoken");
//   const navigate = useNavigate();
//   const videoPlayerRef = useRef(null);
//   const API_BASE_URL = "https://kaasbackend.vetrinahealthcare.com";

//   useEffect(() => {
//     const disableRightClick = (e) => e.preventDefault();
//     const disableInspectKeys = (e) => {
//       if (
//         e.key === "F12" ||
//         (e.ctrlKey && e.shiftKey && e.key === "I") ||
//         (e.ctrlKey && e.shiftKey && e.key === "J") ||
//         (e.ctrlKey && e.key === "U")
//       ) {
//         e.preventDefault();
//       }
//     };

//     document.addEventListener("contextmenu", disableRightClick);
//     document.addEventListener("keydown", disableInspectKeys);

//     return () => {
//       document.removeEventListener("contextmenu", disableRightClick);
//       document.removeEventListener("keydown", disableInspectKeys);
//     };
//   }, []);

//   const colors = {
//     primary: "#6366f1",
//     secondary: "#8b5cf6",
//     success: "#10b981",
//     warning: "#f59e0b",
//     danger: "#ef4444",
//     info: "#3b82f6",
//     light: "#f3f4f6",
//     dark: "#1f2937",
//     white: "#ffffff",
//     gradient: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
//   };

//   // Fetch Certificate Data
//   const fetchCertificate = useCallback(async () => {
//     if (!id || !course) return;

//     try {
//       setFetchingCertificate(true);
//       const url = `https://kaasbackend.vetrinahealthcare.com/master/certificate-v2/${id}/`;

//       console.log("Fetching certificate from:", url);

//       const response = await axios.post(
//         url,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//           responseType: 'blob'
//         }
//       );

//       console.log("Certificate response:", response);
//       console.log("Content-Type:", response.headers['content-type']);
//       console.log("Blob type:", response.data.type);
//       console.log("Blob size:", response.data.size);

//       if (response.data && response.data instanceof Blob) {
//         const blob = response.data;

//         if (blob.type === 'application/pdf') {
//           // Handle PDF certificate
//           const pdfUrl = URL.createObjectURL(blob);
//           setCertificateImageUrl(pdfUrl); // This will be a PDF URL
//           setCertificateData({
//             type: 'pdf',
//             blob: blob,
//             url: pdfUrl,
//             fileName: `certificate-${course?.title || 'course'}.pdf`
//           });
//         } else if (blob.type.startsWith('image/')) {
//           // Handle image certificate
//           const imageUrl = URL.createObjectURL(blob);
//           setCertificateImageUrl(imageUrl);
//           setCertificateData({
//             type: 'image',
//             blob: blob,
//             url: imageUrl,
//             fileName: `certificate-${course?.title || 'course'}.png`
//           });
//         } else {
//           throw new Error(`Unsupported file type: ${blob.type}`);
//         }

//         setShowCertificateModal(true);

//         Swal.fire({
//           title: 'Certificate Loaded!',
//           text: 'Your course certificate is ready to view and download.',
//           icon: 'success',
//           confirmButtonColor: colors.primary,
//           timer: 2000
//         });
//       } else {
//         throw new Error('Invalid certificate response');
//       }
//     } catch (error) {
//       console.error("Certificate fetch error:", error);

//       if (error.response && error.response.status === 404) {
//         Swal.fire({
//           title: "Certificate Not Available",
//           text: "Certificate will be generated after course completion. Please complete all lessons first.",
//           icon: "info",
//           confirmButtonColor: colors.primary,
//         });
//       } else if (error.response && error.response.status === 401) {
//         Swal.fire({
//           title: "Authentication Error",
//           text: "Your session has expired. Please log in again.",
//           icon: "warning",
//           confirmButtonColor: colors.primary,
//         });
//       } else {
//         Swal.fire({
//           title: "Certificate Not Ready",
//           text: "Unable to load certificate. Please try again later or contact support.",
//           icon: "error",
//           confirmButtonColor: colors.primary,
//         });
//       }
//       setShowCertificateModal(true);
//     } finally {
//       setFetchingCertificate(false);
//     }
//   }, [id, course, token, colors.primary]);

//   // Check if course is completed and show certificate button
//   const isCourseCompleted = useCallback(() => {
//     if (!course?.parts) return false;

//     const totalLessons = course.parts.reduce(
//       (sum, part) => sum + (part.subparts?.length || 0),
//       0
//     );

//     const completedLessons = course.parts.reduce(
//       (sum, part) =>
//         sum + (part.subparts?.filter((l) => l.is_complete).length || 0),
//       0
//     );

//     return totalLessons > 0 && completedLessons === totalLessons;
//   }, [course]);

//   const handleOptionChange = useCallback((questionId, optionId) => {
//     setAnswers((prev) => ({
//       ...prev,
//       [questionId]: optionId,
//     }));

//     const selectedOption = document.querySelector(
//       `.option-card[data-option-id="${optionId}"]`
//     );
//     if (selectedOption) {
//       selectedOption.classList.add("pulse-animation");
//       setTimeout(() => {
//         selectedOption.classList.remove("pulse-animation");
//       }, 500);
//     }
//   }, []);

//   const isQuizComplete = useCallback(() => {
//     if (!quiz) return false;
//     return quiz.questions.every((q) => answers[q.id]);
//   }, [quiz, answers]);

//   const retakeQuiz = useCallback(() => {
//     if (!canRetakeQuiz) return;

//     Swal.fire({
//       title: "Retake Quiz?",
//       text: "Your previous answers will be cleared. Are you ready to try again?",
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Retake Quiz!",
//       cancelButtonText: "Not now",
//       confirmButtonColor: colors.primary,
//       cancelButtonColor: colors.danger,
//     }).then((result) => {
//       if (result.isConfirmed) {
//         setAnswers({});
//         setCurrentQuestionIndex(0);
//         setQuizSubmitted(false);
//         setQuizResults(null);
//         setShowQuizModal(true);
//       }
//     });
//   }, [canRetakeQuiz, colors.primary, colors.danger]);

//   const fetchQuiz = useCallback(() => {
//     if (!course || activePartIndex === null || !activeLesson) return;

//     if (submittedQuizzes.includes(activeLesson.subpart_id)) {
//       Swal.fire({
//         title: "Quiz Already Completed",
//         text: "You have already submitted the quiz for this lesson.",
//         icon: "info",
//         confirmButtonText: "OK",
//         confirmButtonColor: colors.primary,
//       });
//       return;
//     }

//     setLoading(true);
//     Swal.fire({
//       title: "Loading Quiz...",
//       html: `
//         <div class="d-flex justify-content-center">
//           <div class="spinner-border text-primary" role="status">
//             <span class="visually-hidden">Loading...</span>
//           </div>
//         </div>
//         <p class="mt-3">Preparing your questions.</p>`,
//       allowOutsideClick: false,
//       showConfirmButton: false,
//     });

//     const url = `${API_BASE_URL}/quiz/quiz-by-coursepart/${activeLesson.subpart_id}/`;
//     console.log("Attempting to fetch quiz from:", url);

//     axios
//       .get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         setQuiz(response.data);
//         setCurrentQuestionIndex(0);
//         setAnswers({});
//         setQuizSubmitted(false);
//         setQuizResults(null);
//         setShowQuiz(true);
//         setLoading(false);
//         Swal.close();
//       })
//       .catch((err) => {
//         console.error("Failed to fetch quiz. Full error:", err.response || err.request || err.message);
//         setLoading(false);
//         setError("Failed to load quiz. Please try again later.");
//         Swal.fire({
//           title: "Error",
//           text: "Could not load the quiz. Please check your connection and try again.",
//           icon: "error",
//           confirmButtonText: "OK",
//           confirmButtonColor: colors.primary,
//         });
//       });
//   }, [
//     activePartIndex,
//     course,
//     token,
//     colors.primary,
//     API_BASE_URL,
//     submittedQuizzes,
//     activeLesson,
//   ]);

//   const handleSubmitQuiz = useCallback(async () => {
//     if (!quiz || !isQuizComplete()) return;

//     try {
//       setLoading(true);
//       Swal.fire({
//         title: "Submitting Quiz",
//         html: `
//           <div class="d-flex justify-content-center">
//             <div class="spinner-border text-primary" role="status">
//               <span class="visually-hidden">Loading...</span>
//             </div>
//           </div>
//           <p class="mt-3">Evaluating your answers...</p>`,
//         allowOutsideClick: false,
//         showConfirmButton: false,
//       });

//       const formattedAnswers = Object.keys(answers).map((questionId) => ({
//         question: Number.parseInt(questionId),
//         selected_option: answers[questionId],
//       }));

//       const payload = {
//         quiz: quiz.id,
//         answers: formattedAnswers,
//       };

//       const url = `${API_BASE_URL}/quiz/quiz-submit/`;
//       console.log("Attempting to submit quiz to:", url);

//       const res = await axios.post(
//         url,
//         payload,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       console.log("DEBUG: Quiz results from API:", res.data);

//       setQuizSubmitted(true);
//       setQuizResults(res.data);
//       setLoading(false);
//       setSubmittedQuizzes((prev) => [...prev, activeLesson.subpart_id]);

//       const { result } = res.data;
//       const isPassed = result === "Passed";
//       setCanRetakeQuiz(!isPassed);
//       Swal.close();
//     } catch (error) {
//       console.error("Quiz submission failed. Full error:", error.response || error.request || error.message);
//       setLoading(false);
//       Swal.fire({
//         title: "Submission Failed",
//         text: "There was an error submitting your quiz. Please try again.",
//         icon: "error",
//         confirmButtonText: "Retry",
//         confirmButtonColor: colors.primary,
//       });
//     }
//   }, [
//     quiz,
//     isQuizComplete,
//     answers,
//     token,
//     colors.primary,
//     API_BASE_URL,
//     activeLesson,
//   ]);

//   const isLessonLocked = useCallback(
//     (checkPartIndex, checkSubpartIndex) => {
//       if (!course || !course.parts?.[checkPartIndex]) return true;
//       if (checkPartIndex === 0 && checkSubpartIndex === 0) return false;

//       let prevLessonComplete = false;
//       if (checkSubpartIndex > 0) {
//         prevLessonComplete =
//           course.parts[checkPartIndex].subparts?.[checkSubpartIndex - 1]
//             ?.is_complete ?? false;
//       } else if (checkPartIndex > 0) {
//         const prevPart = course.parts[checkPartIndex - 1];
//         prevLessonComplete =
//           prevPart?.subparts?.every((subpart) => subpart.is_complete) ?? false;
//       }
//       return !prevLessonComplete;
//     },
//     [course]
//   );

//   const handleLessonSelect = useCallback(
//     (partIndex, subpartId) => {
//       if (!course?.parts?.[partIndex]) return;

//       const selectedLesson = course.parts[partIndex].subparts?.find(
//         (s) => s.subpart_id === subpartId
//       );
//       const selectedLessonSubpartIndex = course.parts[
//         partIndex
//       ].subparts?.findIndex((s) => s.subpart_id === subpartId);

//       if (!selectedLesson || selectedLessonSubpartIndex === -1) return;

//       if (isLessonLocked(partIndex, selectedLessonSubpartIndex)) {
//         Swal.fire({
//           title: "Lesson Locked",
//           text: "Please complete the previous lesson to unlock this one.",
//           icon: "warning",
//           confirmButtonText: "Got it!",
//           confirmButtonColor: colors.primary,
//         });
//         return;
//       }

//       Swal.fire({
//         title: "Loading Lesson",
//         html: `<p class="mt-3">${selectedLesson.subpart_title}</p>`,
//         timer: 800,
//         timerProgressBar: true,
//         showConfirmButton: false,
//         willOpen: () => {
//           Swal.showLoading();
//         },
//       });

//       setActiveLesson({
//         ...selectedLesson,
//         title: selectedLesson.subpart_title,
//         content: selectedLesson.part_description || "No description available.",
//         video_url: selectedLesson.video || null,
//       });

//       setActivePartIndex(partIndex);
//       setShowQuiz(false);
//       setQuiz(null);
//       setQuizButtonEnabled(selectedLesson.is_complete);
//       setShowMobileMenu(false);
//     },
//     [course, isLessonLocked, colors.primary]
//   );

//   const moveToNextLesson = useCallback(() => {
//     if (!course || activePartIndex === null || !activeLesson) return;

//     if (!activeLesson.is_complete) {
//       Swal.fire({
//         title: "Complete Current Lesson",
//         text: "Please finish the current lesson's video before proceeding.",
//         icon: "info",
//         confirmButtonText: "OK",
//         confirmButtonColor: colors.primary,
//       });
//       return;
//     }

//     const currentPart = course.parts[activePartIndex];
//     const currentLessonIndex =
//       currentPart.subparts?.findIndex(
//         (l) => l.subpart_id === activeLesson.subpart_id
//       ) ?? -1;

//     if (
//       currentLessonIndex !== -1 &&
//       currentLessonIndex < (currentPart.subparts?.length || 0) - 1
//     ) {
//       const nextLesson = currentPart.subparts[currentLessonIndex + 1];
//       handleLessonSelect(activePartIndex, nextLesson.subpart_id);
//     } else if (activePartIndex < course.parts.length - 1) {
//       const nextPart = course.parts[activePartIndex + 1];
//       if (nextPart.subparts?.[0]) {
//         const nextLesson = nextPart.subparts[0];
//         handleLessonSelect(activePartIndex + 1, nextLesson.subpart_id);
//       }
//     } else {
//       Swal.fire({
//         title: "Course Completed!",
//         text: "Congratulations! You have finished all lessons in this course.",
//         icon: "success",
//         showCancelButton: true,
//         confirmButtonText: "View Certificate",
//         cancelButtonText: "Continue",
//         confirmButtonColor: colors.primary,
//         cancelButtonColor: colors.secondary,
//       }).then((result) => {
//         if (result.isConfirmed) {
//           fetchCertificate();
//         }
//       });
//     }
//   }, [
//     course,
//     activePartIndex,
//     activeLesson,
//     handleLessonSelect,
//     colors.primary,
//     colors.secondary,
//     fetchCertificate,
//   ]);

//   const moveToPreviousLesson = useCallback(() => {
//     if (!course || activePartIndex === null || !activeLesson) return;

//     const currentPart = course.parts[activePartIndex];
//     const currentLessonIndex =
//       currentPart.subparts?.findIndex(
//         (l) => l.subpart_id === activeLesson.subpart_id
//       ) ?? -1;

//     if (currentLessonIndex > 0) {
//       const prevLesson = currentPart.subparts[currentLessonIndex - 1];
//       handleLessonSelect(activePartIndex, prevLesson.subpart_id);
//     } else if (activePartIndex > 0) {
//       const prevPart = course.parts[activePartIndex - 1];
//       if (prevPart.subparts?.length > 0) {
//         const prevLesson = prevPart.subparts[prevPart.subparts.length - 1];
//         handleLessonSelect(activePartIndex - 1, prevLesson.subpart_id);
//       }
//     } else {
//       Swal.fire({
//         title: "First Lesson",
//         text: "You are at the beginning of the course.",
//         icon: "info",
//         confirmButtonColor: colors.primary,
//       });
//     }
//   }, [
//     course,
//     activePartIndex,
//     activeLesson,
//     handleLessonSelect,
//     colors.primary,
//   ]);

//   const handleVideoEnd = useCallback(() => {
//     if (!activeLesson || !course || activePartIndex === null) return;
//     if (activeLesson.is_complete) return;

//     Swal.fire({
//       title: "Saving Progress...",
//       allowOutsideClick: false,
//       didOpen: () => {
//         Swal.showLoading();
//       },
//     });

//     const formData = new FormData();
//     formData.append("is_complete", true);

//     const url = `${API_BASE_URL}/lms/subparts/${activeLesson.subpart_id}/`;
//     console.log("Attempting to mark video as complete at:", url);

//     axios
//       .patch(
//         url,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then(() => {
//         const updatedCourse = {
//           ...course,
//           parts: course.parts.map((part, pIdx) => {
//             if (pIdx !== activePartIndex) return part;
//             return {
//               ...part,
//               subparts:
//                 part.subparts?.map((subpart) =>
//                   subpart.subpart_id === activeLesson.subpart_id
//                     ? { ...subpart, is_complete: true }
//                     : subpart
//                 ) || [],
//             };
//           }),
//         };
//         setCourse(updatedCourse);
//         setActiveLesson((prev) => ({ ...prev, is_complete: true }));
//         setQuizButtonEnabled(
//           !submittedQuizzes.includes(activeLesson.subpart_id)
//         );

//         const currentPart = updatedCourse.parts[activePartIndex];
//         const allCompletedInCurrentPart = currentPart.subparts?.every(
//           (s) => s.is_complete
//         );

//         Swal.close();

//         if (allCompletedInCurrentPart) {
//           Swal.fire({
//             title: "Topic Completed!",
//             text: "Great work! You've completed all subtopic in this topic.",
//             icon: "success",
//             showCancelButton: true,
//             confirmButtonText: "Take Topic Quiz",
//             cancelButtonText: "Next Topic",
//             confirmButtonColor: colors.primary,
//             cancelButtonColor: colors.secondary,
//           }).then((result) => {
//             if (result.isConfirmed) {
//               fetchQuiz();
//               setShowQuizModal(true);
//             } else if (result.dismiss === Swal.DismissReason.cancel) {
//               setTimeout(() => moveToNextLesson(), 50);

//             }
//           });
//         } else {
//           Swal.fire({
//             title: "Subpart Completed!",
//             text: "You can now take the quiz or move to the next subtopic.",
//             icon: "success",
//             showCancelButton: true,
//             confirmButtonText: "Take Quiz",
//             cancelButtonText: "Next Subtopic",
//             confirmButtonColor: colors.primary,
//             cancelButtonColor: colors.secondary,
//           }).then((result) => {
//             if (result.isConfirmed) {
//               fetchQuiz();
//               setShowQuizModal(true);
//             } else if (result.dismiss === Swal.DismissReason.cancel) {
//               setTimeout(() => moveToNextLesson(), 50);

//             }
//           });
//         }
//       })
//       .catch((err) => {
//         console.error("Failed to update subtopic completion. Full error:", err.response || err.request || err.message);
//         Swal.fire({
//           title: "Update Error",
//           text: "Failed to save your progress. Please check your connection and try again.",
//           icon: "error",
//           confirmButtonText: "OK",
//           confirmButtonColor: colors.primary,
//         });
//       });
//   }, [
//     activeLesson,
//     activePartIndex,
//     course,
//     token,
//     colors,
//     fetchQuiz,
//     moveToNextLesson,
//     API_BASE_URL,
//     submittedQuizzes,
//   ]);

//   const handleVideoProgress = useCallback(
//     (progress) => {
//       setVideoProgress(progress);
//       if (progress >= 95 && !quizButtonEnabled && !activeLesson?.is_complete) {
//         setQuizButtonEnabled(true);
//         Swal.fire({
//           title: "Quiz Unlocked!",
//           text: "You can now take the quiz for this subtopic.",
//           icon: "info",
//           toast: true,
//           position: "top-end",
//           showConfirmButton: false,
//           timer: 3000,
//           timerProgressBar: true,
//         });
//       }
//     },
//     [quizButtonEnabled, activeLesson]
//   );

//   const handleNextQuestion = useCallback(() => {
//     if (
//       !quiz ||
//       !quiz.questions ||
//       currentQuestionIndex >= quiz.questions.length - 1
//     )
//       return;

//     const questionContainer = document.querySelector(".question-container");
//     if (questionContainer) {
//       questionContainer.classList.add("slide-out");
//       setTimeout(() => {
//         setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
//         setTimeout(() => {
//           questionContainer.classList.remove("slide-out");
//           questionContainer.classList.add("slide-in");
//           setTimeout(() => {
//             questionContainer.classList.remove("slide-in");
//           }, 500);
//         }, 50);
//       }, 300);
//     } else {
//       setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
//     }
//   }, [quiz, currentQuestionIndex]);

//   const handlePrevQuestion = useCallback(() => {
//     if (!quiz || !quiz.questions || currentQuestionIndex <= 0) return;

//     const questionContainer = document.querySelector(".question-container");
//     if (questionContainer) {
//       questionContainer.classList.add("slide-out-reverse");
//       setTimeout(() => {
//         setCurrentQuestionIndex((prevIndex) => prevIndex - 1);
//         setTimeout(() => {
//           questionContainer.classList.remove("slide-out-reverse");
//           questionContainer.classList.add("slide-in-reverse");
//           setTimeout(() => {
//             questionContainer.classList.remove("slide-in-reverse");
//           }, 500);
//         }, 50);
//       }, 300);
//     } else {
//       setCurrentQuestionIndex((prevIndex) => prevIndex - 1);
//     }
//   }, [quiz, currentQuestionIndex]);

//   const toggleBookmark = useCallback(
//     (lessonId) => {
//       const isBookmarked = bookmarkedLessons.includes(lessonId);
//       const updatedBookmarks = isBookmarked
//         ? bookmarkedLessons.filter((id) => id !== lessonId)
//         : [...bookmarkedLessons, lessonId];

//       Swal.fire({
//         title: isBookmarked ? "Bookmark Removed" : "Bookmark Added!",
//         icon: isBookmarked ? "info" : "success",
//         toast: true,
//         position: "top-end",
//         showConfirmButton: false,
//         timer: 2000,
//         timerProgressBar: true,
//       });

//       setBookmarkedLessons(updatedBookmarks);
//       localStorage.setItem(`bookmarks-${id}`, JSON.stringify(updatedBookmarks));
//     },
//     [bookmarkedLessons, id]
//   );

//   const togglePart = useCallback(
//     (partIndex) => {
//       setActivePartIndex((prevIndex) =>
//         prevIndex === partIndex ? null : partIndex
//       );
//     },
//     []
//   );

//   // Pause video when opening certificate or navigating away
//   const pauseVideo = useCallback(() => {
//     if (videoPlayerRef.current) {
//       videoPlayerRef.current.pause();
//     }
//   }, []);

//   // Handle certificate view with video pausing
//   const handleViewCertificate = useCallback(async () => {
//     pauseVideo(); // Pause video immediately

//     // Open a new tab immediately in response to the user's click
//     const newTab = window.open('', '_blank');

//     try {
//       setViewLoading(true);
//       if (!newTab) {
//         throw new Error('Popup blocked! Please allow popups for this site.');
//       }

//       const certificateUrl = `https://kaasbackend.vetrinahealthcare.com/master/certificate-v2/${id}/`;

//       const response = await fetch(certificateUrl, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(errorText || 'Failed to load certificate');
//       }

//       const blob = await response.blob();
//       const pdfUrl = URL.createObjectURL(blob);

//       // Load the PDF into the already opened tab
//       newTab.location.href = pdfUrl;

//       setTimeout(() => URL.revokeObjectURL(pdfUrl), 30000);

//     } catch (error) {
//       console.error("View certificate failed:", error);
//       // If an error occurs, you might want to close the blank tab
//       if (newTab) {
//         newTab.close();
//       }
//       Swal.fire({
//         title: 'View Failed',
//         text: error.message || 'Unable to load certificate. Please try downloading instead.',
//         icon: 'error',
//         confirmButtonColor: '#6366f1',
//       });
//     } finally {
//       setViewLoading(false);
//     }
//   }, [id, token, pauseVideo]);

//   // Handle certificate download with video pausing
//   const handleDownloadCertificate = useCallback(async () => {
//     pauseVideo(); // Pause video immediately

//     try {
//       setDownloadLoading(true);
//       const certificateUrl = `https://kaasbackend.vetrinahealthcare.com/master/certificate-v2/${id}/`;

//       const response = await fetch(certificateUrl, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(errorText || "Certificate not available yet!");
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `certificate_${course?.title || id}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);

//       Swal.fire({
//         title: 'Success!',
//         text: 'Certificate downloaded successfully!',
//         icon: 'success',
//         confirmButtonColor: '#10b981',
//         timer: 2000
//       });

//     } catch (error) {
//       console.error("Download failed:", error);
//       Swal.fire({
//         title: 'Download Failed',
//         text: error.message || 'Something went wrong while downloading the certificate.',
//         icon: 'error',
//         confirmButtonColor: '#6366f1',
//       });
//     } finally {
//       setDownloadLoading(false);
//     }
//   }, [id, token, course, pauseVideo]);

//   useEffect(() => {
//     if (!id) return;
//     setLoading(true);
//     Swal.fire({
//       title: "Loading Course...",
//       html: `<p>Please wait while we prepare your learning experience.</p>`,
//       allowOutsideClick: false,
//       didOpen: () => {
//         Swal.showLoading();
//       },
//     });

//     const url = `${API_BASE_URL}/lms/courses/${id}/`;
//     console.log("Attempting to fetch course data from:", url);

//     axios
//       .get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         const courseData = response.data;
//         setCourse(courseData);
//         setInstructor(courseData.display.is_instructor);
//         setEnrolled(courseData.display.is_enrolled);
//         setError(null);

//         let initialLesson = null;
//         let initialPartIndex = null;

//         if (courseData.parts) {
//           for (let pIdx = 0; pIdx < courseData.parts.length; pIdx++) {
//             const part = courseData.parts[pIdx];
//             if (part.subparts) {
//               const firstUncompleted = part.subparts.find(
//                 (subpart) => !subpart.is_complete
//               );
//               if (firstUncompleted) {
//                 initialLesson = firstUncompleted;
//                 initialPartIndex = pIdx;
//                 break;
//               }
//             }
//           }
//         }

//         if (!initialLesson && courseData.parts?.[0]?.subparts?.[0]) {
//           initialLesson = courseData.parts[0].subparts[0];
//           initialPartIndex = 0;
//         }

//         if (initialLesson && initialPartIndex !== null) {
//           setActiveLesson({
//             ...initialLesson,
//             title: initialLesson.subpart_title,
//             content:
//               initialLesson.part_description || "No description available.",
//             video_url: initialLesson.video || null,
//           });
//           setActivePartIndex(initialPartIndex);
//           setQuizButtonEnabled(initialLesson.is_complete);
//         }

//         setLoading(false);
//         Swal.close();
//         Swal.fire({
//           title: `Welcome to ${courseData.title}!`,
//           icon: "success",
//           confirmButtonText: "Start Learning",
//           confirmButtonColor: colors.primary,
//           timer: 2500,
//           timerProgressBar: true,
//         });
//       })
//       .catch((error) => {
//         console.error("Error fetching course data. Full error:", error.response || error.request || error.message);
//         setError("Failed to load the course. Please try again later.");
//         setLoading(false);
//         Swal.fire({
//           title: "Error Loading Course",
//           text: "We couldn't retrieve the course data. Please check your connection and refresh the page.",
//           icon: "error",
//           confirmButtonText: "Refresh",
//           confirmButtonColor: colors.primary,
//         }).then((result) => {
//           if (result.isConfirmed) {
//             window.location.reload();
//           }
//         });
//       });

//     const savedSubmittedQuizzes = localStorage.getItem(
//       `submittedQuizzes-${id}`
//     );
//     if (savedSubmittedQuizzes) {
//       setSubmittedQuizzes(JSON.parse(savedSubmittedQuizzes));
//     }
//     const savedBookmarks = localStorage.getItem(`bookmarks-${id}`);
//     if (savedBookmarks) {
//       setBookmarkedLessons(JSON.parse(savedBookmarks));
//     }
//   }, [id, token, colors.primary, API_BASE_URL]);

//   const totalLessons =
//     course?.parts?.reduce(
//       (sum, part) => sum + (part.subparts?.length || 0),
//       0
//     ) || 0;
//   const completedLessons =
//     course?.parts?.reduce(
//       (sum, part) =>
//         sum + (part.subparts?.filter((l) => l.is_complete).length || 0),
//       0
//     ) || 0;
//   const progress = totalLessons ? (completedLessons / totalLessons) * 100 : 0;

//   // Get recommendations for YouTube-style display
//   let nextLessonsInCurrentPart = [];
//   const otherSectionsLessons = [];

//   if (course && activePartIndex !== null && activeLesson) {
//     const currentPart = course.parts[activePartIndex];
//     const currentLessonIndex =
//       currentPart.subparts?.findIndex(
//         (s) => s.subpart_id === activeLesson.subpart_id
//       ) ?? -1;

//     if (currentLessonIndex !== -1) {
//       nextLessonsInCurrentPart =
//         currentPart.subparts?.slice(currentLessonIndex + 1) || [];
//     }

//     for (let pIdx = activePartIndex + 1; pIdx < course.parts.length; pIdx++) {
//       otherSectionsLessons.push(...(course.parts[pIdx].subparts || []));
//     }
//   }

//   if (loading) {
//     return (
//       <div
//         className="text-center py-5"
//         style={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         }}
//       >
//         <div>
//           {defaultLoadingAnimationData ? (
//             <Lottie
//               options={{
//                 loop: true,
//                 autoplay: true,
//                 animationData: defaultLoadingAnimationData,
//                 rendererSettings: {
//                   preserveAspectRatio: "xMidYMid slice",
//                 },
//               }}
//               height={200}
//               width={200}
//             />
//           ) : (
//             <Spinner
//               animation="border"
//               role="status"
//               style={{ color: colors.primary, width: "100px", height: "100px" }}
//             >
//               <span className="visually-hidden">Loading...</span>
//             </Spinner>
//           )}
//           <h4 className="mt-3 fw-bold" style={{ color: colors.primary }}>
//             Loading Your Course...
//           </h4>
//           <p className="text-muted">
//             Getting everything ready for your learning experience.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div
//         className="text-center py-5"
//         style={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         }}
//       >
//         <Alert variant="danger" className="text-center py-5 m-4 shadow-lg">
//           <h4 className="alert-heading">Oops! Something went wrong.</h4>
//           <p>
//             <SafeRender>{error}</SafeRender>
//           </p>
//           <hr />
//           <Button
//             variant="primary"
//             className="mt-3"
//             onClick={() => window.location.reload()}
//             style={{ background: colors.primary, border: "none" }}
//           >
//             Retry Loading
//           </Button>
//         </Alert>
//       </div>
//     );
//   }

//   if (!course) {
//     return (
//       <div
//         className="text-center py-5"
//         style={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         }}
//       >
//         <div>
//           <h4 className="mb-3">Course not found.</h4>
//           <Button
//             variant="primary"
//             onClick={() => navigate("/courses")}
//             style={{ background: colors.primary, border: "none" }}
//           >
//             Browse Other Courses
//           </Button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <Container
//       fluid
//       className="py-4"
//       style={{
//         background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         minHeight: "100vh",
//       }}
//     >
//       <style>
//         {`
//           .option-card.selected {
//             box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
//           }
//           .quiz-modal .modal-content {
//             border-radius: 1rem;
//             border: none;
//             overflow: hidden;
//           }
//           .video-controls {
//             background: linear-gradient(0deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 70%, transparent 100%);
//             opacity: 0;
//             transition: opacity 0.3s ease;
//           }
//           .video-container:hover .video-controls {
//             opacity: 1;
//           }
//           .form-range::-webkit-slider-thumb {
//             background: #6366f1;
//           }
//           .form-range::-moz-range-thumb {
//             background: #6366f1;
//           }
//           .form-range::-ms-thumb {
//             background: #6366f1;
//           }
//           .pulse-animation {
//             animation: pulse 0.5s;
//           }
//           @keyframes pulse {
//             0% { transform: scale(1); }
//             50% { transform: scale(1.05); }
//             100% { transform: scale(1); }
//           }
//           .slide-out { animation: slideOut 0.3s forwards; }
//           .slide-in { animation: slideIn 0.3s forwards; }
//           .slide-out-reverse { animation: slideOutReverse 0.3s forwards; }
//           .slide-in-reverse { animation: slideInReverse 0.3s forwards; }
//           @keyframes slideOut {
//             0% { transform: translateX(0); opacity: 1; }
//             100% { transform: translateX(-20px); opacity: 0; }
//           }
//           @keyframes slideIn {
//             0% { transform: translateX(20px); opacity: 0; }
//             100% { transform: translateX(0); opacity: 1; }
//           }
//           @keyframes slideOutReverse {
//             0% { transform: translateX(0); opacity: 1; }
//             100% { transform: translateX(20px); opacity: 0; }
//           }
//           @keyframes slideInReverse {
//             0% { transform: translateX(-20px); opacity: 0; }
//             100% { transform: translateX(0); opacity: 1; }
//           }
//           @media (max-width: 991.98px) {
//             .mobile-menu-button { display: flex !important; }
//             .desktop-course-structure { display: none !important; }
//             .course-content-column { order: 1; }
//             .sidebar-column { order: 2; }
//           }
//           /* YouTube-style Video Recommendations */
//           .youtube-recommendation { margin-bottom: 12px; }
//           .youtube-video-card {
//             display: flex;
//             align-items: flex-start;
//             padding: 12px;
//             cursor: pointer;
//             border-radius: 8px;
//             transition: background-color 0.2s ease, opacity 0.3s ease;
//             background: white;
//             border: 1px solid #e0e0e0;
//           }
//           .youtube-video-card:hover:not(.locked) {
//             background-color: #f8f9fa;
//             box-shadow: 0 2px 8px rgba(0,0,0,0.1);
//           }
//           .youtube-video-card.locked { opacity: 0.6; cursor: not-allowed; }
//           .youtube-video-card.active { background-color: #e3f2fd; border-color: #2196f3; }
//           .video-thumbnail {
//             width: 168px;
//             height: 94px;
//             background-color: #ddd;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             flex-shrink: 0;
//             margin-right: 12px;
//             border-radius: 8px;
//             overflow: hidden;
//             position: relative;
//           }
//           .video-thumbnail img { width: 100%; height: 100%; object-fit: cover; }
//           .placeholder-thumbnail {
//             width: 100%;
//             height: 100%;
//             background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }
//           .play-icon { color: white; font-size: 32px; }
//           .video-duration {
//             position: absolute;
//             bottom: 4px;
//             right: 4px;
//             background: rgba(0,0,0,0.8);
//             color: white;
//             padding: 2px 6px;
//             border-radius: 4px;
//             font-size: 12px;
//             font-weight: 500;
//           }
//           .video-info { flex-grow: 1; min-width: 0; }
//           .video-title {
//             font-size: 14px;
//             font-weight: 600;
//             margin-bottom: 4px;
//             line-height: 1.3;
//             color: #333;
//             display: -webkit-box;
//             -webkit-line-clamp: 2;
//             -webkit-box-orient: vertical;
//             overflow: hidden;
//           }
//           .video-meta { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
//           .video-section {
//             font-size: 12px;
//             color: #666;
//             background: #f0f0f0;
//             padding: 2px 6px;
//             border-radius: 4px;
//           }
//           .video-watched {
//             font-size: 12px;
//             color: #10b981;
//             background: #d1fae5;
//             padding: 2px 6px;
//             border-radius: 4px;
//           }
//           .description-toggle {
//             background: none;
//             border: none;
//             color: #666;
//             font-size: 12px;
//             cursor: pointer;
//             padding: 0;
//             text-decoration: underline;
//           }
//           .description-toggle:hover { color: #333; }
//           .video-description {
//             margin-top: 8px;
//             font-size: 12px;
//             color: #666;
//             line-height: 1.4;
//             display: -webkit-box;
//             -webkit-line-clamp: 3;
//             -webkit-box-orient: vertical;
//             overflow: hidden;
//           }
//           .video-status { margin-left: 12px; flex-shrink: 0; display: flex; align-items: center; }
//           .recommendations-section {
//             background: white;
//             border-radius: 12px;
//             overflow: hidden;
//             box-shadow: 0 2px 12px rgba(0,0,0,0.08);
//           }
//           .recommendations-header {
//             padding: 16px 20px;
//             background: #f8f9fa;
//             border-bottom: 1px solid #e9ecef;
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             cursor: pointer;
//             transition: background-color 0.2s ease;
//           }
//           .recommendations-header:hover { background: #e9ecef; }
//           .recommendations-title { font-size: 16px; font-weight: 600; margin: 0; color: #333; }
//           .recommendations-count { font-size: 14px; color: #666; margin-left: 8px; }
//           .recommendations-content { max-height: 400px; overflow-y: auto; }
//           .recommendations-content.collapsed { max-height: 0; overflow: hidden; }
//           @media (max-width: 768px) {
//             .video-thumbnail { width: 120px; height: 67px; }
//             .video-title { font-size: 13px; }
//             .youtube-video-card { padding: 10px; }
//           }
//           /* Certificate Styles */
//           .certificate-modal .modal-content {
//             border-radius: 1rem;
//             border: none;
//             overflow: hidden;
//           }
//           .certificate-preview {
//             transition: all 0.3s ease;
//           }
//           .certificate-preview:hover {
//             transform: translateY(-5px);
//             box-shadow: 0 25px 80px rgba(99, 102, 241, 0.4) !important;
//           }
//           .certificate-image {
//             max-width: 100%;
//             max-height: 600px;
//             border-radius: 8px;
//             box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
//           }
//             .lesson-content-truncated {
//   display: -webkit-box;
//   -webkit-line-clamp: 5; /* Show only 5 lines */
//   -webkit-box-orient: vertical;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   max-height: 7.5rem; /* Approx 5 lines * 1.5 line-height */
// }
//         `}
//       </style>

//       <Button
//         variant="primary"
//         className="mobile-menu-button d-lg-none d-none position-fixed"
//         style={{
//           top: "60px",
//           left: "10px",
//           zIndex: 1030,
//           background: colors.gradient,
//           borderRadius: "50%",
//           width: "50px",
//           height: "50px",
//           alignItems: "center",
//           justifyContent: "center",
//           boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//           border: "none",
//         }}
//         onClick={() => setShowMobileMenu(true)}
//       >
//         <i className="fas fa-bars"></i>
//       </Button>

//       <Row>
//         <Col lg={8} className="mb-4 course-content-column">
//           <Card className="shadow-lg border-0 rounded-4 overflow-hidden">
//             <Card.Body className="p-0">
//               {activeLesson ? (
//                 <>
//                   <div className="position-relative">
//                     {activeLesson.video_url ? (
//                       <CustomVideoPlayer
//                         ref={videoPlayerRef}
//                         videoUrl={activeLesson.video_url}
//                         onEnd={handleVideoEnd}
//                         onProgress={handleVideoProgress}
//                         subpartId={activeLesson.subpart_id}
//                         token={token}
//                         API_BASE_URL={API_BASE_URL}
//                       />
//                     ) : (
//                       <div
//                         className="text-center py-5 bg-dark text-white"
//                         style={{
//                           aspectRatio: "16 / 9",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <p className="mb-0">
//                           No video available for this lesson.
//                         </p>
//                       </div>
//                     )}
//                   </div>

//                   <div className="p-4">
//                     <motion.div
//                       className="d-flex justify-content-between align-items-center mb-3"
//                       initial={{ opacity: 0, y: 20 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.5 }}
//                     >
//                       <h4 className="fw-bold mb-0">
//                         <SafeRender>{activeLesson.title}</SafeRender>
//                       </h4>
//                       <Button
//                         variant="link"
//                         className="p-0 text-decoration-none"
//                         onClick={() => toggleBookmark(activeLesson.subpart_id)}
//                       >
//                         {bookmarkedLessons.includes(activeLesson.subpart_id) ? (
//                           <BsBookmarkFill size={20} className="text-warning" />
//                         ) : (
//                           <BsBookmark size={20} />
//                         )}
//                       </Button>
//                     </motion.div>


//                     <motion.div
//                       className="mb-4"
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       transition={{ duration: 0.5, delay: 0.2 }}
//                     >
//                       <div
//                         className={`text-muted lesson-content ${!showFullContent ? 'lesson-content-truncated' : ''}`}
//                         style={{
//                           lineHeight: '1.6',
//                           fontSize: '1rem',
//                           whiteSpace: 'pre-line',
//                         }}
//                       >
//                         <SafeRender>{activeLesson.content}</SafeRender>
//                       </div>

//                       {activeLesson.content && (
//                         (() => {
//                           const wordCount = activeLesson.content.split(/\s+/).length;
//                           const charCount = activeLesson.content.length;
//                           const needsTruncation = wordCount > 100 || charCount > 500;

//                           if (needsTruncation) {
//                             return (
//                               <Button
//                                 variant="link"
//                                 onClick={() => setShowFullContent(!showFullContent)}
//                                 className="p-0 mt-2 text-decoration-none d-flex align-items-center"
//                                 style={{
//                                   fontSize: '0.875rem',
//                                   fontWeight: '600',
//                                   color: colors.primary,
//                                 }}
//                               >
//                                 {showFullContent ? (
//                                   <>
//                                     <BsChevronUp className="me-1" size={12} />
//                                     Show Less
//                                   </>
//                                 ) : (
//                                   <>
//                                     <BsChevronDown className="me-1" size={12} />
//                                     Show More
//                                   </>
//                                 )}
//                                 <small className="text-muted ms-2">
//                                   ({wordCount} words)
//                                 </small>
//                               </Button>
//                             );
//                           }
//                           return null;
//                         })()
//                       )}
//                     </motion.div>

//                     <motion.div
//                       className="d-flex justify-content-between mt-4"
//                       initial={{ opacity: 0, y: 20 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.5, delay: 0.3 }}
//                     >
//                       <Button
//                         variant="outline-secondary"
//                         onClick={moveToPreviousLesson}
//                         disabled={
//                           activePartIndex === 0 &&
//                           course.parts[0]?.subparts?.[0]?.subpart_id ===
//                           activeLesson.subpart_id
//                         }
//                         className="d-flex align-items-center"
//                       >
//                         <BsArrowLeft className="me-2" /> Previous Lesson
//                       </Button>

//                       <div className="d-flex gap-2">
//                         <Button
//                           variant="primary"
//                           onClick={() => {
//                             pauseVideo(); // Pause video when opening quiz
//                             fetchQuiz();
//                             setShowQuizModal(true);
//                           }}
//                           disabled={
//                             !quizButtonEnabled ||
//                             submittedQuizzes.includes(activeLesson.subpart_id)
//                           }
//                           style={{
//                             background:
//                               quizButtonEnabled &&
//                                 !submittedQuizzes.includes(
//                                   activeLesson.subpart_id
//                                 )
//                                 ? colors.gradient
//                                 : "#ccc",
//                             border: "none",
//                             transition: "all 0.3s ease",
//                           }}
//                           className={
//                             quizButtonEnabled &&
//                               !submittedQuizzes.includes(activeLesson.subpart_id)
//                               ? "pulse-animation"
//                               : ""
//                           }
//                         >
//                           {submittedQuizzes.includes(activeLesson.subpart_id)
//                             ? "Quiz Completed"
//                             : "Solve Quiz"}
//                         </Button>

//                         <Button
//                           variant="success"
//                           onClick={moveToNextLesson}
//                           className="d-flex align-items-center"
//                         >
//                           Next Lesson <BsArrowRight className="ms-2" />
//                         </Button>
//                       </div>
//                     </motion.div>
//                   </div>
//                 </>
//               ) : (
//                 <div className="text-center p-5">
//                   <h3 className="fw-bold">
//                     <SafeRender>{course.title}</SafeRender>
//                   </h3>
//                   <p className="text-muted">
//                     <SafeRender>{course.description}</SafeRender>
//                   </p>
//                   <p className="text-muted">
//                     Select a lesson from the course structure to start learning.
//                   </p>
//                 </div>
//               )}
//             </Card.Body>
//           </Card>

//           {(nextLessonsInCurrentPart.length > 0 ||
//             otherSectionsLessons.length > 0) && (
//               <div className="mt-4">
//                 {nextLessonsInCurrentPart.length > 0 && (
//                   <div className="recommendations-section mb-4">
//                     <div
//                       className="recommendations-header"
//                       onClick={() =>
//                         setExpandedVideoSection((prev) => ({
//                           ...prev,
//                           upNext: !prev.upNext,
//                         }))
//                       }
//                     >
//                       <div className="d-flex align-items-center">
//                         <h5 className="recommendations-title">Up Next</h5>
//                         <span className="recommendations-count">
//                           ({nextLessonsInCurrentPart.length})
//                         </span>
//                       </div>
//                       {expandedVideoSection.upNext ? (
//                         <BsChevronUp />
//                       ) : (
//                         <BsChevronDown />
//                       )}
//                     </div>
//                     <AnimatePresence>
//                       {expandedVideoSection.upNext && (
//                         <motion.div
//                           className="recommendations-content"
//                           initial={{ height: 0, opacity: 0 }}
//                           animate={{ height: "auto", opacity: 1 }}
//                           exit={{ height: 0, opacity: 0 }}
//                           transition={{ duration: 0.3 }}
//                         >
//                           {nextLessonsInCurrentPart.map((lesson) => {
//                             const subpartActualIndex =
//                               course.parts[activePartIndex].subparts?.findIndex(
//                                 (s) => s.subpart_id === lesson.subpart_id
//                               ) ?? -1;
//                             const locked = isLessonLocked(
//                               activePartIndex,
//                               subpartActualIndex
//                             );

//                             return (
//                               <VideoRecommendation
//                                 key={lesson.subpart_id}
//                                 lesson={lesson}
//                                 partIndex={activePartIndex}
//                                 isLocked={locked}
//                                 handleLessonSelect={handleLessonSelect}
//                                 isActive={
//                                   activeLesson?.subpart_id === lesson.subpart_id
//                                 }
//                                 isComplete={lesson.is_complete}
//                                 API_BASE_URL={API_BASE_URL}
//                                 duration={lesson.duration}
//                               />
//                             );
//                           })}
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </div>
//                 )}

//                 {otherSectionsLessons.length > 0 && (
//                   <div className="recommendations-section">
//                     <div
//                       className="recommendations-header"
//                       onClick={() =>
//                         setExpandedVideoSection((prev) => ({
//                           ...prev,
//                           otherSections: !prev.otherSections,
//                         }))
//                       }
//                     >
//                       <div className="d-flex align-items-center">
//                         <h5 className="recommendations-title">
//                           More from this Course
//                         </h5>
//                         <span className="recommendations-count">
//                           ({otherSectionsLessons.length})
//                         </span>
//                       </div>
//                       {expandedVideoSection.otherSections ? (
//                         <BsChevronUp />
//                       ) : (
//                         <BsChevronDown />
//                       )}
//                     </div>
//                     <AnimatePresence>
//                       {expandedVideoSection.otherSections && (
//                         <motion.div
//                           className="recommendations-content"
//                           initial={{ height: 0, opacity: 0 }}
//                           animate={{ height: "auto", opacity: 1 }}
//                           exit={{ height: 0, opacity: 0 }}
//                           transition={{ duration: 0.3 }}
//                         >
//                           {otherSectionsLessons.slice(0, 10).map((lesson) => {
//                             let partActualIndex = -1;
//                             let subpartActualIndex = -1;

//                             for (
//                               let pIdx = activePartIndex + 1;
//                               pIdx < course.parts.length;
//                               pIdx++
//                             ) {
//                               const foundIndex = course.parts[
//                                 pIdx
//                               ].subparts?.findIndex(
//                                 (s) => s.subpart_id === lesson.subpart_id
//                               );
//                               if (foundIndex !== -1 && foundIndex !== undefined) {
//                                 partActualIndex = pIdx;
//                                 subpartActualIndex = foundIndex;
//                                 break;
//                               }
//                             }

//                             const locked = isLessonLocked(
//                               partActualIndex,
//                               subpartActualIndex
//                             );

//                             return (
//                               <VideoRecommendation
//                                 key={lesson.subpart_id}
//                                 lesson={lesson}
//                                 partIndex={partActualIndex}
//                                 isLocked={locked}
//                                 handleLessonSelect={handleLessonSelect}
//                                 isActive={
//                                   activeLesson?.subpart_id === lesson.subpart_id
//                                 }
//                                 isComplete={lesson.is_complete}
//                                 API_BASE_URL={API_BASE_URL}
//                                 duration="8:45"
//                               />
//                             );
//                           })}
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </div>
//                 )}
//               </div>
//             )}

//           <Card className="shadow-sm border-0 rounded-4 mt-4 p-3">
//             <Card.Body>
//               <motion.div
//                 className="d-flex justify-content-between align-items-center mb-3"
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ duration: 0.5 }}
//               >
//                 <h5 className="fw-bold mb-0">Your Progress</h5>
//                 <div className="d-flex align-items-center gap-2">
//                   <Badge
//                     bg="primary"
//                     pill
//                     style={{ background: colors.gradient }}
//                   >
//                     {completedLessons} of {totalLessons} lessons completed
//                   </Badge>

//                   {/* Certificate Button */}
//                   {/* {isCourseCompleted() && (
//                     <Button
//                       variant="success"
//                       size="sm"
//                       className="d-flex align-items-center"
//                       onClick={fetchCertificate}
//                       disabled={fetchingCertificate}
//                       style={{
//                         background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
//                         border: 'none'
//                       }}
//                     >
//                       {fetchingCertificate ? (
//                         <>
//                           <Spinner animation="border" size="sm" className="me-1" />
//                           Loading...
//                         </>
//                       ) : (
//                         <>
//                           <BsEye className="me-1" />
//                           View Certificate
//                         </>
//                       )}
//                     </Button>
//                   )} */}
//                 </div>
//               </motion.div>

//               <motion.div
//                 className="d-flex align-items-center flex-wrap"
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: 0.2 }}
//               >
//                 <CircularProgress percentage={progress} />
//                 <div className="ms-4 flex-grow-1">
//                   <ProgressBar
//                     now={progress}
//                     className="mb-2"
//                     style={{ height: "10px", background: "#e9ecef" }}
//                     variant="primary"
//                   />
//                   <div className="d-flex justify-content-between text-muted small">
//                     <span>Course Progress</span>
//                     <span>{Math.round(progress)}% Complete</span>
//                   </div>

//                   {progress >= 25 && (
//                     <div className="mt-3">
//                       <h6 className="fw-bold">Achievement Unlocked!</h6>
//                       <div className="d-flex align-items-center">
//                         <div
//                           className="me-2 rounded-circle d-flex align-items-center justify-content-center"
//                           style={{
//                             width: "30px",
//                             height: "30px",
//                             background: colors.gradient,
//                             color: "white",
//                           }}
//                         >
//                           <BsCheckCircleFill />
//                         </div>
//                         <span>
//                           {progress >= 75
//                             ? "Course Expert"
//                             : progress >= 50
//                               ? "Halfway Hero"
//                               : "Getting Started"}
//                         </span>
//                       </div>
//                     </div>
//                   )}

//                   {/* Course Completion Message */}
//                   {isCourseCompleted() && (
//                     <motion.div
//                       className="mt-3 p-3 rounded"
//                       initial={{ opacity: 0, scale: 0.9 }}
//                       animate={{ opacity: 1, scale: 1 }}
//                       style={{
//                         background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
//                         border: '2px solid #10b981'
//                       }}
//                     >
//                       <div className="d-flex align-items-center">
//                         <BsCheckCircleFill className="text-success me-2" size={24} />
//                         <div>
//                           <h6 className="fw-bold mb-1 text-success">Course Completed! 🎉</h6>
//                           <p className="mb-2 text-success">
//                             Congratulations! You've completed all lessons. You can now view or download your certificate.
//                           </p>

//                           <div className="mt-2">
//                             <button
//                               onClick={handleViewCertificate}
//                               disabled={viewLoading || downloadLoading}
//                               className="btn btn-outline-success btn-sm me-2"
//                             >
//                               {viewLoading ? (
//                                 <>
//                                   <Spinner animation="border" size="sm" className="me-1" />
//                                   Loading...
//                                 </>
//                               ) : (
//                                 'View Certificate'
//                               )}
//                             </button>

//                             <button
//                               onClick={handleDownloadCertificate}
//                               disabled={viewLoading || downloadLoading}
//                               className="btn btn-success btn-sm"
//                             >
//                               {downloadLoading ? (
//                                 <>
//                                   <Spinner animation="border" size="sm" className="me-1" />
//                                   Downloading...
//                                 </>
//                               ) : (
//                                 'Download Certificate'
//                               )}
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     </motion.div>
//                   )}
//                 </div>
//               </motion.div>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col lg={4} className="sidebar-column">
//           <Card className="shadow-lg border-0 rounded-4 overflow-hidden desktop-course-structure">
//             <Card.Header
//               className="border-0 d-flex justify-content-between align-items-center py-3"
//               style={{ background: colors.gradient, color: colors.white }}
//             >
//               <h5 className="fw-bold mb-0">Course Structure</h5>
//               {isInstructor && (
//                 <BsPlusCircle
//                   size={24}
//                   style={{ cursor: "pointer" }}
//                   onClick={() =>
//                     navigate(`/addcourseinfo/${id}?view=curriculum`)
//                   }
//                 />
//               )}
//             </Card.Header>
//             <ListGroup
//               variant="flush"
//               className="course-structure"
//               style={{ maxHeight: "600px", overflowY: "auto" }}
//             >
//               {course.parts?.map((part, partIndex) => (
//                 <div key={part.part_id}>
//                   <ListGroup.Item
//                     action
//                     className={`fw-bold d-flex justify-content-between align-items-center border-0 ${activePartIndex === partIndex
//                       ? "text-primary"
//                       : "text-dark"
//                       }`}
//                     onClick={() => togglePart(partIndex)}
//                     style={{
//                       cursor: "pointer",
//                       backgroundColor:
//                         activePartIndex === partIndex ? "#f0f4ff" : "#ffffff",
//                       padding: "1rem",
//                     }}
//                   >
//                     <div className="d-flex align-items-center">
//                       <div
//                         className="me-2 rounded-circle d-flex align-items-center justify-content-center"
//                         style={{
//                           width: "28px",
//                           height: "28px",
//                           background:
//                             activePartIndex === partIndex
//                               ? colors.primary
//                               : "#e9ecef",
//                           color:
//                             activePartIndex === partIndex ? "white" : "black",
//                         }}
//                       >
//                         {partIndex + 1}
//                       </div>
//                       <SafeRender>{part.part_title}</SafeRender>
//                     </div>
//                     {activePartIndex === partIndex ? (
//                       <BsChevronUp />
//                     ) : (
//                       <BsChevronDown />
//                     )}
//                   </ListGroup.Item>
//                   <AnimatePresence>
//                     {activePartIndex === partIndex && (
//                       <motion.div
//                         initial={{ height: 0, opacity: 0 }}
//                         animate={{ height: "auto", opacity: 1 }}
//                         exit={{ height: 0, opacity: 0 }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         {part.subparts?.map((lesson, lessonIndex) => {
//                           const locked = isLessonLocked(partIndex, lessonIndex);
//                           return (
//                             <ListGroup.Item
//                               key={lesson.subpart_id}
//                               action
//                               active={
//                                 activeLesson?.subpart_id === lesson.subpart_id
//                               }
//                               className={`border-0 py-3 px-4 ${locked ? "text-muted" : ""
//                                 }`}
//                               onClick={() =>
//                                 !locked &&
//                                 handleLessonSelect(partIndex, lesson.subpart_id)
//                               }
//                               style={{
//                                 cursor: locked ? "not-allowed" : "pointer",
//                                 backgroundColor:
//                                   activeLesson?.subpart_id === lesson.subpart_id
//                                     ? colors.primary + "20"
//                                     : lesson.is_complete
//                                       ? colors.success + "20"
//                                       : "white",
//                                 color: activeLesson?.subpart_id === lesson.subpart_id
//                                   ? colors.primary  // Add this line - change to your preferred color
//                                   : "inherit",
//                                 borderLeft:
//                                   activeLesson?.subpart_id === lesson.subpart_id
//                                     ? `4px solid ${colors.primary}`
//                                     : lesson.is_complete
//                                       ? `4px solid ${colors.success}`
//                                       : "4px solid transparent",
//                                 transition: "all 0.2s ease",
//                               }}
//                             >
//                               <div className="d-flex justify-content-between align-items-center">
//                                 <div className="d-flex align-items-center">
//                                   <div
//                                     className="me-3 rounded-circle d-flex align-items-center justify-content-center"
//                                     style={{
//                                       width: "24px",
//                                       height: "24px",
//                                       background: lesson.is_complete
//                                         ? colors.success
//                                         : "#e9ecef",
//                                       color: lesson.is_complete
//                                         ? "white"
//                                         : "black",
//                                     }}
//                                   >
//                                     {lesson.is_complete ? (
//                                       <BsCheck2Circle size={14} />
//                                     ) : locked ? (
//                                       <BsLockFill size={12} />
//                                     ) : (
//                                       lessonIndex + 1
//                                     )}
//                                   </div>
//                                   <p className="mb-0 fw-medium small">
//                                     <SafeRender>{lesson.subpart_title}</SafeRender>
//                                   </p>
//                                 </div>
//                                 {bookmarkedLessons.includes(
//                                   lesson.subpart_id
//                                 ) && (
//                                     <BsBookmarkFill className="text-warning" />
//                                   )}
//                               </div>
//                             </ListGroup.Item>
//                           );
//                         })}
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </div>
//               ))}
//             </ListGroup>
//           </Card>

//           {/* Certificate Quick Access Card */}
//           {isCourseCompleted() && (
//             <Card className="shadow-lg border-0 rounded-4 overflow-hidden mt-4">
//               <Card.Header
//                 className="border-0 text-center py-3"
//                 style={{ background: colors.gradient, color: colors.white }}
//               >
//                 <h5 className="fw-bold mb-0">
//                   <BsCheckCircleFill className="me-2" />
//                   Course Completed
//                 </h5>
//               </Card.Header>
//               <Card.Body className="text-center p-4">
//                 <div className="mb-3">
//                   <BsCheckCircleFill size={48} className="text-success" />
//                 </div>
//                 <h6 className="fw-bold text-success mb-2">
//                   Congratulations! 🎉
//                 </h6>
//                 <p className="text-muted mb-3">
//                   You have successfully completed this course. Get your certificate now!
//                 </p>

//                 <div className="d-grid gap-2">
//                   <Button
//                     variant="outline-primary"
//                     onClick={handleViewCertificate}
//                     disabled={viewLoading || downloadLoading}
//                     className="d-flex align-items-center justify-content-center"
//                   >
//                     {viewLoading ? (
//                       <>
//                         <Spinner animation="border" size="sm" className="me-2" />
//                         Loading...
//                       </>
//                     ) : (
//                       <>
//                         <BsEye className="me-2" />
//                         View Certificate
//                       </>
//                     )}
//                   </Button>

//                   <Button
//                     variant="primary"
//                     onClick={handleDownloadCertificate}
//                     disabled={viewLoading || downloadLoading}
//                     className="d-flex align-items-center justify-content-center"
//                     style={{ background: colors.gradient, border: 'none' }}
//                   >
//                     {downloadLoading ? (
//                       <>
//                         <Spinner animation="border" size="sm" className="me-2" />
//                         Downloading...
//                       </>
//                     ) : (
//                       <>
//                         <BsDownload className="me-2" />
//                         Download Certificate
//                       </>
//                     )}
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           )}
//         </Col>
//       </Row>

//       <QuizModal
//         show={showQuizModal}
//         onHide={() => setShowQuizModal(false)}
//         quiz={quiz}
//         quizSubmitted={quizSubmitted}
//         quizResults={quizResults}
//         currentQuestionIndex={currentQuestionIndex}
//         answers={answers}
//         colors={colors}
//         handleOptionChange={handleOptionChange}
//         handlePrevQuestion={handlePrevQuestion}
//         handleNextQuestion={handleNextQuestion}
//         handleSubmitQuiz={handleSubmitQuiz}
//         isQuizComplete={isQuizComplete}
//         retakeQuiz={retakeQuiz}
//       />
//       <QuizOffcanvas
//         show={showOffcanvas}
//         onHide={() => setShowOffcanvas(false)}
//         quiz={quiz}
//         quizSubmitted={quizSubmitted}
//         quizResults={quizResults}
//         currentQuestionIndex={currentQuestionIndex}
//         answers={answers}
//         colors={colors}
//         handleOptionChange={handleOptionChange}
//         handlePrevQuestion={handlePrevQuestion}
//         handleNextQuestion={handleNextQuestion}
//         handleSubmitQuiz={handleSubmitQuiz}
//         isQuizComplete={isQuizComplete}
//         retakeQuiz={retakeQuiz}
//       />
//       <MobileMenuOffcanvas
//         show={showMobileMenu}
//         onHide={() => setShowMobileMenu(false)}
//         course={course}
//         colors={colors}
//         activePartIndex={activePartIndex}
//         togglePart={togglePart}
//         activeLesson={activeLesson}
//         isLessonLocked={isLessonLocked}
//         handleLessonSelect={handleLessonSelect}
//         bookmarkedLessons={bookmarkedLessons}
//       />

//       {/* Certificate Modal */}
//       <CertificateModal
//         show={showCertificateModal}
//         onHide={() => setShowCertificateModal(false)}
//         certificateData={certificateData}
//         course={course}
//         userName={userName}
//         certificateImageUrl={certificateImageUrl}
//       />
//     </Container>
//   );
// }

  import React from "react";

  import {
    useState,
    useEffect,
    useRef,
    useCallback,
    memo,
    forwardRef,
    useImperativeHandle,
  } from "react";
  import {
    Container,
    Row,
    Col,
    Card,
    Button,
    Alert,
    ListGroup,
    Badge,
    Spinner,
    Offcanvas,
    ProgressBar,
    Modal,
  } from "react-bootstrap";
  import {
    BsPlusCircle,
    BsChevronUp,
    BsChevronDown,
    BsCheck2Circle,
    BsArrowLeft,
    BsArrowRight,
    BsCheckCircleFill,
    BsBookmark,
    BsBookmarkFill,
    BsPlayFill,
    BsPauseFill,
    BsFullscreen,
    BsVolumeUp,
    BsVolumeMute,
    BsSkipForward,
    BsSkipBackward,
    BsArrowRepeat,
    BsFullscreenExit,
    BsLockFill,
    BsDownload,
    BsEye,
    BsImage,
    BsClipboardX,
  } from "react-icons/bs";
  import { motion, AnimatePresence } from "framer-motion";
  import axios from "axios";
  import { useParams, useNavigate } from "react-router-dom";
  import Swal from "sweetalert2";
  import Lottie from "react-lottie";
  import html2canvas from "html2canvas";
  import jsPDF from "jspdf";

  // Safe Render Component to prevent object rendering errors
  const SafeRender = ({ children, fallback = null }) => {
    try {
      if (children == null) {
        return fallback;
      }

      if (typeof children === 'object' && !React.isValidElement(children)) {
        console.warn('Attempted to render object:', children);
        return fallback || <span>[Content]</span>;
      }

      return children;
    } catch (error) {
      console.error('Rendering error:', error);
      return fallback || <span>Error rendering content</span>;
    }
  };

  // IMPORTANT: Replace these with actual imported Lottie JSON data or set to null
  const defaultLoadingAnimationData = null;
  const defaultSuccessAnimationData = null;
  const defaultConfettiAnimationData = null;

  // Lottie animation options - only create if animation data exists
  const defaultOptions = defaultLoadingAnimationData ? {
    loop: true,
    autoplay: true,
    animationData: defaultLoadingAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  } : null;

  const successOptions = defaultSuccessAnimationData ? {
    loop: false,
    autoplay: true,
    animationData: defaultSuccessAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  } : null;

  const confettiOptions = defaultConfettiAnimationData ? {
    loop: false,
    autoplay: true,
    animationData: defaultConfettiAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  } : null;

  // Certificate Modal Component
  const CertificateModal = memo(({
    show,
    onHide,
    certificateData,
    course,
    userName = "Student",
    certificateImageUrl
  }) => {
    const certificateRef = useRef(null);
    const [downloading, setDownloading] = useState(false);
    const [imageLoading, setImageLoading] = useState(true);
    const [imageError, setImageError] = useState(false);

    const downloadCertificate = async (format = 'png') => {
      if (!certificateImageUrl) {
        Swal.fire({
          title: 'Download Failed',
          text: 'Certificate image not available for download.',
          icon: 'error',
          confirmButtonColor: '#6366f1',
        });
        return;
      }

      setDownloading(true);

      try {
        if (format === 'png') {
          // Direct download for PNG
          const link = document.createElement('a');
          link.download = `certificate-${course?.title || 'course'}.png`;
          link.href = certificateImageUrl;
          link.click();
        } else {
          // For PDF, we need to create from the image
          const response = await fetch(certificateImageUrl);
          const blob = await response.blob();
          const imgData = URL.createObjectURL(blob);

          const pdf = new jsPDF('landscape', 'mm', 'a4');
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();

          // Add image to PDF
          pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
          pdf.save(`certificate-${course?.title || 'course'}.pdf`);
        }

        Swal.fire({
          title: 'Success!',
          text: `Certificate downloaded as ${format.toUpperCase()}`,
          icon: 'success',
          confirmButtonColor: '#6366f1',
        });
      } catch (error) {
        console.error('Download error:', error);
        Swal.fire({
          title: 'Download Failed',
          text: 'Failed to download certificate. Please try again.',
          icon: 'error',
          confirmButtonColor: '#6366f1',
        });
      } finally {
        setDownloading(false);
      }
    };

    const handleImageLoad = () => {
      setImageLoading(false);
      setImageError(false);
    };

    const handleImageError = () => {
      setImageLoading(false);
      setImageError(true);
    };

    return (
      <Modal
        show={show}
        onHide={onHide}
        centered
        size="xl"
        backdrop="static"
        className="certificate-modal"
      >
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', color: 'white' }}>
          <Modal.Title>
            <div className="d-flex align-items-center">
              <BsCheckCircleFill className="me-2" size={24} />
              Course Certificate
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="text-center mb-4">
            <h4 className="fw-bold text-primary">Congratulations!</h4>
            <p className="text-muted">
              You have successfully completed the course and earned this certificate.
            </p>
          </div>

          {/* Certificate Preview */}
          <div className="certificate-container mb-4">
            <div
              ref={certificateRef}
              className="certificate-preview text-center"
              style={{
                background: '#ffffff',
                border: '1px solid #e0e0e0',
                borderRadius: '10px',
                padding: '20px',
                position: 'relative',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                minHeight: '500px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {certificateImageUrl ? (
                <>
                  {imageLoading && (
                    <div className="text-center py-5">
                      <Spinner animation="border" variant="primary" />
                      <p className="mt-2 text-muted">Loading certificate...</p>
                    </div>
                  )}

                  {imageError ? (
                    <div className="text-center py-5">
                      <BsImage size={48} className="text-muted mb-3" />
                      <h5 className="text-muted">Failed to load certificate image</h5>
                      <p className="text-muted">Please try again later.</p>
                    </div>
                  ) : (
                    <img
                      src={certificateImageUrl}
                      alt="Course Certificate"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '600px',
                        borderRadius: '8px',
                        display: imageLoading ? 'none' : 'block'
                      }}
                      onLoad={handleImageLoad}
                      onError={handleImageError}
                    />
                  )}
                </>
              ) : (
                // Fallback certificate design if no image is available
                <div className="fallback-certificate text-center">
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%)',
                      border: '15px solid #6366f1',
                      borderRadius: '10px',
                      padding: '30px',
                      minHeight: '400px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <h1
                      style={{
                        color: '#6366f1',
                        fontSize: '2rem',
                        fontWeight: 'bold',
                        marginBottom: '20px',
                        textTransform: 'uppercase'
                      }}
                    >
                      Certificate of Completion
                    </h1>

                    <div
                      style={{
                        height: '3px',
                        background: 'linear-gradient(90deg, transparent, #6366f1, transparent)',
                        margin: '20px auto',
                        width: '200px'
                      }}
                    />

                    <div className="mb-4">
                      <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '10px' }}>
                        This is to certify that
                      </p>
                      <h2
                        style={{
                          color: '#1f2937',
                          fontSize: '1.8rem',
                          fontWeight: 'bold',
                          margin: '20px 0',
                          textTransform: 'uppercase'
                        }}
                      >
                        {userName}
                      </h2>
                      <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '20px' }}>
                        has successfully completed the course
                      </p>
                      <h3
                        style={{
                          color: '#6366f1',
                          fontSize: '1.3rem',
                          fontWeight: 'bold',
                          margin: '20px 0',
                          fontStyle: 'italic'
                        }}
                      >
                        "{course?.title || 'Course'}"
                      </h3>
                    </div>

                    <div className="mt-4">
                      <div
                        style={{
                          height: '2px',
                          background: 'linear-gradient(90deg, transparent, #8b5cf6, transparent)',
                          margin: '30px auto',
                          width: '300px'
                        }}
                      />
                      <div className="row text-center">
                        <div className="col-6">
                          <div style={{ borderTop: '2px solid #6366f1', paddingTop: '10px' }}>
                            <p style={{ margin: 0, fontWeight: 'bold', color: '#1f2937' }}>
                              Date Completed
                            </p>
                            <p style={{ margin: 0, color: '#666' }}>
                              {new Date().toLocaleDateString()}
                            </p>
                          </div>
                        </div>
                        <div className="col-6">
                          <div style={{ borderTop: '2px solid #6366f1', paddingTop: '10px' }}>
                            <p style={{ margin: 0, fontWeight: 'bold', color: '#1f2937' }}>
                              Certificate ID
                            </p>
                            <p style={{ margin: 0, color: '#666', fontFamily: 'monospace' }}>
                              CERT-{Date.now()}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Download Options */}
          <div className="text-center">
            <p className="text-muted mb-3">
              Download your certificate in your preferred format
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Button
                variant="outline-primary"
                onClick={() => downloadCertificate('png')}
                disabled={downloading || !certificateImageUrl || imageError}
                className="d-flex align-items-center"
              >
                <BsDownload className="me-2" />
                {downloading ? 'Downloading...' : 'Download PNG'}
              </Button>
              <Button
                variant="primary"
                onClick={() => downloadCertificate('pdf')}
                disabled={downloading || !certificateImageUrl || imageError}
                className="d-flex align-items-center"
                style={{ background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', border: 'none' }}
              >
                <BsDownload className="me-2" />
                {downloading ? 'Downloading...' : 'Download PDF'}
              </Button>
            </div>

            {(!certificateImageUrl || imageError) && (
              <div className="mt-3">
                <Alert variant="warning" className="mb-0">
                  <small>
                    Certificate image is not currently available. Please try again later or contact support.
                  </small>
                </Alert>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  });

  // Circular Progress Component
  const CircularProgress = ({ percentage, size = 120, strokeWidth = 15 }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * 2 * Math.PI;
    const offset = circumference - (percentage / 100) * circumference;
    const [animatedPercentage, setAnimatedPercentage] = useState(0);

    useEffect(() => {
      const timer = setTimeout(() => {
        setAnimatedPercentage(percentage);
      }, 200);

      return () => clearTimeout(timer);
    }, [percentage]);

    return (
      <div
        className="position-relative d-flex justify-content-center align-items-center"
        style={{ width: size, height: size }}
      >
        <svg width={size} height={size} className="position-absolute">
          <defs>
            <linearGradient
              id="progressGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#6366f1" />
              <stop offset="100%" stopColor="#8b5cf6" />
            </linearGradient>
          </defs>
          <circle
            className="text-muted"
            stroke="currentColor"
            fill="transparent"
            strokeWidth={strokeWidth}
            r={radius}
            cx={size / 2}
            cy={size / 2}
            opacity={0.2}
          />
          <motion.circle
            className="text-primary"
            stroke="url(#progressGradient)"
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            initial={{ strokeDashoffset: circumference }}
            animate={{ strokeDashoffset: offset }}
            transition={{ duration: 1, ease: "easeOut" }}
            strokeLinecap="round"
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
        </svg>
        <div className="position-relative text-center">
          <motion.h3
            className="mb-0 fw-bold"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            {Math.round(animatedPercentage)}%
          </motion.h3>
          <small className="text-muted">Complete</small>
        </div>
      </div>
    );
  };

  // Custom Video Player Component with restrictions
  // const CustomVideoPlayer = forwardRef(({ videoUrl, onEnd, onProgress, subpartId, token, API_BASE_URL }, ref) => {
  //   const videoRef = useRef(null);
  //   const [isPlaying, setIsPlaying] = useState(false);
  //   const [currentTime, setCurrentTime] = useState(0);
  //   const [duration, setDuration] = useState(0);
  //   const [volume, setVolume] = useState(1);
  //   const [isMuted, setIsMuted] = useState(false);
  //   const [progress, setProgress] = useState(0);
  //   const [isFullscreen, setIsFullscreen] = useState(false);
  //   const [hasReachedEnd, setHasReachedEnd] = useState(false);
  //   const [lastSentTime, setLastSentTime] = useState(0);
  //   const [userInteracted, setUserInteracted] = useState(false);

  //   useImperativeHandle(ref, () => ({
  //     pause: () => {
  //       if (videoRef.current) {
  //         videoRef.current.pause();
  //         setIsPlaying(false);
  //       }
  //     },
  //     getCurrentTime: () => videoRef.current?.currentTime || 0,
  //     getDuration: () => videoRef.current?.duration || 0,
  //   }));

  //   const sendProgress = useCallback(() => {
  //     const video = videoRef.current;
  //     if (!video || !subpartId || !token) return;

  //     if (video.currentTime === 0) {
  //       return;
  //     }

  //     // Only send progress if significant time has passed (to avoid too many requests)
  //     if (Math.abs(video.currentTime - lastSentTime) < 5) {
  //       return;
  //     }

  //     const progressData = {
  //       current_time: video.currentTime,
  //       duration: video.duration,
  //     };

  //     const url = `${API_BASE_URL}/lms/subpart/${subpartId}/progress/`;

  //     console.log("Sending video progress:", progressData);

  //     fetch(url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Authorization": `Bearer ${token}`,
  //       },
  //       body: JSON.stringify(progressData),
  //       keepalive: true,
  //     })
  //       .then(() => setLastSentTime(video.currentTime))
  //       .catch(error => {
  //         console.error("Failed to send video progress:", error);
  //       });
  //   }, [subpartId, token, API_BASE_URL, lastSentTime]);

  //   useEffect(() => {
  //     const video = videoRef.current;
  //     if (!video) return;

  //     let debounceTimeout;

  //     const debouncedSendProgress = () => {
  //       clearTimeout(debounceTimeout);
  //       debounceTimeout = setTimeout(sendProgress, 1000);
  //     };

  //     const handlePause = () => {
  //       if (video.ended) {
  //         return;
  //       }
  //       console.log("Video paused, queueing progress send.");
  //       debouncedSendProgress();
  //     };

  //     const handleVisibilityChange = () => {
  //       if (document.visibilityState === 'hidden') {
  //         console.log("Page hidden, sending progress immediately.");
  //         clearTimeout(debounceTimeout);
  //         sendProgress();
  //       }
  //     };

  //     // Prevent right-click context menu
  //     const preventContextMenu = (e) => e.preventDefault();

  //     // Prevent keyboard shortcuts
  //     const preventShortcuts = (e) => {
  //       if (
  //         e.key === ' ' || // Space bar
  //         e.key === 'k' || // K key (play/pause)
  //         e.key === 'K' ||
  //         e.key === 'f' || // F key (fullscreen)
  //         e.key === 'F' ||
  //         e.key === 'm' || // M key (mute)
  //         e.key === 'M' ||
  //         e.key === 'c' || // C key (captions)
  //         e.key === 'C' ||
  //         e.ctrlKey ||     // Ctrl combinations
  //         e.metaKey        // Cmd combinations (Mac)
  //       ) {
  //         e.preventDefault();
  //       }
  //     };

  //     video.addEventListener("pause", handlePause);
  //     document.addEventListener("visibilitychange", handleVisibilityChange);
  //     video.addEventListener("contextmenu", preventContextMenu);
  //     document.addEventListener("keydown", preventShortcuts);

  //     return () => {
  //       clearTimeout(debounceTimeout);
  //       console.log("Component unmounting, sending final progress.");
  //       sendProgress();
  //       video.removeEventListener("pause", handlePause);
  //       document.removeEventListener("visibilitychange", handleVisibilityChange);
  //       video.removeEventListener("contextmenu", preventContextMenu);
  //       document.removeEventListener("keydown", preventShortcuts);
  //     };
  //   }, [sendProgress]);

  //   useEffect(() => {
  //     const video = videoRef.current;
  //     if (!video) return;

  //     const handleTimeUpdate = () => {
  //       setCurrentTime(video.currentTime);
  //       const progressValue = (video.currentTime / video.duration) * 100;
  //       setProgress(progressValue);
  //       onProgress(progressValue);

  //       // Send progress every 30 seconds or when significant time passes
  //       if (Math.abs(video.currentTime - lastSentTime) >= 30) {
  //         sendProgress();
  //       }
  //     };

  //     const handleLoadedMetadata = () => {
  //       setDuration(video.duration);
  //       setHasReachedEnd(false);

  //       // Disable seeking and controls for restricted viewing
  //       if (video.textTracks) {
  //         for (let i = 0; i < video.textTracks.length; i++) {
  //           video.textTracks[i].mode = 'hidden';
  //         }
  //       }
  //     };

  //     const handleEnded = () => {
  //       setIsPlaying(false);

  //       console.log("Video ended, sending final progress.");
  //       sendProgress();

  //       if (!hasReachedEnd) {
  //         setHasReachedEnd(true);
  //         setTimeout(() => {
  //           onEnd();
  //         }, 100);
  //       }
  //     };

  //     const handlePlay = () => {
  //       setIsPlaying(true);
  //       setUserInteracted(true);
  //     };

  //     const handlePause = () => setIsPlaying(false);

  //     // Prevent seeking by disabling seek functionality
  //     const handleSeeked = () => {
  //       // If user tries to seek forward more than 10 seconds from last sent time, revert
  //       if (userInteracted && video.currentTime - lastSentTime > 10) {
  //         video.currentTime = lastSentTime;
  //         Swal.fire({
  //           title: 'Seeking Restricted',
  //           text: 'Please watch the video sequentially to track your progress properly.',
  //           icon: 'warning',
  //           confirmButtonColor: '#6366f1',
  //           timer: 3000
  //         });
  //       }
  //     };

  //     video.addEventListener("timeupdate", handleTimeUpdate);
  //     video.addEventListener("loadedmetadata", handleLoadedMetadata);
  //     video.addEventListener("ended", handleEnded);
  //     video.addEventListener("play", handlePlay);
  //     video.addEventListener("pause", handlePause);
  //     video.addEventListener("seeked", handleSeeked);

  //     return () => {
  //       video.removeEventListener("timeupdate", handleTimeUpdate);
  //       video.removeEventListener("loadedmetadata", handleLoadedMetadata);
  //       video.removeEventListener("ended", handleEnded);
  //       video.removeEventListener("play", handlePlay);
  //       video.removeEventListener("pause", handlePause);
  //       video.removeEventListener("seeked", handleSeeked);
  //     };
  //   }, [onEnd, onProgress, hasReachedEnd, sendProgress, lastSentTime, userInteracted]);

  //   useEffect(() => {
  //     setHasReachedEnd(false);
  //     setProgress(0);
  //     setCurrentTime(0);
  //     setLastSentTime(0);
  //     setUserInteracted(false);
  //   }, [videoUrl]);

  //   const togglePlay = () => {
  //     const video = videoRef.current;
  //     if (video) {
  //       if (isPlaying) {
  //         video.pause();
  //       } else {
  //         video.play().catch((error) => {
  //           console.error("Video play failed:", error);
  //         });
  //       }
  //     }
  //   };

  //   const toggleMute = () => {
  //     const video = videoRef.current;
  //     if (video) {
  //       video.muted = !video.muted;
  //       setIsMuted(!isMuted);
  //     }
  //   };

  //   const handleVolumeChange = (e) => {
  //     const value = Number.parseFloat(e.target.value);
  //     const video = videoRef.current;
  //     if (video) {
  //       video.volume = value;
  //       setVolume(value);
  //       setIsMuted(value === 0);
  //     }
  //   };

  //   const handleProgressChange = (e) => {
  //     const value = Number.parseFloat(e.target.value);
  //     const video = videoRef.current;
  //     if (video) {
  //       // Only allow minimal seeking (5 seconds buffer)
  //       const targetTime = (value / 100) * video.duration;
  //       const maxAllowedTime = lastSentTime + 5;

  //       if (targetTime <= maxAllowedTime) {
  //         video.currentTime = targetTime;
  //         setProgress(value);
  //       } else {
  //         // Reset to allowed position
  //         video.currentTime = maxAllowedTime;
  //         setProgress((maxAllowedTime / video.duration) * 100);

  //         Swal.fire({
  //           title: 'Seeking Restricted',
  //           text: 'You can only seek within 5 seconds of your current progress.',
  //           icon: 'warning',
  //           confirmButtonColor: '#6366f1',
  //           timer: 3000
  //         });
  //       }
  //     }
  //   };

  //   const skipForward = () => {
  //     const video = videoRef.current;
  //     if (video) {
  //       Swal.fire({
  //         title: "Forward Skipping Disabled",
  //         text: "You cannot skip ahead. Please continue watching the video to proceed.",
  //         icon: "info",
  //         confirmButtonText: "OK",
  //         confirmButtonColor: "#6366f1",
  //       });
  //     }
  //   };


  //   const skipBackward = () => {
  //     const video = videoRef.current;
  //     if (video) {
  //       video.currentTime = Math.max(video.currentTime - 5, 0);
  //     }
  //   };

  //   const toggleFullscreen = () => {
  //     const videoElement = videoRef.current;
  //     if (!videoElement) return;

  //     const container = videoElement.closest(".video-container");
  //     if (!container) return;

  //     if (!document.fullscreenElement) {
  //       container
  //         .requestFullscreen()
  //         .then(() => setIsFullscreen(true))
  //         .catch((err) => {
  //           console.error(
  //             `Error attempting to enable fullscreen: ${err.message}`
  //           );
  //         });
  //     } else {
  //       document.exitFullscreen();
  //       setIsFullscreen(false);
  //     }
  //   };

  //   const formatTime = (seconds) => {
  //     if (isNaN(seconds) || seconds < 0) return "0:00";
  //     const minutes = Math.floor(seconds / 60);
  //     const remainingSeconds = Math.floor(seconds % 60);
  //     return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  //   };

  //   const btnStyle = {
  //     background: "none",
  //     border: "none",
  //     color: "white",
  //     padding: "0",
  //     cursor: "pointer",
  //     display: "flex",
  //     alignItems: "center",
  //     fontSize: "14px",
  //   };

  //   return (
  //     <div
  //       className="video-container"
  //       style={{
  //         backgroundColor: "#000",
  //         width: "100%",
  //         position: "relative",
  //         overflow: "hidden",
  //         aspectRatio: "16 / 9",
  //       }}
  //     >
  //       <video
  //         key={videoUrl}
  //         ref={videoRef}
  //         src={videoUrl}
  //         controlsList="nodownload noplaybackrate nofullscreen"
  //         disablePictureInPicture
  //         playsInline
  //         onContextMenu={(e) => e.preventDefault()}
  //         style={{
  //           width: "100%",
  //           height: "100%",
  //           objectFit: "contain",
  //           display: "block",
  //         }}
  //       />
  //       <div
  //         className="video-controls"
  //         style={{
  //           position: "absolute",
  //           bottom: 0,
  //           left: 0,
  //           right: 0,
  //           backgroundColor: "rgba(0, 0, 0, 0.6)",
  //           padding: "8px 10px",
  //           display: "flex",
  //           flexDirection: "column",
  //           zIndex: 10,
  //         }}
  //       >
  //         <input
  //           type="range"
  //           min="0"
  //           max="100"
  //           step="0.1"
  //           value={progress}
  //           onChange={handleProgressChange}
  //           style={{
  //             width: "100%",
  //             accentColor: "#0d6efd",
  //             cursor: "pointer",
  //             height: "5px",
  //             marginBottom: "6px",
  //           }}
  //         />
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "space-between",
  //             alignItems: "center",
  //             flexWrap: "wrap",
  //             gap: "8px",
  //           }}
  //         >
  //           <div
  //             style={{
  //               display: "flex",
  //               alignItems: "center",
  //               gap: "10px",
  //               flexWrap: "wrap",
  //             }}
  //           >
  //             <button onClick={togglePlay} style={btnStyle}>
  //               {isPlaying ? <BsPauseFill size={24} /> : <BsPlayFill size={24} />}
  //             </button>
  //             <button onClick={skipBackward} style={btnStyle}>
  //               <BsSkipBackward size={20} />
  //             </button>
  //             <button onClick={skipForward} style={btnStyle}>
  //               <BsSkipForward size={20} />
  //             </button>
  //             <button onClick={toggleMute} style={btnStyle}>
  //               {isMuted ? <BsVolumeMute size={20} /> : <BsVolumeUp size={20} />}
  //             </button>
  //             <input
  //               type="range"
  //               min="0"
  //               max="1"
  //               step="0.1"
  //               value={volume}
  //               onChange={handleVolumeChange}
  //               style={{
  //                 width: "60px",
  //                 accentColor: "#fff",
  //                 cursor: "pointer",
  //               }}
  //             />
  //             <span style={{ color: "#fff", fontSize: "0.8rem" }}>
  //               {formatTime(currentTime)} / {formatTime(duration)}
  //             </span>
  //           </div>
  //           <button
  //             onClick={toggleFullscreen}
  //             style={{
  //               position: "absolute",
  //               top: "12px",
  //               right: "12px",
  //               background: "none",
  //               border: "none",
  //               color: "white",
  //               padding: "4px",
  //               cursor: "pointer",
  //               zIndex: 15,
  //             }}
  //           >
  //             <BsFullscreen size={14} />
  //           </button>
  //         </div>
  //       </div>
  //       {!isPlaying && (
  //         <div
  //           style={{
  //             position: "absolute",
  //             top: 0,
  //             left: 0,
  //             right: 0,
  //             bottom: 0,
  //             backgroundColor: "rgba(0,0,0,0.3)",
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             cursor: "default",
  //             zIndex: 5,
  //           }}
  //         >
  //           <div
  //             onClick={togglePlay}
  //             style={{
  //               backgroundColor: "rgba(255,255,255,0.3)",
  //               borderRadius: "50%",
  //               padding: "12px",
  //               cursor: "pointer",
  //             }}
  //           >
  //             <BsPlayFill size={40} color="white" />
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   );
  // });
const CustomVideoPlayer = forwardRef(
  ({ videoUrl, onEnd, onProgress, subpartId, token, API_BASE_URL }, ref) => {
    const videoRef = useRef(null);
    const hideTimer = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [progress, setProgress] = useState(0);
    const [volume, setVolume] = useState(1);
    const [isMuted, setIsMuted] = useState(false);
    const [showControls, setShowControls] = useState(true);

    const [lastSentTime, setLastSentTime] = useState(0);

    /* ---------- IMPERATIVE ---------- */
    useImperativeHandle(ref, () => ({
      pause: () => {
        if (videoRef.current) {
          videoRef.current.pause();
          setIsPlaying(false);
          // Send progress when paused via imperative call
          sendProgress();
        }
      },
      play: () => {
        if (videoRef.current) {
          videoRef.current.play().catch(() => {});
          setIsPlaying(true);
        }
      },
      isPlaying: () => isPlaying,
    }));

    /* ---------- RESET ON VIDEO CHANGE ---------- */
    useEffect(() => {
      const video = videoRef.current;
      if (!video) return;

      video.pause();
      video.currentTime = 0;
      video.load();

      setIsPlaying(false);
      setProgress(0);
      setCurrentTime(0);
      setDuration(0);
      setLastSentTime(0);
    }, [videoUrl]);

    /* ---------- PROGRESS API ---------- */
    const sendProgress = useCallback(() => {
      const video = videoRef.current;
      if (!video || !token || !subpartId) return;

      // Send progress immediately when:
      // 1. Video ends (within last 1 second)
      // 2. User pauses
      // 3. Every 30 seconds during playback
      const shouldSendProgress = 
        video.currentTime >= video.duration - 1 || // End of video
        !video.paused && video.currentTime - lastSentTime >= 30; // Every 30 seconds

      if (!shouldSendProgress) return;

      fetch(`${API_BASE_URL}/lms/subpart/${subpartId}/progress/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          current_time: video.currentTime,
          duration: video.duration,
        }),
        keepalive: true,
      })
        .then(() => setLastSentTime(video.currentTime))
        .catch((err) => {
          console.error("Progress API error:", err);
        });
    }, [token, subpartId, API_BASE_URL, lastSentTime]);

    /* ---------- VIDEO EVENTS (SOURCE OF TRUTH) ---------- */
    useEffect(() => {
      const video = videoRef.current;
      if (!video) return;

      const onPlay = () => {
        setIsPlaying(true);
        // Send progress when user starts playing
        sendProgress();
      };
      
      const onPause = () => {
        setIsPlaying(false);
        // Send progress when user pauses
        sendProgress();
      };

      const onTime = () => {
        if (!video.duration || video.duration <= 0) return;
        
        setCurrentTime(video.currentTime);
        const newProgress = (video.currentTime / video.duration) * 100;
        setProgress(newProgress);
        onProgress?.(newProgress);
        sendProgress();
      };

      const onLoaded = () => {
        setDuration(video.duration);
      };

      const onEnded = () => {
        setIsPlaying(false);
        // Force send progress when video ends
        sendProgress();
        onEnd?.();
      };

      video.addEventListener("play", onPlay);
      video.addEventListener("pause", onPause);
      video.addEventListener("timeupdate", onTime);
      video.addEventListener("loadedmetadata", onLoaded);
      video.addEventListener("ended", onEnded);

      return () => {
        video.removeEventListener("play", onPlay);
        video.removeEventListener("pause", onPause);
        video.removeEventListener("timeupdate", onTime);
        video.removeEventListener("loadedmetadata", onLoaded);
        video.removeEventListener("ended", onEnded);
      };
    }, [sendProgress]);

    /* ---------- FULLSCREEN TRACKING ---------- */
    useEffect(() => {
      const handler = () => {
        setIsFullscreen(Boolean(document.fullscreenElement));
      };

      document.addEventListener("fullscreenchange", handler);
      return () =>
        document.removeEventListener("fullscreenchange", handler);
    }, []);

    /* ---------- CONTROLS ---------- */
    const togglePlay = () => {
      const video = videoRef.current;
      if (!video) return;
      
      if (video.paused) {
        video.play();
      } else {
        video.pause();
        // Also send progress when user manually pauses via button
        sendProgress();
      }
    };

    const toggleMute = () => {
      const video = videoRef.current;
      video.muted = !video.muted;
      setIsMuted(video.muted);
    };

    const handleSeek = (e) => {
      const video = videoRef.current;
      const target = (e.target.value / 100) * video.duration;
      video.currentTime = target;
      // Send progress when user seeks
      sendProgress();
    };

    const rewind = () => {
      const video = videoRef.current;
      if (!video) return;
      video.currentTime = Math.max(video.currentTime - 10, 0);
      // Send progress when rewinding
      sendProgress();
    };

    const forward = () => {
      const video = videoRef.current;
      if (!video) return;
      video.currentTime = Math.min(video.currentTime + 10, duration);
      // Send progress when forwarding
      sendProgress();
    };

    const toggleFullscreen = () => {
      const box = videoRef.current.closest(".video-container");
      document.fullscreenElement
        ? document.exitFullscreen()
        : box.requestFullscreen();
    };

    const showTemporarily = () => {
      setShowControls(true);
      clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => {
        setShowControls(false);
      }, 2500);
    };

    const format = (s) =>
      `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;

    /* ---------- UI ---------- */
    return (
      <div
        className="video-container"
        onMouseMove={showTemporarily}
        style={{
          position: "relative",
          background: "#000",
          aspectRatio: "16 / 9",
        }}
      >
        <video
          key={videoUrl}
          ref={videoRef}
          src={videoUrl}
          playsInline
          disablePictureInPicture
          controls={false}
          onContextMenu={(e) => e.preventDefault()}
          style={{ width: "100%", height: "100%" }}
          // Add preload="metadata" to load only metadata, not the entire video
          preload="metadata"
        />

        {/* Add a play overlay for initial state */}
        {!isPlaying && currentTime === 0 && (
          <div 
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={togglePlay}
          >
            <div style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "rgba(0,0,0,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: 40,
            }}>
              <BsPlayFill />
            </div>
          </div>
        )}

        {showControls && (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              background: "rgba(0,0,0,0.65)",
              padding: "10px",
            }}
          >
            <input
              type="range"
              value={progress}
              onChange={handleSeek}
              style={{ width: "100%" }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 8,
              }}
            >
              <div style={{ display: "flex", gap: 10 }}>
                <button onClick={togglePlay}>
                  {isPlaying ? <BsPauseFill /> : <BsPlayFill />}
                </button>
                <button onClick={rewind}>
                  <BsSkipBackward />
                </button>
                <button onClick={forward}>
                  <BsSkipForward />
                </button>
                <button onClick={toggleMute}>
                  {isMuted ? <BsVolumeMute /> : <BsVolumeUp />}
                </button>
                <span style={{ color: "#fff", fontSize: 12 }}>
                  {format(currentTime)} / {format(duration)}
                </span>
              </div>

              <button onClick={toggleFullscreen}>
                {isFullscreen ? (
                  <BsFullscreenExit />
                ) : (
                  <BsFullscreen />
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
);



  
  // YouTube-style Video Recommendation Component
  const VideoRecommendation = ({
    lesson,
    partIndex,
    isLocked,
    handleLessonSelect,
    isActive,
    isComplete,
    API_BASE_URL,
    duration,
  }) => {
    const [showDescription, setShowDescription] = useState(false);

    return (
      <div className="youtube-recommendation">
        <div
          className={`youtube-video-card ${isLocked ? "locked" : ""} ${isActive ? "active" : ""
            }`}
          onClick={() =>
            !isLocked && handleLessonSelect(partIndex, lesson.subpart_id)
          }
        >
          <div className="video-thumbnail">
            {lesson.video ? (
              <img
                src={`${API_BASE_URL}/lms/media/videos/thumbnail.png`}
                alt="Video Thumbnail"
              />
            ) : (
              <div className="placeholder-thumbnail">
                <BsPlayFill className="play-icon" />
              </div>
            )}
            {duration && (
              <span className="video-duration">
                <SafeRender>{lesson.duration}</SafeRender>
              </span>
            )}
          </div>

          <div className="video-info">
            <h6 className="video-title">
              <SafeRender>{lesson.subpart_title}</SafeRender>
            </h6>

            <div className="video-meta">
              <span className="video-section">Section {partIndex + 1}</span>
              {isComplete && <span className="video-watched">Watched</span>}
            </div>

            <button
              className="description-toggle"
              onClick={(e) => {
                e.stopPropagation();
                setShowDescription(!showDescription);
              }}
            >
              {showDescription ? "Hide description" : "Show description"}
            </button>

            {showDescription && (
              <div className="video-description">
                <SafeRender>
                  {lesson.part_description ||
                    "No description available for this lesson."}
                </SafeRender>
              </div>
            )}
          </div>

          <div className="video-status">
            {isComplete ? (
              <BsCheck2Circle size={20} className="text-success" />
            ) : isLocked ? (
              <BsLockFill size={18} className="text-muted" />
            ) : (
              <BsPlayFill size={20} className="text-primary" />
            )}
          </div>
        </div>
      </div>
    );
  };

  // Quiz Modal Component
  const QuizModal = memo(
    ({
      show,
      onHide,
      quiz,
      quizSubmitted,
      quizResults,
      currentQuestionIndex,
      answers,
      colors,
      handleOptionChange,
      handlePrevQuestion,
      handleNextQuestion,
      handleSubmitQuiz,
      isQuizComplete,
      retakeQuiz,
    }) => (
      <Modal
        show={show}
        onHide={onHide}
        centered
        size="lg"
        backdrop="static"
        className="quiz-modal"
      >
        <Modal.Header
          closeButton
          style={{ background: colors.gradient, color: colors.white }}
        >
          <Modal.Title>
            <div className="d-flex align-items-center">
              <BsBookmark className="me-2" size={24} />
              <SafeRender>{quiz?.title || "Section Quiz"}</SafeRender>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {quiz && quiz.questions && !quizSubmitted ? (
            <>
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold mb-0">
                    Question {currentQuestionIndex + 1} of {quiz.questions.length}
                  </h5>
                  <div className="progress w-50" style={{ height: "8px" }}>
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${((currentQuestionIndex + 1) / quiz.questions.length) *
                          100
                          }%`,
                        background: colors.gradient,
                      }}
                      aria-valuenow={
                        ((currentQuestionIndex + 1) / quiz.questions.length) * 100
                      }
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <div className="question-container">
                  <Card className="border-0 shadow-sm mb-4">
                    <Card.Body>
                      <h5 className="fw-bold">
                        <SafeRender>
                          {quiz.questions[currentQuestionIndex].text}
                        </SafeRender>
                      </h5>
                    </Card.Body>
                  </Card>

                  <div className="options-container">
                    {quiz.questions[currentQuestionIndex].options.map(
                      (option) => (
                        <Card
                          key={option.id}
                          data-option-id={option.id}
                          className={`mb-3 border-0 shadow-sm option-card ${answers[quiz.questions[currentQuestionIndex].id] ===
                            option.id
                            ? "selected"
                            : ""
                            }`}
                          onClick={() =>
                            handleOptionChange(
                              quiz.questions[currentQuestionIndex].id,
                              option.id
                            )
                          }
                          style={{
                            cursor: "pointer",
                            borderLeft:
                              answers[quiz.questions[currentQuestionIndex].id] ===
                                option.id
                                ? `5px solid ${colors.primary}`
                                : "5px solid transparent",
                            transform:
                              answers[quiz.questions[currentQuestionIndex].id] ===
                                option.id
                                ? "translateX(5px)"
                                : "none",
                            transition: "all 0.2s ease",
                          }}
                        >
                          <Card.Body className="d-flex align-items-center">
                            <div
                              className="option-indicator me-3"
                              style={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                border: `2px solid ${answers[
                                  quiz.questions[currentQuestionIndex].id
                                ] === option.id
                                  ? colors.primary
                                  : "#ddd"
                                  }`,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background:
                                  answers[
                                    quiz.questions[currentQuestionIndex].id
                                  ] === option.id
                                    ? colors.primary
                                    : "transparent",
                              }}
                            >
                              {answers[
                                quiz.questions[currentQuestionIndex].id
                              ] === option.id && (
                                  <div
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      borderRadius: "50%",
                                      background: "white",
                                    }}
                                  ></div>
                                )}
                            </div>
                            <div>
                              <SafeRender>{option.text}</SafeRender>
                            </div>
                          </Card.Body>
                        </Card>
                      )
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between mt-4">
                <Button
                  variant="outline-secondary"
                  onClick={handlePrevQuestion}
                  disabled={currentQuestionIndex === 0}
                  className="d-flex align-items-center"
                >
                  <BsArrowLeft className="me-2" /> Previous
                </Button>

                {currentQuestionIndex < quiz.questions.length - 1 ? (
                  <Button
                    variant="primary"
                    onClick={handleNextQuestion}
                    className="d-flex align-items-center"
                    style={{ background: colors.gradient, border: "none" }}
                  >
                    Next <BsArrowRight className="ms-2" />
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    onClick={handleSubmitQuiz}
                    disabled={!isQuizComplete()}
                    className="d-flex align-items-center"
                  >
                    Submit Quiz <BsCheckCircleFill className="ms-2" />
                  </Button>
                )}
              </div>
            </>
          ) : quizSubmitted && quizResults ? (
            <div className="text-center py-4">
              <div className="mb-4">
                <div className="result-icon mb-3">
                  {quizResults.result === "Passed" ? (
                    <div
                      className="success-icon"
                      style={{ color: colors.success, fontSize: "4rem" }}
                    >
                      <BsCheckCircleFill />
                    </div>
                  ) : (
                    <div
                      className="warning-icon"
                      style={{ color: colors.warning, fontSize: "4rem" }}
                    >
                      <BsArrowRepeat />
                    </div>
                  )}
                </div>

                <h4 className="fw-bold">
                  {quizResults.result === "Passed"
                    ? "Quiz Passed!"
                    : "Quiz Needs Improvement"}
                </h4>
                <p className="text-muted">
                  <SafeRender>{quizResults.message}</SafeRender>
                </p>

                <div className="score-display my-4">
                  <CircularProgress percentage={quizResults.score} />
                  <h5 className="mt-3">
                    Your Score: {Math.round(quizResults.score)}%
                  </h5>
                </div>

                {quizResults.result !== "Passed" && (
                  <p className="text-warning">
                    You can retake the quiz to improve your score.
                  </p>
                )}
              </div>

              <div className="d-flex justify-content-center gap-3">
                {quizResults.result !== "Passed" && (
                  <Button
                    variant="warning"
                    onClick={retakeQuiz}
                    className="d-flex align-items-center"
                  >
                    <BsArrowRepeat className="me-2" /> Retake Quiz
                  </Button>
                )}

                <Button
                  variant="primary"
                  onClick={onHide}
                  style={{ background: colors.gradient, border: "none" }}
                >
                  Continue Learning
                </Button>
              </div>
            </div>
          ) : (
            <p className="text-center text-muted">
              No quiz available for this section yet.
            </p>
          )}
        </Modal.Body>
      </Modal>
    )
  );

  // Quiz Offcanvas Component
  const QuizOffcanvas = memo(
    ({
      show,
      onHide,
      quiz,
      quizSubmitted,
      quizResults,
      currentQuestionIndex,
      answers,
      colors,
      handleOptionChange,
      handlePrevQuestion,
      handleNextQuestion,
      handleSubmitQuiz,
      isQuizComplete,
      retakeQuiz,
    }) => (
      <Offcanvas
        show={show}
        onHide={onHide}
        placement="bottom"
        style={{ height: "90vh" }}
      >
        <Offcanvas.Header
          closeButton
          style={{ background: colors.gradient, color: colors.white }}
        >
          <Offcanvas.Title>
            <div className="d-flex align-items-center">
              <BsBookmark className="me-2" size={24} />
              <SafeRender>{quiz?.title || "Section Quiz"}</SafeRender>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {quiz && quiz.questions && !quizSubmitted ? (
            <>
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold mb-0">
                    Question {currentQuestionIndex + 1} of {quiz.questions.length}
                  </h5>
                  <div className="progress w-50" style={{ height: "8px" }}>
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${((currentQuestionIndex + 1) / quiz.questions.length) *
                          100
                          }%`,
                        background: colors.gradient,
                      }}
                      aria-valuenow={
                        ((currentQuestionIndex + 1) / quiz.questions.length) * 100
                      }
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <div className="question-container">
                  <Card className="border-0 shadow-sm mb-4">
                    <Card.Body>
                      <h5 className="fw-bold">
                        <SafeRender>
                          {quiz.questions[currentQuestionIndex].text}
                        </SafeRender>
                      </h5>
                    </Card.Body>
                  </Card>

                  <div className="options-container">
                    {quiz.questions[currentQuestionIndex].options.map(
                      (option) => (
                        <Card
                          key={option.id}
                          data-option-id={option.id}
                          className={`mb-3 border-0 shadow-sm option-card ${answers[quiz.questions[currentQuestionIndex].id] ===
                            option.id
                            ? "selected"
                            : ""
                            }`}
                          onClick={() =>
                            handleOptionChange(
                              quiz.questions[currentQuestionIndex].id,
                              option.id
                            )
                          }
                          style={{
                            cursor: "pointer",
                            borderLeft:
                              answers[quiz.questions[currentQuestionIndex].id] ===
                                option.id
                                ? `5px solid ${colors.primary}`
                                : "5px solid transparent",
                            transform:
                              answers[quiz.questions[currentQuestionIndex].id] ===
                                option.id
                                ? "translateX(5px)"
                                : "none",
                            transition: "all 0.2s ease",
                          }}
                        >
                          <Card.Body className="d-flex align-items-center">
                            <div
                              className="option-indicator me-3"
                              style={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                border: `2px solid ${answers[
                                  quiz.questions[currentQuestionIndex].id
                                ] === option.id
                                  ? colors.primary
                                  : "#ddd"
                                  }`,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background:
                                  answers[
                                    quiz.questions[currentQuestionIndex].id
                                  ] === option.id
                                    ? colors.primary
                                    : "transparent",
                              }}
                            >
                              {answers[
                                quiz.questions[currentQuestionIndex].id
                              ] === option.id && (
                                  <div
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      borderRadius: "50%",
                                      background: "white",
                                    }}
                                  ></div>
                                )}
                            </div>
                            <div>
                              <SafeRender>{option.text}</SafeRender>
                            </div>
                          </Card.Body>
                        </Card>
                      )
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between mt-4">
                <Button
                  variant="outline-secondary"
                  onClick={handlePrevQuestion}
                  disabled={currentQuestionIndex === 0}
                  className="d-flex align-items-center"
                >
                  <BsArrowLeft className="me-2" /> Previous
                </Button>

                {currentQuestionIndex < quiz.questions.length - 1 ? (
                  <Button
                    variant="primary"
                    onClick={handleNextQuestion}
                    className="d-flex align-items-center"
                    style={{ background: colors.gradient, border: "none" }}
                  >
                    Next <BsArrowRight className="ms-2" />
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    onClick={handleSubmitQuiz}
                    disabled={!isQuizComplete()}
                    className="d-flex align-items-center"
                  >
                    Submit Quiz <BsCheckCircleFill className="ms-2" />
                  </Button>
                )}
              </div>
            </>
          ) : quizSubmitted && quizResults ? (
            <div className="text-center py-4">
              <div className="mb-4">
                <div className="result-icon mb-3">
                  {quizResults.result === "Passed" ? (
                    <div
                      className="success-icon"
                      style={{ color: colors.success, fontSize: "4rem" }}
                    >
                      <BsCheckCircleFill />
                    </div>
                  ) : (
                    <div
                      className="warning-icon"
                      style={{ color: colors.warning, fontSize: "4rem" }}
                    >
                      <BsArrowRepeat />
                    </div>
                  )}
                </div>

                <h4 className="fw-bold">
                  {quizResults.result === "Passed"
                    ? "Quiz Passed!"
                    : "Quiz Needs Improvement"}
                </h4>
                <p className="text-muted">
                  <SafeRender>{quizResults.message.text || quizResults.message}</SafeRender>
                </p>

                <div className="score-display my-4">
                  <CircularProgress percentage={quizResults.score} />
                  <h5 className="mt-3">
                    Your Score: {Math.round(quizResults.score)}%
                  </h5>
                </div>

                {quizResults.result !== "Passed" && (
                  <p className="text-warning">
                    You can retake the quiz to improve your score.
                  </p>
                )}
              </div>

              <div className="d-flex justify-content-center gap-3">
                {quizResults.result !== "Passed" && (
                  <Button
                    variant="warning"
                    onClick={retakeQuiz}
                    className="d-flex align-items-center"
                  >
                    <BsArrowRepeat className="me-2" /> Retake Quiz
                  </Button>
                )}

                <Button
                  variant="primary"
                  onClick={onHide}
                  style={{ background: colors.gradient, border: "none" }}
                >
                  Continue Learning
                </Button>
              </div>
            </div>
          ) : (
            <p className="text-center text-muted">
              No quiz available for this section yet.
            </p>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    )
  );

  // Mobile Menu Offcanvas
  const MobileMenuOffcanvas = memo(
    ({
      show,
      onHide,
      course,
      colors,
      activePartIndex,
      togglePart,
      activeLesson,
      isLessonLocked,
      handleLessonSelect,
      bookmarkedLessons,
    }) => (
      <Offcanvas
        show={show}
        onHide={onHide}
        placement="start"
        style={{ maxWidth: "80%" }}
      >
        <Offcanvas.Header
          closeButton
          style={{ background: colors.gradient, color: colors.white }}
        >
          <Offcanvas.Title>Course Structure</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <ListGroup variant="flush" className="course-structure">
            {course?.parts?.map((part, partIndex) => (
              <div key={part.part_id}>
                <ListGroup.Item
                  action
                  className={`fw-bold d-flex justify-content-between align-items-center border-0 ${activePartIndex === partIndex ? "text-primary" : "text-dark"
                    }`}
                  onClick={() => togglePart(partIndex)}
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      activePartIndex === partIndex ? "#f0f4ff" : "#ffffff",
                    padding: "1rem",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div
                      className="me-2 rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "28px",
                        height: "28px",
                        background:
                          activePartIndex === partIndex
                            ? colors.primary
                            : "#e9ecef",
                        color: activePartIndex === partIndex ? "white" : "black",
                      }}
                    >
                      {partIndex + 1}
                    </div>
                    <SafeRender>{part.part_title}</SafeRender>
                  </div>
                  {activePartIndex === partIndex ? (
                    <BsChevronUp />
                  ) : (
                    <BsChevronDown />
                  )}
                </ListGroup.Item>
                <AnimatePresence>
                  {activePartIndex === partIndex && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      {part.subparts?.map((lesson, lessonIndex) => {
                        const locked = isLessonLocked(partIndex, lessonIndex);
                        return (
                          <ListGroup.Item
                            key={lesson.subpart_id}
                            action
                            active={
                              activeLesson?.subpart_id === lesson.subpart_id
                            }
                            className={`border-0 py-3 px-4 ${locked ? "text-muted" : ""
                              }`}
                            onClick={() =>
                              !locked &&
                              handleLessonSelect(partIndex, lesson.subpart_id)
                            }
                            style={{
                              cursor: locked ? "not-allowed" : "pointer",
                              backgroundColor:
                                activeLesson?.subpart_id === lesson.subpart_id
                                  ? colors.primary + "20"
                                  : lesson.is_complete
                                    ? colors.success + "20"
                                    : "white",
                              borderLeft:
                                activeLesson?.subpart_id === lesson.subpart_id
                                  ? `4px solid ${colors.primary}`
                                  : lesson.is_complete
                                    ? `4px solid ${colors.success}`
                                    : "4px solid transparent",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="d-flex align-items-center">
                                <div
                                  className="me-3 rounded-circle d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    background: lesson.is_complete
                                      ? colors.success
                                      : "#e9ecef",
                                    color: lesson.is_complete ? "white" : "black",
                                  }}
                                >
                                  {lesson.is_complete ? (
                                    <BsCheck2Circle size={14} />
                                  ) : locked ? (
                                    <BsLockFill size={12} />
                                  ) : (
                                    lessonIndex + 1
                                  )}
                                </div>
                                <p className="mb-0 fw-medium small">
                                  <SafeRender>{lesson.subpart_title}</SafeRender>
                                </p>
                              </div>
                              {bookmarkedLessons.includes(lesson.subpart_id) && (
                                <BsBookmarkFill className="text-warning" />
                              )}
                            </div>
                          </ListGroup.Item>
                        );
                      })}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </ListGroup>
        </Offcanvas.Body>
      </Offcanvas>
    )
  );

  export default function CourseViewer() {
    const { id } = useParams();
    const [course, setCourse] = useState(null);
    const [activePartIndex, setActivePartIndex] = useState(null);
    const [activeLesson, setActiveLesson] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isInstructor, setInstructor] = useState(false);
    const [isEnrolled, setEnrolled] = useState(false);
    const [quiz, setQuiz] = useState(null);
    const [answers, setAnswers] = useState({});
    const [showQuiz, setShowQuiz] = useState(false);
    const [showCurriculum, setShowCurriculum] = useState(false);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [quizSubmitted, setQuizSubmitted] = useState(false);
    const [quizResults, setQuizResults] = useState(null);
    const [showQuizModal, setShowQuizModal] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [bookmarkedLessons, setBookmarkedLessons] = useState([]);
    const [videoProgress, setVideoProgress] = useState(0);
    const [quizButtonEnabled, setQuizButtonEnabled] = useState(false);
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [canRetakeQuiz, setCanRetakeQuiz] = useState(false);
    // BUG FIX: The state now tracks submitted quiz IDs by the PART ID for better consistency.
    const [submittedQuizzes, setSubmittedQuizzes] = useState(() => {
      const saved = localStorage.getItem(`submittedQuizzes-${id}`);
      return saved ? JSON.parse(saved) : [];
    });
    const [expandedVideoSection, setExpandedVideoSection] = useState({
      upNext: true,
      otherSections: true,
    });
    const [showCertificateModal, setShowCertificateModal] = useState(false);
    const [certificateData, setCertificateData] = useState(null);
    const [certificateImageUrl, setCertificateImageUrl] = useState(null);
    const [userName, setUserName] = useState("Student");
    const [fetchingCertificate, setFetchingCertificate] = useState(false);
    const [viewLoading, setViewLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [showFullContent, setShowFullContent] = useState(false);

    const [quizPassStatus, setQuizPassStatus] = useState(() => {
      const saved = localStorage.getItem(`quizPassStatus-${id}`);
      return saved ? JSON.parse(saved) : {};
    });

    const token = localStorage.getItem("jwttoken");
    const navigate = useNavigate();
    const videoPlayerRef = useRef(null);
    const API_BASE_URL = "https://kaasbackend.vetrinahealthcare.com";

    useEffect(() => {
      localStorage.setItem(`quizPassStatus-${id}`, JSON.stringify(quizPassStatus));
    }, [quizPassStatus, id]);

    // BUG FIX: Added a new useEffect to persist the `submittedQuizzes` state to localStorage.
    useEffect(() => {
      localStorage.setItem(`submittedQuizzes-${id}`, JSON.stringify(submittedQuizzes));
    }, [submittedQuizzes, id]);


    useEffect(() => {
      const disableRightClick = (e) => e.preventDefault();
      const disableInspectKeys = (e) => {
        if (
          e.key === "F12" ||
          (e.ctrlKey && e.shiftKey && e.key === "I") ||
          (e.ctrlKey && e.shiftKey && e.key === "J") ||
          (e.ctrlKey && e.key === "U")
        ) {
          e.preventDefault();
        }
      };

      document.addEventListener("contextmenu", disableRightClick);
      document.addEventListener("keydown", disableInspectKeys);

      return () => {
        document.removeEventListener("contextmenu", disableRightClick);
        document.removeEventListener("keydown", disableInspectKeys);
      };
    }, []);

    const colors = {
      primary: "#6366f1",
      secondary: "#8b5cf6",
      success: "#10b981",
      warning: "#f59e0b",
      danger: "#ef4444",
      info: "#3b82f6",
      light: "#f3f4f6",
      dark: "#1f2937",
      white: "#ffffff",
      gradient: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    };

    // Fetch Certificate Data
    const fetchCertificate = useCallback(async () => {
      if (!id || !course) return;

      try {
        setFetchingCertificate(true);
        const url = `https://kaasbackend.vetrinahealthcare.com/master/certificate-v2/${id}/`;

        console.log("Fetching certificate from:", url);

        const response = await axios.post(
          url,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            responseType: 'blob'
          }
        );

        console.log("Certificate response:", response);
        console.log("Content-Type:", response.headers['content-type']);
        console.log("Blob type:", response.data.type);
        console.log("Blob size:", response.data.size);

        if (response.data && response.data instanceof Blob) {
          const blob = response.data;

          if (blob.type === 'application/pdf') {
            // Handle PDF certificate
            const pdfUrl = URL.createObjectURL(blob);
            setCertificateImageUrl(pdfUrl); // This will be a PDF URL
            setCertificateData({
              type: 'pdf',
              blob: blob,
              url: pdfUrl,
              fileName: `certificate-${course?.title || 'course'}.pdf`
            });
          } else if (blob.type.startsWith('image/')) {
            // Handle image certificate
            const imageUrl = URL.createObjectURL(blob);
            setCertificateImageUrl(imageUrl);
            setCertificateData({
              type: 'image',
              blob: blob,
              url: imageUrl,
              fileName: `certificate-${course?.title || 'course'}.png`
            });
          } else {
            throw new Error(`Unsupported file type: ${blob.type}`);
          }

          setShowCertificateModal(true);

          Swal.fire({
            title: 'Certificate Loaded!',
            text: 'Your course certificate is ready to view and download.',
            icon: 'success',
            confirmButtonColor: colors.primary,
            timer: 2000
          });
        } else {
          throw new Error('Invalid certificate response');
        }
      } catch (error) {
        console.error("Certificate fetch error:", error);

        if (error.response && error.response.status === 404) {
          Swal.fire({
            title: "Certificate Not Available",
            text: "Certificate will be generated after course completion. Please complete all lessons first.",
            icon: "info",
            confirmButtonColor: colors.primary,
          });
        } else if (error.response && error.response.status === 401) {
          Swal.fire({
            title: "Authentication Error",
            text: "Your session has expired. Please log in again.",
            icon: "warning",
            confirmButtonColor: colors.primary,
          });
        } else {
          Swal.fire({
            title: "Certificate Not Ready",
            text: "Unable to load certificate. Please try again later or contact support.",
            icon: "error",
            confirmButtonColor: colors.primary,
          });
        }
        setShowCertificateModal(true);
      } finally {
        setFetchingCertificate(false);
      }
    }, [id, course, token, colors.primary]);

    // Check if course is completed and show certificate button
    const isCourseCompleted = useCallback(() => {
      if (!course?.parts) return false;

      const totalLessons = course.parts.reduce(
        (sum, part) => sum + (part.subparts?.length || 0),
        0
      );

      const completedLessons = course.parts.reduce(
        (sum, part) =>
          sum + (part.subparts?.filter((l) => l.is_complete).length || 0),
        0
      );

      return totalLessons > 0 && completedLessons === totalLessons;
    }, [course]);

    const handleOptionChange = useCallback((questionId, optionId) => {
      setAnswers((prev) => ({
        ...prev,
        [questionId]: optionId,
      }));

      const selectedOption = document.querySelector(
        `.option-card[data-option-id="${optionId}"]`
      );
      if (selectedOption) {
        selectedOption.classList.add("pulse-animation");
        setTimeout(() => {
          selectedOption.classList.remove("pulse-animation");
        }, 500);
      }
    }, []);

    const isQuizComplete = useCallback(() => {
      if (!quiz) return false;
      return quiz.questions.every((q) => answers[q.id]);
    }, [quiz, answers]);

    const retakeQuiz = useCallback(() => {
      // BUG FIX: The check `canRetakeQuiz` is no longer needed here, as the button logic controls this.
      Swal.fire({
        title: "Retake Quiz?",
        text: "Your previous answers will be cleared. Are you ready to try again?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Retake Quiz!",
        cancelButtonText: "Not now",
        confirmButtonColor: colors.primary,
        cancelButtonColor: colors.danger,
      }).then((result) => {
        if (result.isConfirmed) {
          setAnswers({});
          setCurrentQuestionIndex(0);
          setQuizSubmitted(false);
          setQuizResults(null);
          setShowQuizModal(true);
        }
      });
    }, [colors.primary, colors.danger]);

    const fetchQuiz = useCallback(() => {
      if (!course || activePartIndex === null || !activeLesson) return;

      // ENHANCEMENT: The check for already completed quizzes is now handled by the button logic.
      // This allows the `retakeQuiz` function to call this without being blocked.

      setLoading(true);
      Swal.fire({
        title: "Loading Quiz...",
        html: `
          <div class="d-flex justify-content-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <p class="mt-3">Preparing your questions.</p>`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      const url = `${API_BASE_URL}/quiz/quiz-by-coursepart/${activeLesson.subpart_id}/`;
      console.log("Attempting to fetch quiz from:", url);

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setQuiz(response.data);
          setCurrentQuestionIndex(0);
          setAnswers({});
          setQuizSubmitted(false);
          setQuizResults(null);
          setShowQuiz(true);
          setLoading(false);
          Swal.close();
        })
        .catch((err) => {
          console.error("Failed to fetch quiz. Full error:", err.response || err.request || err.message);
          setLoading(false);
          setError("Failed to load quiz. Please try again later.");
          Swal.fire({
            title: "Error",
            text: "Could not load the quiz. Please check your connection and try again.",
            icon: "error",
            confirmButtonText: "OK",
            confirmButtonColor: colors.primary,
          });
        });
    }, [
      activePartIndex,
      course,
      token,
      colors.primary,
      API_BASE_URL,
      activeLesson,
    ]);

    const handleSubmitQuiz = useCallback(async () => {
      if (!quiz || !isQuizComplete()) return;

      try {
        setLoading(true);
        Swal.fire({
          title: "Submitting Quiz",
          html: `
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <p class="mt-3">Evaluating your answers...</p>`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        const formattedAnswers = Object.keys(answers).map((questionId) => ({
          question: Number.parseInt(questionId),
          selected_option: answers[questionId],
        }));

        const payload = {
          quiz: quiz.id,
          answers: formattedAnswers,
        };

        const url = `${API_BASE_URL}/quiz/quiz-submit/`;
        console.log("Attempting to submit quiz to:", url);

        const res = await axios.post(
          url,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log("DEBUG: Quiz results from API:", res.data);

        setQuizSubmitted(true);
        setQuizResults(res.data);
        setLoading(false);

        const { result } = res.data;
        const isPassed = result === "Passed";

        if (course && activePartIndex !== null) {
          const partId = course.parts[activePartIndex].part_id;
          
          // BUG FIX: Always update the pass status, whether true or false.
          setQuizPassStatus(prevStatus => ({
            ...prevStatus,
            [partId]: isPassed,
          }));

          // BUG FIX: Add the partId to the list of submitted quizzes.
          // Using a Set ensures no duplicate IDs are added.
          setSubmittedQuizzes((prev) => [...new Set([...prev, partId])]);
        }

        setCanRetakeQuiz(!isPassed);
        Swal.close();
      } catch (error) {
        console.error("Quiz submission failed. Full error:", error.response || error.request || error.message);
        setLoading(false);
        Swal.fire({
          title: "Submission Failed",
          text: "There was an error submitting your quiz. Please try again.",
          icon: "error",
          confirmButtonText: "Retry",
          confirmButtonColor: colors.primary,
        });
      }
    }, [
      quiz,
      isQuizComplete,
      answers,
      token,
      colors.primary,
      API_BASE_URL,
      activeLesson,
      course,
      activePartIndex,
    ]);

    const isLessonLocked = useCallback(
      (checkPartIndex, checkSubpartIndex) => {
        if (!course || !course.parts?.[checkPartIndex]) return true;
        if (checkPartIndex === 0 && checkSubpartIndex === 0) return false;

        let prevLessonComplete = false;
        if (checkSubpartIndex > 0) {
          prevLessonComplete =
            course.parts[checkPartIndex].subparts?.[checkSubpartIndex - 1]
              ?.is_complete ?? false;
        } else if (checkPartIndex > 0) {
          const prevPart = course.parts[checkPartIndex - 1];
          prevLessonComplete =
            prevPart?.subparts?.every((subpart) => subpart.is_complete) ?? false;
        }
        return !prevLessonComplete;
      },
      [course]
    );

    const handleLessonSelect = useCallback(
      (partIndex, subpartId) => {
        if (!course?.parts?.[partIndex]) return;

        const selectedLesson = course.parts[partIndex].subparts?.find(
          (s) => s.subpart_id === subpartId
        );
        const selectedLessonSubpartIndex = course.parts[
          partIndex
        ].subparts?.findIndex((s) => s.subpart_id === subpartId);

        if (!selectedLesson || selectedLessonSubpartIndex === -1) return;

        if (isLessonLocked(partIndex, selectedLessonSubpartIndex)) {
          Swal.fire({
            title: "Lesson Locked",
            text: "Please complete the previous lesson to unlock this one.",
            icon: "warning",
            confirmButtonText: "Got it!",
            confirmButtonColor: colors.primary,
          });
          return;
        }

        Swal.fire({
          title: "Loading Lesson",
          html: `<p class="mt-3">${selectedLesson.subpart_title}</p>`,
          timer: 800,
          timerProgressBar: true,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        setActiveLesson({
          ...selectedLesson,
          title: selectedLesson.subpart_title,
          content: selectedLesson.part_description || "No description available.",
          video_url: selectedLesson.video || null,
        });

        setActivePartIndex(partIndex);
        setShowQuiz(false);
        setQuiz(null);
        setQuizButtonEnabled(selectedLesson.is_complete);
        setShowMobileMenu(false);
      },
      [course, isLessonLocked, colors.primary]
    );

  const moveToNextLesson = useCallback(() => {
      if (!course || activePartIndex === null || !activeLesson) return;

      if (activeLesson.video_url && !activeLesson.is_complete) {
        Swal.fire({
          title: "Complete Current Lesson",
          text: "Please finish the current lesson's video before proceeding.",
          icon: "info",
          confirmButtonText: "OK",
          confirmButtonColor: colors.primary,
        });
        return;
      }

      const currentPart = course.parts[activePartIndex];
      const currentLessonIndex =
        currentPart.subparts?.findIndex(
          (l) => l.subpart_id === activeLesson.subpart_id
        ) ?? -1;

      if (
        currentLessonIndex !== -1 &&
        currentLessonIndex < (currentPart.subparts?.length || 0) - 1
      ) {
        const nextLesson = currentPart.subparts[currentLessonIndex + 1];
        handleLessonSelect(activePartIndex, nextLesson.subpart_id);
      } else if (activePartIndex < course.parts.length - 1) {
        const nextPart = course.parts[activePartIndex + 1];
        if (nextPart.subparts?.[0]) {
          const nextLesson = nextPart.subparts[0];
          handleLessonSelect(activePartIndex + 1, nextLesson.subpart_id);
        }
      } else {
        Swal.fire({
          title: "Course Completed!",
          text: "Congratulations! You have finished all lessons in this course.",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "View Certificate",
          cancelButtonText: "Continue",
          confirmButtonColor: colors.primary,
          cancelButtonColor: colors.secondary,
        }).then((result) => {
          if (result.isConfirmed) {
            fetchCertificate();
          }
        });
      }
    }, [
      course,
      activePartIndex,
      activeLesson,
      handleLessonSelect,
      colors.primary,
      colors.secondary,
      fetchCertificate,
    ]);

    const moveToPreviousLesson = useCallback(() => {
      if (!course || activePartIndex === null || !activeLesson) return;

      const currentPart = course.parts[activePartIndex];
      const currentLessonIndex =
        currentPart.subparts?.findIndex(
          (l) => l.subpart_id === activeLesson.subpart_id
        ) ?? -1;

      if (currentLessonIndex > 0) {
        const prevLesson = currentPart.subparts[currentLessonIndex - 1];
        handleLessonSelect(activePartIndex, prevLesson.subpart_id);
      } else if (activePartIndex > 0) {
        const prevPart = course.parts[activePartIndex - 1];
        if (prevPart.subparts?.length > 0) {
          const prevLesson = prevPart.subparts[prevPart.subparts.length - 1];
          handleLessonSelect(activePartIndex - 1, prevLesson.subpart_id);
        }
      } else {
        Swal.fire({
          title: "First Lesson",
          text: "You are at the beginning of the course.",
          icon: "info",
          confirmButtonColor: colors.primary,
        });
      }
    }, [
      course,
      activePartIndex,
      activeLesson,
      handleLessonSelect,
      colors.primary,
    ]);

    const handleVideoEnd = useCallback(() => {
      if (!activeLesson || !course || activePartIndex === null) return;
      if (activeLesson.is_complete) return;

      Swal.fire({
        title: "Saving Progress...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const formData = new FormData();
      formData.append("is_complete", true);

      const url = `${API_BASE_URL}/lms/subparts/${activeLesson.subpart_id}/`;
      console.log("Attempting to mark video as complete at:", url);

      axios
        .patch(
          url,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          const updatedCourse = {
            ...course,
            parts: course.parts.map((part, pIdx) => {
              if (pIdx !== activePartIndex) return part;
              return {
                ...part,
                subparts:
                  part.subparts?.map((subpart) =>
                    subpart.subpart_id === activeLesson.subpart_id
                      ? { ...subpart, is_complete: true }
                      : subpart
                  ) || [],
              };
            }),
          };
          setCourse(updatedCourse);
          setActiveLesson((prev) => ({ ...prev, is_complete: true }));
          // ENHANCEMENT: The quiz button is now always enabled once a lesson is complete.
          // The specific text ("Solve", "Retake", "Passed") is handled separately.
          setQuizButtonEnabled(true);

          const currentPart = updatedCourse.parts[activePartIndex];
          const allCompletedInCurrentPart = currentPart.subparts?.every(
            (s) => s.is_complete
          );

          Swal.close();

          if (allCompletedInCurrentPart) {
            Swal.fire({
              title: "Topic Completed!",
              text: "Great work! You've completed all subtopic in this topic.",
              icon: "success",
              showCancelButton: true,
              confirmButtonText: "Take Topic Quiz",
              cancelButtonText: "Next Topic",
              confirmButtonColor: colors.primary,
              cancelButtonColor: colors.secondary,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchQuiz();
                setShowQuizModal(true);
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                setTimeout(() => moveToNextLesson(), 50);

              }
            });
          } else {
            Swal.fire({
              title: "Subpart Completed!",
              text: "You can now take the quiz or move to the next subtopic.",
              icon: "success",
              showCancelButton: true,
              confirmButtonText: "Take Quiz",
              cancelButtonText: "Next Subtopic",
              confirmButtonColor: colors.primary,
              cancelButtonColor: colors.secondary,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchQuiz();
                setShowQuizModal(true);
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                setTimeout(() => moveToNextLesson(), 50);

              }
            });
          }
        })
        .catch((err) => {
          console.error("Failed to update subtopic completion. Full error:", err.response || err.request || err.message);
          Swal.fire({
            title: "Update Error",
            text: "Failed to save your progress. Please check your connection and try again.",
            icon: "error",
            confirmButtonText: "OK",
            confirmButtonColor: colors.primary,
          });
        });
    }, [
      activeLesson,
      activePartIndex,
      course,
      token,
      colors,
      fetchQuiz,
      moveToNextLesson,
      API_BASE_URL,
      submittedQuizzes,
    ]);

    const handleVideoProgress = useCallback(
      (progress) => {
        setVideoProgress(progress);
        if (progress >= 95 && !quizButtonEnabled && !activeLesson?.is_complete) {
          setQuizButtonEnabled(true);
          Swal.fire({
            title: "Quiz Unlocked!",
            text: "You can now take the quiz for this subtopic.",
            icon: "info",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      },
      [quizButtonEnabled, activeLesson]
    );

    const handleNextQuestion = useCallback(() => {
      if (
        !quiz ||
        !quiz.questions ||
        currentQuestionIndex >= quiz.questions.length - 1
      )
        return;

      const questionContainer = document.querySelector(".question-container");
      if (questionContainer) {
        questionContainer.classList.add("slide-out");
        setTimeout(() => {
          setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
          setTimeout(() => {
            questionContainer.classList.remove("slide-out");
            questionContainer.classList.add("slide-in");
            setTimeout(() => {
              questionContainer.classList.remove("slide-in");
            }, 500);
          }, 50);
        }, 300);
      } else {
        setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      }
    }, [quiz, currentQuestionIndex]);

    const handlePrevQuestion = useCallback(() => {
      if (!quiz || !quiz.questions || currentQuestionIndex <= 0) return;

      const questionContainer = document.querySelector(".question-container");
      if (questionContainer) {
        questionContainer.classList.add("slide-out-reverse");
        setTimeout(() => {
          setCurrentQuestionIndex((prevIndex) => prevIndex - 1);
          setTimeout(() => {
            questionContainer.classList.remove("slide-out-reverse");
            questionContainer.classList.add("slide-in-reverse");
            setTimeout(() => {
              questionContainer.classList.remove("slide-in-reverse");
            }, 500);
          }, 50);
        }, 300);
      } else {
        setCurrentQuestionIndex((prevIndex) => prevIndex - 1);
      }
    }, [quiz, currentQuestionIndex]);

    const toggleBookmark = useCallback(
      (lessonId) => {
        const isBookmarked = bookmarkedLessons.includes(lessonId);
        const updatedBookmarks = isBookmarked
          ? bookmarkedLessons.filter((id) => id !== lessonId)
          : [...bookmarkedLessons, lessonId];

        Swal.fire({
          title: isBookmarked ? "Bookmark Removed" : "Bookmark Added!",
          icon: isBookmarked ? "info" : "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });

        setBookmarkedLessons(updatedBookmarks);
        localStorage.setItem(`bookmarks-${id}`, JSON.stringify(updatedBookmarks));
      },
      [bookmarkedLessons, id]
    );

    const togglePart = useCallback(
      (partIndex) => {
        setActivePartIndex((prevIndex) =>
          prevIndex === partIndex ? null : partIndex
        );
      },
      []
    );

    // Pause video when opening certificate or navigating away
    const pauseVideo = useCallback(() => {
      if (videoPlayerRef.current) {
        videoPlayerRef.current.pause();
      }
    }, []);

    // Handle certificate view with video pausing
    const handleViewCertificate = useCallback(async () => {
      pauseVideo(); // Pause video immediately

      // Open a new tab immediately in response to the user's click
      const newTab = window.open('', '_blank');

      try {
        setViewLoading(true);
        if (!newTab) {
          throw new Error('Popup blocked! Please allow popups for this site.');
        }

        const certificateUrl = `https://kaasbackend.vetrinahealthcare.com/master/certificate-v2/${id}/`;

        const response = await fetch(certificateUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || 'Failed to load certificate');
        }

        const blob = await response.blob();
        const pdfUrl = URL.createObjectURL(blob);

        // Load the PDF into the already opened tab
        newTab.location.href = pdfUrl;

        setTimeout(() => URL.revokeObjectURL(pdfUrl), 30000);

      } catch (error) {
        console.error("View certificate failed:", error);
        // If an error occurs, you might want to close the blank tab
        if (newTab) {
          newTab.close();
        }
        Swal.fire({
          title: 'View Failed',
          text: error.message || 'Unable to load certificate. Please try downloading instead.',
          icon: 'error',
          confirmButtonColor: '#6366f1',
        });
      } finally {
        setViewLoading(false);
      }
    }, [id, token, pauseVideo]);

    // Handle certificate download with video pausing
    const handleDownloadCertificate = useCallback(async () => {
      pauseVideo(); // Pause video immediately

      try {
        setDownloadLoading(true);
        const certificateUrl = `https://kaasbackend.vetrinahealthcare.com/master/certificate-v2/${id}/`;

        const response = await fetch(certificateUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || "Certificate not available yet!");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `certificate_${course?.title || id}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        Swal.fire({
          title: 'Success!',
          text: 'Certificate downloaded successfully!',
          icon: 'success',
          confirmButtonColor: '#10b981',
          timer: 2000
        });

      } catch (error) {
        console.error("Download failed:", error);
        Swal.fire({
          title: 'Download Failed',
          text: error.message || 'Something went wrong while downloading the certificate.',
          icon: 'error',
          confirmButtonColor: '#6366f1',
        });
      } finally {
        setDownloadLoading(false);
      }
    }, [id, token, course, pauseVideo]);

    useEffect(() => {
      if (!id) return;
      setLoading(true);
      Swal.fire({
        title: "Loading Course...",
        html: `<p>Please wait while we prepare your learning experience.</p>`,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const url = `${API_BASE_URL}/lms/courses/${id}/`;
      console.log("Attempting to fetch course data from:", url);

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const courseData = response.data;
          setCourse(courseData);
          setInstructor(courseData.display.is_instructor);
          setEnrolled(courseData.display.is_enrolled);
          setError(null);

          let initialLesson = null;
          let initialPartIndex = null;

          if (courseData.parts) {
            for (let pIdx = 0; pIdx < courseData.parts.length; pIdx++) {
              const part = courseData.parts[pIdx];
              if (part.subparts) {
                const firstUncompleted = part.subparts.find(
                  (subpart) => !subpart.is_complete
                );
                if (firstUncompleted) {
                  initialLesson = firstUncompleted;
                  initialPartIndex = pIdx;
                  break;
                }
              }
            }
          }

          if (!initialLesson && courseData.parts?.[0]?.subparts?.[0]) {
            initialLesson = courseData.parts[0].subparts[0];
            initialPartIndex = 0;
          }

          if (initialLesson && initialPartIndex !== null) {
            setActiveLesson({
              ...initialLesson,
              title: initialLesson.subpart_title,
              content:
                initialLesson.part_description || "No description available.",
              video_url: initialLesson.video || null,
            });
            setActivePartIndex(initialPartIndex);
            setQuizButtonEnabled(initialLesson.is_complete);
          }

          setLoading(false);
          Swal.close();
          Swal.fire({
            title: `Welcome to ${courseData.title}!`,
            icon: "success",
            confirmButtonText: "Start Learning",
            confirmButtonColor: colors.primary,
            timer: 2500,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          console.error("Error fetching course data. Full error:", error.response || error.request || error.message);
          setError("Failed to load the course. Please try again later.");
          setLoading(false);
          Swal.fire({
            title: "Error Loading Course",
            text: "We couldn't retrieve the course data. Please check your connection and refresh the page.",
            icon: "error",
            confirmButtonText: "Refresh",
            confirmButtonColor: colors.primary,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        });

      const savedBookmarks = localStorage.getItem(`bookmarks-${id}`);
      if (savedBookmarks) {
        setBookmarkedLessons(JSON.parse(savedBookmarks));
      }
    }, [id, token, colors.primary, API_BASE_URL]);

    const totalLessons =
      course?.parts?.reduce(
        (sum, part) => sum + (part.subparts?.length || 0),
        0
      ) || 0;
    const completedLessons =
      course?.parts?.reduce(
        (sum, part) =>
          sum + (part.subparts?.filter((l) => l.is_complete).length || 0),
        0
      ) || 0;
    const progress = totalLessons ? (completedLessons / totalLessons) * 100 : 0;
    
    const allQuizzesPassed = useCallback(() => {
      if (!course?.parts) return false;
      const partsWithQuizzes = course.parts.filter(
        (part) => part.subparts && part.subparts.length > 0
      );
      if (partsWithQuizzes.length === 0) return true;
      return partsWithQuizzes.every((part) => quizPassStatus[part.part_id] === true);
    }, [course, quizPassStatus]);

    const courseIsFullyCompleted = isCourseCompleted();
    const quizzesAreAllPassed = allQuizzesPassed();
    const canViewCertificate = courseIsFullyCompleted && quizzesAreAllPassed;


    // Get recommendations for YouTube-style display
    let nextLessonsInCurrentPart = [];
    const otherSectionsLessons = [];

    if (course && activePartIndex !== null && activeLesson) {
      const currentPart = course.parts[activePartIndex];
      const currentLessonIndex =
        currentPart.subparts?.findIndex(
          (s) => s.subpart_id === activeLesson.subpart_id
        ) ?? -1;

      if (currentLessonIndex !== -1) {
        nextLessonsInCurrentPart =
          currentPart.subparts?.slice(currentLessonIndex + 1) || [];
      }

      for (let pIdx = activePartIndex + 1; pIdx < course.parts.length; pIdx++) {
        otherSectionsLessons.push(...(course.parts[pIdx].subparts || []));
      }
    }

    if (loading) {
      return (
        <div
          className="text-center py-5"
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          }}
        >
          <div>
            {defaultLoadingAnimationData ? (
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: defaultLoadingAnimationData,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={200}
                width={200}
              />
            ) : (
              <Spinner
                animation="border"
                role="status"
                style={{ color: colors.primary, width: "100px", height: "100px" }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
            <h4 className="mt-3 fw-bold" style={{ color: colors.primary }}>
              Loading Your Course...
            </h4>
            <p className="text-muted">
              Getting everything ready for your learning experience.
            </p>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div
          className="text-center py-5"
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          }}
        >
          <Alert variant="danger" className="text-center py-5 m-4 shadow-lg">
            <h4 className="alert-heading">Oops! Something went wrong.</h4>
            <p>
              <SafeRender>{error}</SafeRender>
            </p>
            <hr />
            <Button
              variant="primary"
              className="mt-3"
              onClick={() => window.location.reload()}
              style={{ background: colors.primary, border: "none" }}
            >
              Retry Loading
            </Button>
          </Alert>
        </div>
      );
    }

    if (!course) {
      return (
        <div
          className="text-center py-5"
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          }}
        >
          <div>
            <h4 className="mb-3">Course not found.</h4>
            <Button
              variant="primary"
              onClick={() => navigate("/courses")}
              style={{ background: colors.primary, border: "none" }}
            >
              Browse Other Courses
            </Button>
          </div>
        </div>
      );
    }
    
    // ENHANCEMENT: Create variables for quiz status to simplify button logic.
    const currentPartId = (course && activePartIndex !== null) ? course.parts[activePartIndex].part_id : null;
    const hasPassedThisQuiz = currentPartId ? quizPassStatus[currentPartId] === true : false;
    const hasAttemptedThisQuiz = currentPartId ? submittedQuizzes.includes(currentPartId) : false;

    return (
      <Container
        fluid
        className="py-4"
        style={{
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          minHeight: "100vh",
        }}
      >
        <style>
          {`
            .option-card.selected {
              box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
            }
            .quiz-modal .modal-content {
              border-radius: 1rem;
              border: none;
              overflow: hidden;
            }
            .video-controls {
              background: linear-gradient(0deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 70%, transparent 100%);
              opacity: 0;
              transition: opacity 0.3s ease;
            }
            .video-container:hover .video-controls {
              opacity: 1;
            }
            .form-range::-webkit-slider-thumb {
              background: #6366f1;
            }
            .form-range::-moz-range-thumb {
              background: #6366f1;
            }
            .form-range::-ms-thumb {
              background: #6366f1;
            }
            .pulse-animation {
              animation: pulse 0.5s;
            }
            @keyframes pulse {
              0% { transform: scale(1); }
              50% { transform: scale(1.05); }
              100% { transform: scale(1); }
            }
            .slide-out { animation: slideOut 0.3s forwards; }
            .slide-in { animation: slideIn 0.3s forwards; }
            .slide-out-reverse { animation: slideOutReverse 0.3s forwards; }
            .slide-in-reverse { animation: slideInReverse 0.3s forwards; }
            @keyframes slideOut {
              0% { transform: translateX(0); opacity: 1; }
              100% { transform: translateX(-20px); opacity: 0; }
            }
            @keyframes slideIn {
              0% { transform: translateX(20px); opacity: 0; }
              100% { transform: translateX(0); opacity: 1; }
            }
            @keyframes slideOutReverse {
              0% { transform: translateX(0); opacity: 1; }
              100% { transform: translateX(20px); opacity: 0; }
            }
            @keyframes slideInReverse {
              0% { transform: translateX(-20px); opacity: 0; }
              100% { transform: translateX(0); opacity: 1; }
            }
            @media (max-width: 991.98px) {
              .mobile-menu-button { display: flex !important; }
              .desktop-course-structure { display: none !important; }
              .course-content-column { order: 1; }
              .sidebar-column { order: 2; }
            }
            /* YouTube-style Video Recommendations */
            .youtube-recommendation { margin-bottom: 12px; }
            .youtube-video-card {
              display: flex;
              align-items: flex-start;
              padding: 12px;
              cursor: pointer;
              border-radius: 8px;
              transition: background-color 0.2s ease, opacity 0.3s ease;
              background: white;
              border: 1px solid #e0e0e0;
            }
            .youtube-video-card:hover:not(.locked) {
              background-color: #f8f9fa;
              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            }
            .youtube-video-card.locked { opacity: 0.6; cursor: not-allowed; }
            .youtube-video-card.active { background-color: #e3f2fd; border-color: #2196f3; }
            .video-thumbnail {
              width: 168px;
              height: 94px;
              background-color: #ddd;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              margin-right: 12px;
              border-radius: 8px;
              overflow: hidden;
              position: relative;
            }
            .video-thumbnail img { width: 100%; height: 100%; object-fit: cover; }
            .placeholder-thumbnail {
              width: 100%;
              height: 100%;
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .play-icon { color: white; font-size: 32px; }
            .video-duration {
              position: absolute;
              bottom: 4px;
              right: 4px;
              background: rgba(0,0,0,0.8);
              color: white;
              padding: 2px 6px;
              border-radius: 4px;
              font-size: 12px;
              font-weight: 500;
            }
            .video-info { flex-grow: 1; min-width: 0; }
            .video-title {
              font-size: 14px;
              font-weight: 600;
              margin-bottom: 4px;
              line-height: 1.3;
              color: #333;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            .video-meta { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
            .video-section {
              font-size: 12px;
              color: #666;
              background: #f0f0f0;
              padding: 2px 6px;
              border-radius: 4px;
            }
            .video-watched {
              font-size: 12px;
              color: #10b981;
              background: #d1fae5;
              padding: 2px 6px;
              border-radius: 4px;
            }
            .description-toggle {
              background: none;
              border: none;
              color: #666;
              font-size: 12px;
              cursor: pointer;
              padding: 0;
              text-decoration: underline;
            }
            .description-toggle:hover { color: #333; }
            .video-description {
              margin-top: 8px;
              font-size: 12px;
              color: #666;
              line-height: 1.4;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            .video-status { margin-left: 12px; flex-shrink: 0; display: flex; align-items: center; }
            .recommendations-section {
              background: white;
              border-radius: 12px;
              overflow: hidden;
              box-shadow: 0 2px 12px rgba(0,0,0,0.08);
            }
            .recommendations-header {
              padding: 16px 20px;
              background: #f8f9fa;
              border-bottom: 1px solid #e9ecef;
              display: flex;
              justify-content: space-between;
              align-items: center;
              cursor: pointer;
              transition: background-color 0.2s ease;
            }
            .recommendations-header:hover { background: #e9ecef; }
            .recommendations-title { font-size: 16px; font-weight: 600; margin: 0; color: #333; }
            .recommendations-count { font-size: 14px; color: #666; margin-left: 8px; }
            .recommendations-content { max-height: 400px; overflow-y: auto; }
            .recommendations-content.collapsed { max-height: 0; overflow: hidden; }
            @media (max-width: 768px) {
              .video-thumbnail { width: 120px; height: 67px; }
              .video-title { font-size: 13px; }
              .youtube-video-card { padding: 10px; }
            }
            /* Certificate Styles */
            .certificate-modal .modal-content {
              border-radius: 1rem;
              border: none;
              overflow: hidden;
            }
            .certificate-preview {
              transition: all 0.3s ease;
            }
            .certificate-preview:hover {
              transform: translateY(-5px);
              box-shadow: 0 25px 80px rgba(99, 102, 241, 0.4) !important;
            }
            .certificate-image {
              max-width: 100%;
              max-height: 600px;
              border-radius: 8px;
              box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
            }
              .lesson-content-truncated {
    display: -webkit-box;
    -webkit-line-clamp: 5; /* Show only 5 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 7.5rem; /* Approx 5 lines * 1.5 line-height */
  }
          `}
        </style>

        <Button
          variant="primary"
          className="mobile-menu-button d-lg-none d-none position-fixed"
          style={{
            top: "60px",
            left: "10px",
            zIndex: 1030,
            background: colors.gradient,
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            border: "none",
          }}
          onClick={() => setShowMobileMenu(true)}
        >
          <i className="fas fa-bars"></i>
        </Button>

        <Row>
          <Col lg={8} className="mb-4 course-content-column">
            <Card className="shadow-lg border-0 rounded-4 overflow-hidden">
              <Card.Body className="p-0">
                {activeLesson ? (
                  <>
                    <div className="position-relative">
                      {activeLesson.video_url ? (
                        <CustomVideoPlayer
                          ref={videoPlayerRef}
                          videoUrl={activeLesson.video_url}
                          onEnd={handleVideoEnd}
                          onProgress={handleVideoProgress}
                          subpartId={activeLesson.subpart_id}
                          token={token}
                          API_BASE_URL={API_BASE_URL}
                        />
                      ) : (
                        <div
                          className="text-center py-5 bg-dark text-white"
                          style={{
                            aspectRatio: "16 / 9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p className="mb-0">
                            No video available for this lesson.
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="p-4">
                      <motion.div
                        className="d-flex justify-content-between align-items-center mb-3"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                      >
                        <h4 className="fw-bold mb-0">
                          <SafeRender>{activeLesson.title}</SafeRender>
                        </h4>
                        <Button
                          variant="link"
                          className="p-0 text-decoration-none"
                          onClick={() => toggleBookmark(activeLesson.subpart_id)}
                        >
                          {bookmarkedLessons.includes(activeLesson.subpart_id) ? (
                            <BsBookmarkFill size={20} className="text-warning" />
                          ) : (
                            <BsBookmark size={20} />
                          )}
                        </Button>
                      </motion.div>


                      <motion.div
                        className="mb-4"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                      >
                        <div
                          className={`text-muted lesson-content ${!showFullContent ? 'lesson-content-truncated' : ''}`}
                          style={{
                            lineHeight: '1.6',
                            fontSize: '1rem',
                            whiteSpace: 'pre-line',
                          }}
                        >
                          <SafeRender>{activeLesson.content}</SafeRender>
                        </div>

                        {activeLesson.content && (
                          (() => {
                            const wordCount = activeLesson.content.split(/\s+/).length;
                            const charCount = activeLesson.content.length;
                            const needsTruncation = wordCount > 100 || charCount > 500;

                            if (needsTruncation) {
                              return (
                                <Button
                                  variant="link"
                                  onClick={() => setShowFullContent(!showFullContent)}
                                  className="p-0 mt-2 text-decoration-none d-flex align-items-center"
                                  style={{
                                    fontSize: '0.875rem',
                                    fontWeight: '600',
                                    color: colors.primary,
                                  }}
                                >
                                  {showFullContent ? (
                                    <>
                                      <BsChevronUp className="me-1" size={12} />
                                      Show Less
                                    </>
                                  ) : (
                                    <>
                                      <BsChevronDown className="me-1" size={12} />
                                      Show More
                                    </>
                                  )}
                                  <small className="text-muted ms-2">
                                    ({wordCount} words)
                                  </small>
                                </Button>
                              );
                            }
                            return null;
                          })()
                        )}
                      </motion.div>

                      <motion.div
                        className="d-flex justify-content-between mt-4"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                      >
                        <Button
                          variant="outline-secondary"
                          onClick={moveToPreviousLesson}
                          disabled={
                            activePartIndex === 0 &&
                            course.parts[0]?.subparts?.[0]?.subpart_id ===
                            activeLesson.subpart_id
                          }
                          className="d-flex align-items-center"
                        >
                          <BsArrowLeft className="me-2" /> Previous Lesson
                        </Button>

                        <div className="d-flex gap-2">
                          {/* ENHANCEMENT: New button logic for Solve/Retake/Passed states */}
                          {hasPassedThisQuiz ? (
                            <Button
                              variant="success"
                              disabled
                              style={{ cursor: 'default' }}
                            >
                              Quiz Passed
                            </Button>
                          ) : (
                            <Button
                              variant="primary"
                              onClick={() => {
                                pauseVideo();
                                // Use retakeQuiz if attempted, otherwise fetch a new one
                                if (hasAttemptedThisQuiz) {
                                  retakeQuiz();
                                } else {
                                  fetchQuiz();
                                  setShowQuizModal(true);
                                }
                              }}
                              disabled={!quizButtonEnabled}
                              style={{
                                background: quizButtonEnabled ? colors.gradient : "#ccc",
                                border: "none",
                                transition: "all 0.3s ease",
                              }}
                            >
                              {hasAttemptedThisQuiz ? "Retake Quiz" : "Solve Quiz"}
                            </Button>
                          )}

                          <Button
                            variant="success"
                            onClick={moveToNextLesson}
                            disabled={activeLesson && activeLesson.video_url && !activeLesson.is_complete}
                            className="d-flex align-items-center"
                          >
                            Next Lesson <BsArrowRight className="ms-2" />
                          </Button>
                        </div>
                      </motion.div>
                    </div>
                  </>
                ) : (
                  <div className="text-center p-5">
                    <h3 className="fw-bold">
                      <SafeRender>{course.title}</SafeRender>
                    </h3>
                    <p className="text-muted">
                      <SafeRender>{course.description}</SafeRender>
                    </p>
                    <p className="text-muted">
                      Select a lesson from the course structure to start learning.
                    </p>
                  </div>
                )}
              </Card.Body>
            </Card>

            {(nextLessonsInCurrentPart.length > 0 ||
              otherSectionsLessons.length > 0) && (
                <div className="mt-4">
                  {nextLessonsInCurrentPart.length > 0 && (
                    <div className="recommendations-section mb-4">
                      <div
                        className="recommendations-header"
                        onClick={() =>
                          setExpandedVideoSection((prev) => ({
                            ...prev,
                            upNext: !prev.upNext,
                          }))
                        }
                      >
                        <div className="d-flex align-items-center">
                          <h5 className="recommendations-title">Up Next</h5>
                          <span className="recommendations-count">
                            ({nextLessonsInCurrentPart.length})
                          </span>
                        </div>
                        {expandedVideoSection.upNext ? (
                          <BsChevronUp />
                        ) : (
                          <BsChevronDown />
                        )}
                      </div>
                      <AnimatePresence>
                        {expandedVideoSection.upNext && (
                          <motion.div
                            className="recommendations-content"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                          >
                            {nextLessonsInCurrentPart.map((lesson) => {
                              const subpartActualIndex =
                                course.parts[activePartIndex].subparts?.findIndex(
                                  (s) => s.subpart_id === lesson.subpart_id
                                ) ?? -1;
                              const locked = isLessonLocked(
                                activePartIndex,
                                subpartActualIndex
                              );

                              return (
                                <VideoRecommendation
                                  key={lesson.subpart_id}
                                  lesson={lesson}
                                  partIndex={activePartIndex}
                                  isLocked={locked}
                                  handleLessonSelect={handleLessonSelect}
                                  isActive={
                                    activeLesson?.subpart_id === lesson.subpart_id
                                  }
                                  isComplete={lesson.is_complete}
                                  API_BASE_URL={API_BASE_URL}
                                  duration={lesson.duration}
                                />
                              );
                            })}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  )}

                  {otherSectionsLessons.length > 0 && (
                    <div className="recommendations-section">
                      <div
                        className="recommendations-header"
                        onClick={() =>
                          setExpandedVideoSection((prev) => ({
                            ...prev,
                            otherSections: !prev.otherSections,
                          }))
                        }
                      >
                        <div className="d-flex align-items-center">
                          <h5 className="recommendations-title">
                            More from this Course
                          </h5>
                          <span className="recommendations-count">
                            ({otherSectionsLessons.length})
                          </span>
                        </div>
                        {expandedVideoSection.otherSections ? (
                          <BsChevronUp />
                        ) : (
                          <BsChevronDown />
                        )}
                      </div>
                      <AnimatePresence>
                        {expandedVideoSection.otherSections && (
                          <motion.div
                            className="recommendations-content"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                          >
                            {otherSectionsLessons.slice(0, 10).map((lesson) => {
                              let partActualIndex = -1;
                              let subpartActualIndex = -1;

                              for (
                                let pIdx = activePartIndex + 1;
                                pIdx < course.parts.length;
                                pIdx++
                              ) {
                                const foundIndex = course.parts[
                                  pIdx
                                ].subparts?.findIndex(
                                  (s) => s.subpart_id === lesson.subpart_id
                                );
                                if (foundIndex !== -1 && foundIndex !== undefined) {
                                  partActualIndex = pIdx;
                                  subpartActualIndex = foundIndex;
                                  break;
                                }
                              }

                              const locked = isLessonLocked(
                                partActualIndex,
                                subpartActualIndex
                              );

                              return (
                                <VideoRecommendation
                                  key={lesson.subpart_id}
                                  lesson={lesson}
                                  partIndex={partActualIndex}
                                  isLocked={locked}
                                  handleLessonSelect={handleLessonSelect}
                                  isActive={
                                    activeLesson?.subpart_id === lesson.subpart_id
                                  }
                                  isComplete={lesson.is_complete}
                                  API_BASE_URL={API_BASE_URL}
                                  duration="8:45"
                                />
                              );
                            })}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  )}
                </div>
              )}

            <Card className="shadow-sm border-0 rounded-4 mt-4 p-3">
              <Card.Body>
                <motion.div
                  className="d-flex justify-content-between align-items-center mb-3"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <h5 className="fw-bold mb-0">Your Progress</h5>
                  <div className="d-flex align-items-center gap-2">
                    <Badge
                      bg="primary"
                      pill
                      style={{ background: colors.gradient }}
                    >
                      {completedLessons} of {totalLessons} lessons completed
                    </Badge>
                  </div>
                </motion.div>

                <motion.div
                  className="d-flex align-items-center flex-wrap"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <CircularProgress percentage={progress} />
                  <div className="ms-4 flex-grow-1">
                    <ProgressBar
                      now={progress}
                      className="mb-2"
                      style={{ height: "10px", background: "#e9ecef" }}
                      variant="primary"
                    />
                    <div className="d-flex justify-content-between text-muted small">
                      <span>Course Progress</span>
                      <span>{Math.round(progress)}% Complete</span>
                    </div>

                    {progress >= 25 && (
                      <div className="mt-3">
                        <h6 className="fw-bold">Achievement Unlocked!</h6>
                        <div className="d-flex align-items-center">
                          <div
                            className="me-2 rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              width: "30px",
                              height: "30px",
                              background: colors.gradient,
                              color: "white",
                            }}
                          >
                            <BsCheckCircleFill />
                          </div>
                          <span>
                            {progress >= 75
                              ? "Course Expert"
                              : progress >= 50
                                ? "Halfway Hero"
                                : "Getting Started"}
                          </span>
                        </div>
                      </div>
                    )}

                    {courseIsFullyCompleted && (
                      <motion.div
                        className="mt-3 p-3 rounded"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        style={{
                          background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
                          border: '2px solid #10b981'
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <BsCheckCircleFill className="text-success me-2" size={24} />
                          <div>
                            <h6 className="fw-bold mb-1 text-success">Course Completed! 🎉</h6>
                            <p className="mb-2 text-success small">
                              {canViewCertificate
                                  ? "Congratulations! You've completed all lessons and passed all quizzes. You can now get your certificate."
                                  : "You've finished all lessons! Please make sure you have passed all topic quizzes to unlock your certificate."
                              }
                            </p>

                            <div className="mt-2">
                              <button
                                onClick={handleViewCertificate}
                                disabled={!canViewCertificate || viewLoading || downloadLoading}
                                className="btn btn-outline-success btn-sm me-2"
                                title={!canViewCertificate ? "Complete all lessons and pass all quizzes to view" : "View Certificate"}
                              >
                                {viewLoading ? (
                                  <>
                                    <Spinner animation="border" size="sm" className="me-1" />
                                    Loading...
                                  </>
                                ) : (
                                  'View Certificate'
                                )}
                              </button>

                              <button
                                onClick={handleDownloadCertificate}
                                disabled={!canViewCertificate || viewLoading || downloadLoading}
                                className="btn btn-success btn-sm"
                                title={!canViewCertificate ? "Complete all lessons and pass all quizzes to download" : "Download Certificate"}
                              >
                                {downloadLoading ? (
                                  <>
                                    <Spinner animation="border" size="sm" className="me-1" />
                                    Downloading...
                                  </>
                                ) : (
                                  'Download Certificate'
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </div>
                </motion.div>
              </Card.Body>
            </Card>
          </Col>
<Col lg={4} className="sidebar-column">
  {/* ================= COURSE STRUCTURE ================= */}
  <Card className="shadow-lg border-0 rounded-4 overflow-hidden desktop-course-structure">
    <Card.Header
      className="border-0 d-flex justify-content-between align-items-center py-3"
      style={{ background: colors.gradient, color: colors.white }}
    >
      <h5 className="fw-bold mb-0">Course Structure</h5>

      {isInstructor && (
        <BsPlusCircle
          size={24}
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate(`/addcourseinfo/${id}?view=curriculum`)
          }
        />
      )}
    </Card.Header>

    <ListGroup
      variant="flush"
      className="course-structure"
      style={{ maxHeight: "600px", overflowY: "auto" }}
    >
      {course.parts?.map((part, partIndex) => {
        // Sort subparts by order number (null orders come last)
        const sortedSubparts = [...(part.subparts || [])].sort((a, b) => {
          // Handle null values - treat null as Number.MAX_SAFE_INTEGER so they appear last
          const orderA = a.order === null || a.order === undefined ? Number.MAX_SAFE_INTEGER : a.order;
          const orderB = b.order === null || b.order === undefined ? Number.MAX_SAFE_INTEGER : b.order;
          
          return orderA - orderB;
        });

        return (
          <div key={part.part_id}>
            {/* ================= PART HEADER ================= */}
            <ListGroup.Item
              action
              className={`fw-bold d-flex justify-content-between align-items-center border-0 ${
                activePartIndex === partIndex
                  ? "text-primary"
                  : "text-dark"
              }`}
              onClick={() => togglePart(partIndex)}
              style={{
                cursor: "pointer",
                backgroundColor:
                  activePartIndex === partIndex
                    ? "#f0f4ff"
                    : "#ffffff",
                padding: "1rem",
              }}
            >
              <div className="d-flex align-items-center">
                <div
                  className="me-2 rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: "28px",
                    height: "28px",
                    background:
                      activePartIndex === partIndex
                        ? colors.primary
                        : "#e9ecef",
                    color:
                      activePartIndex === partIndex
                        ? "white"
                        : "black",
                  }}
                >
                  {partIndex + 1}
                </div>
                <SafeRender>{part.part_title}</SafeRender>
              </div>

              {activePartIndex === partIndex ? (
                <BsChevronUp />
              ) : (
                <BsChevronDown />
              )}
            </ListGroup.Item>

            {/* ================= SUBPARTS ================= */}
            <AnimatePresence>
              {activePartIndex === partIndex && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  {sortedSubparts.map((lesson, lessonIndex) => {
                    const locked = isLessonLocked(
                      partIndex,
                      lessonIndex
                    );

                    return (
                      <ListGroup.Item
                        key={lesson.subpart_id}
                        action
                        active={
                          activeLesson?.subpart_id ===
                          lesson.subpart_id
                        }
                        className={`border-0 py-3 px-4 ${
                          locked ? "text-muted" : ""
                        }`}
                        onClick={() =>
                          !locked &&
                          handleLessonSelect(
                            partIndex,
                            lesson.subpart_id
                          )
                        }
                        style={{
                          cursor: locked
                            ? "not-allowed"
                            : "pointer",
                          backgroundColor:
                            activeLesson?.subpart_id ===
                            lesson.subpart_id
                              ? colors.primary + "20"
                              : lesson.is_complete
                              ? colors.success + "20"
                              : "white",
                          color:
                            activeLesson?.subpart_id ===
                            lesson.subpart_id
                              ? colors.primary
                              : "inherit",
                          borderLeft:
                            activeLesson?.subpart_id ===
                            lesson.subpart_id
                              ? `4px solid ${colors.primary}`
                              : lesson.is_complete
                              ? `4px solid ${colors.success}`
                              : "4px solid transparent",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          {/* -------- LEFT -------- */}
                          <div className="d-flex align-items-center">
                            <div
                              className="me-3 rounded-circle d-flex align-items-center justify-content-center"
                              style={{
                                width: "24px",
                                height: "24px",
                                background: lesson.is_complete
                                  ? colors.success
                                  : "#e9ecef",
                                color: lesson.is_complete
                                  ? "white"
                                  : "black",
                              }}
                            >
                              {lesson.is_complete ? (
                                <BsCheck2Circle size={14} />
                              ) : locked ? (
                                <BsLockFill size={12} />
                              ) : (
                                // Show actual order number instead of lessonIndex + 1
                                lesson.order || lessonIndex + 1
                              )}
                            </div>

                            <p className="mb-0 fw-medium small">
                              <SafeRender>
                                {lesson.subpart_title}
                              </SafeRender>
                            </p>
                          </div>

                          {/* -------- RIGHT (QUIZ + BOOKMARK) -------- */}
                          <div className="d-flex align-items-center gap-2">
                            {lesson.is_complete && (
                              lesson.quiz_completed ? (
                                <span
                                  className="d-flex align-items-center gap-1 text-success small"
                                  title="Quiz completed"
                                >
                                  <BsCheckCircleFill />
                                  Quiz
                                </span>
                              ) : (
                                <span
                                  className="d-flex align-items-center gap-1 text-warning small"
                                  title="Quiz pending"
                                >
                                  <BsClipboardX />
                                  Quiz
                                </span>
                              )
                            )}

                            {bookmarkedLessons.includes(
                              lesson.subpart_id
                            ) && (
                              <BsBookmarkFill className="text-warning" />
                            )}
                          </div>
                        </div>
                      </ListGroup.Item>
                    );
                  })}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </ListGroup>
  </Card>

  {/* ================= COURSE COMPLETED ================= */}
  {courseIsFullyCompleted && (
    <Card className="shadow-lg border-0 rounded-4 overflow-hidden mt-4">
      <Card.Header
        className="border-0 text-center py-3"
        style={{ background: colors.gradient, color: colors.white }}
      >
        <h5 className="fw-bold mb-0">
          <BsCheckCircleFill className="me-2" />
          Course Completed
        </h5>
      </Card.Header>

      <Card.Body className="text-center p-4">
        <div className="mb-3">
          <BsCheckCircleFill
            size={48}
            className="text-success"
          />
        </div>

        <h6 className="fw-bold text-success mb-2">
          Congratulations! 🎉
        </h6>

        <p className="text-muted mb-3">
          {canViewCertificate
            ? "You have successfully completed this course. Get your certificate now!"
            : "You've finished all lessons. Pass all topic quizzes to unlock your certificate."}
        </p>

        <div className="d-grid gap-2">
          <Button
            variant="outline-primary"
            onClick={handleViewCertificate}
            disabled={
              !canViewCertificate ||
              viewLoading ||
              downloadLoading
            }
          >
            {viewLoading ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Loading...
              </>
            ) : (
              "View Certificate"
            )}
          </Button>

          <Button
            variant="primary"
            onClick={handleDownloadCertificate}
            disabled={
              !canViewCertificate ||
              viewLoading ||
              downloadLoading
            }
            style={{
              background: colors.gradient,
              border: "none",
            }}
          >
            {downloadLoading ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Downloading...
              </>
            ) : (
              "Download Certificate"
            )}
          </Button>
        </div>

        {!quizzesAreAllPassed && (
          <Alert variant="warning" className="mt-3 small">
            Your certificate is locked until all topic quizzes
            are passed.
          </Alert>
        )}
      </Card.Body>
    </Card>
  )}
</Col>

        </Row>

        <QuizModal
          show={showQuizModal}
          onHide={() => setShowQuizModal(false)}
          quiz={quiz}
          quizSubmitted={quizSubmitted}
          quizResults={quizResults}
          currentQuestionIndex={currentQuestionIndex}
          answers={answers}
          colors={colors}
          handleOptionChange={handleOptionChange}
          handlePrevQuestion={handlePrevQuestion}
          handleNextQuestion={handleNextQuestion}
          handleSubmitQuiz={handleSubmitQuiz}
          isQuizComplete={isQuizComplete}
          retakeQuiz={retakeQuiz}
        />
        <QuizOffcanvas
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          quiz={quiz}
          quizSubmitted={quizSubmitted}
          quizResults={quizResults}
          currentQuestionIndex={currentQuestionIndex}
          answers={answers}
          colors={colors}
          handleOptionChange={handleOptionChange}
          handlePrevQuestion={handlePrevQuestion}
          handleNextQuestion={handleNextQuestion}
          handleSubmitQuiz={handleSubmitQuiz}
          isQuizComplete={isQuizComplete}
          retakeQuiz={retakeQuiz}
        />
        <MobileMenuOffcanvas
          show={showMobileMenu}
          onHide={() => setShowMobileMenu(false)}
          course={course}
          colors={colors}
          activePartIndex={activePartIndex}
          togglePart={togglePart}
          activeLesson={activeLesson}
          isLessonLocked={isLessonLocked}
          handleLessonSelect={handleLessonSelect}
          bookmarkedLessons={bookmarkedLessons}
        />

        {/* Certificate Modal */}
        <CertificateModal
          show={showCertificateModal}
          onHide={() => setShowCertificateModal(false)}
          certificateData={certificateData}
          course={course}
          userName={userName}
          certificateImageUrl={certificateImageUrl}
        />
      </Container>
    );
  }